(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees100@get');
                }
            }
        });

        // Api
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'angular-oauth2',
//                'ngMask',
//                'datatables'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorio', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {


      // State
        $stateProvider.state('app.relatorio', {
            url: '/relatorio',
            views: {
                'content@app': {
                    templateUrl: 'app/main/relatorio/views/dashboard-relatorio.html',
                    controller: 'RelatorioController as vm'
                }
            },
            bodyClass: 'relatorio'
        });

        $stateProvider.state('app.relatorio-associado', {
          url: '/relatorio-associados',
          views: {
              'content@app': {
                  templateUrl: 'app/main/relatorio/views/relatorio-associados.html',
                  controller: 'RelatorioController as vm'
              }
          },
          bodyClass: 'relatorio'
      });



        $stateProvider.state('app.relatorio.associado-por-nome', {
            url: '/adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/relatorio/views/relatorio-por-nome.html',
                    controller: 'RelatorioController as vm'
                }
            },
            bodyClass: 'relatorio'
        });

        $stateProvider.state('app.relatorio.relatorio-ativos-inativos', {
            url: '/relatorio-ativos-inativos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/relatorio/views/relatorio-ativos-inativos.html',
                    controller: 'RelatorioController as vm'
                }
            },
            bodyClass: 'relatorio'
        });

        $stateProvider.state('app.relatorio.associado-por-matricula', {
            url: '/relatorio.associado-por-matricula',
            views: {
                'content@app': {
                    templateUrl: 'app/main/relatorio/views/relatorio-por-matricula.html',
                    controller: 'RelatorioController as vm'
                }
            },
            bodyClass: 'relatorio'
        });


        $stateProvider.state('app.relatorio.associado-por-nascimento', {
            url: '/relatorio.associado-por-nascimento',
            views: {
                'content@app': {
                    templateUrl: 'app/main/relatorio/views/relatorio-por-nascimento.html',
                    controller: 'RelatorioController as vm'
                }
            },
            bodyClass: 'relatorio'
        });

        $stateProvider.state('app.relatorio.associado-somente-ativos', {
            url: '/relatorio.associado-ativos',
            views: {
                'content@app': {
                    templateUrl: 'app/main/relatorio/views/relatorio-ativos.html',
                    controller: 'RelatorioController as vm'
                }
            },
            bodyClass: 'relatorio'
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/relatorio');



    }

})();

(function () {
    'use strict';

    angular
        .module('app.relatorio')
        .controller('RelatorioController', RelatorioController);

    /** @ngInject */
    function RelatorioController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, $element, $http,$window) {
        var vm = this;
        vm.titulo = "Relatórios";
        $scope.localLoading = false;
        vm.campos = {};
        vm.camposSelecionados = {};
        vm.camposFileiraUm = {};
        vm.camposFileiraDois = {};
        vm.convenios = {};
        vm.pesquisa = {};
        vm.ordencaoSelecionada = {campo:"nome_associado", tipo:"asc"};
        vm.ordenacao = {};
        vm.tipoOrtenacao = {};
        vm.conveniosSelecionados = {};
        /**
 * Preenche as informacoes da tela
 */
        vm.init = function(){
          vm.preencherCombos();
          vm.tipoOrtenacao = {
            "asc":"Ascendente",
            "desc":"Descendente"
          };
          vm.ordenacao = [
            {
              campo:"matricula_asspen",
              label:"Matrícula Asspen"
            },
            {
              campo:"matricula_funcional",
              label:"Matrícula Funcional"
            },

            {
              campo:"dt_filiacao",
              label:"Data da Filiação"
            },

            {
              campo:"dt_nascimento",
              label:"Data de Nascimento"
            },

            {
              campo:"nome_associado",
              label:"Nome do Associado"
            }
          ];

          vm.camposSelecionados = {
            "matricula_funcional":false,
            "matricula_asspen":false,
            "nome_associado":false,
            "email":false,
            "cpf":false,
            "dt_filiacao":false,
            "dt_nascimento":false,
            "status":false,
            "cargo":false,
            "rg":false,
            "orgao_expeditor":false,
            "estado_civil":false,
            "no_mae":false,
            "no_pai":false,
            "dt_nascimento_mae":false,
            "dt_nascimento_pai":false,
            "conjuge_servidor":false,
            "no_conjuge":false,
            "dt_nascimento_conjuge":false,
            "telefone":false,
            "endereco":false,
            "no_guerra":false,
            "sexo":false,
            "dt_expedicao":false,
            "lotacao":false
          };

          vm.camposFileiraUm = {
            "matricula_funcional":{
              valor:true,
              label:'Matrícula Funcional'
            },
            "matricula_asspen":{
              valor:true,
              label:'Matrícula ASSPEN'
            },
            "nome_associado":{
              valor:true,
              label:'Nome do Associado'
            },
            "email":{
              valor:true,
              label:'Email'
            },
            "cpf":{
              valor:true,
              label:'CPF'
            },
            "dt_filiacao":{
              valor:true,
              label:'Data de Filiação'
            },
            "dt_nascimento":{
              valor:true,
              label:'Data de Nascimento'
            },
            "status":{
              label:'Status',
              valor:true
            },
            "cargo":{
              label:'Cargo',
              valor:true
            },
            "rg":{
              label:'RG',
              valor:true
            },
            "dt_nascimento_mae":{
              label:'Dt. Nascimento Mãe',
              valor:true
            },
            "orgao_expeditor":{
              label:'Órgão Expeditor',
              valor:true
            },
            "estado_civil":{
              label:'Estado Civil',
              valor:true
            },

            "dt_nascimento_pai":{
              label:'Data de Nascimento do Pai',
              valor:true
            }
          }
          vm.camposFileiraDois = {
            "conjuge_servidor":{
              label:'Cônjuge Servidor',
              valor:true
            },
            "no_conjuge":{
              label:'Nome do Cônjuge',
              valor:true
            },
            "dt_nascimento_conjuge":{
              label:'Data do Nascimento Cônjuge',
              valor:true
            },
            "telefone":{
              label:'Telefone',
              valor:true
            },
            "endereco":{
              label:'Endereço',
              valor:true
            },
            "no_guerra":{
              label:'Nome de Guerra',
              valor:true
            },
            "lotacao":{
              label:'Lotação',
              valor:true
            },
            "no_mae":{
              label:'Nome da Mãe',
              valor:true
            },
            "no_pai":{
              label:'Nome do Pai',
              valor:true
            },

            "dt_nascimento_pai":{
              label:'Dt. Nascimento Pai',
              valor:true
            },
            "sexo":{
              label:'Sexo',
              valor:true
            },
            "dt_expedicao":{
              label:'Dt. Expedicao',
              valor:true
            }
          }
        }

        vm.emtirRelatorio = function(){
          var payload = {
            'filtros':vm.pesquisa,
            'campos':vm.camposSelecionados,
            'ordem':vm.ordencaoSelecionada,
            'convenios': vm.conveniosSelecionados
          }

          $scope.localLoading = true;
          $http({
            url: api.baseUrl + 'associado/gerar-relatorio-associado',
            method: "POST",
            data: payload
        })
        .then(function (result) {
              if (result.data.excel) {
                  var documento = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + result.data.excel;
                  $window.open(documento, '_blank');
                  $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Relatório gerado com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
              }
              $scope.localLoading = false;
          }, function (err) {

            var mensagemErro = "Não foi possível emitir o relatório";
            $scope.localLoading = false;
            $mdToast.show(
              {
                  template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                  '<span class="md-toast-content md-red-400-bg">' +
                  mensagemErro +
                  '</span>' +
                  '</md-toast>',
                  hideDelay: 3000,
                  position: 'top right'
              }
          );

          $scope.localLoading = false;
              console.log(err);
          });



          console.log('-----------------------');
          console.log(payload);
          console.log('-----------------------');

        }

        vm.limparFiltro = function(){
          vm.pesquisa = {};
          vm.conveniosSelecionados = {};
          vm.ordencaoSelecionada = {campo:"nome_associado", tipo:"asc"};
          vm.camposSelecionados = {

            "matricula_funcional":false,
            "matricula_asspen":false,
            "nome_associado":false,
            "email":false,
            "cpf":false,
            "dt_filiacao":false,
            "dt_nascimento":false,
            "status":false,
            "cargo":false,
            "rg":false,
            "orgao_expeditor":false,
            "estado_civil":false,
            "no_mae":false,
            "no_pai":false,
            "dt_nascimento_mae":false,
            "dt_nascimento_pai":false,
            "conjuge_servidor":false,
            "no_conjuge":false,
            "dt_nascimento_conjuge":false,
            "telefone":false,
            "endereco":false,
            "no_guerra":false,
            "sexo":false,
            "dt_expedicao":false,
            "lotacao":false
          };
        }

        vm.preencherCombos = function () {
          $scope.localLoading = true;

          api.orgaoExpeditor.get({}, function (response) {
              vm.orgaoExpeditor = response._embedded.orgao_expeditor;
          }, function (responseError) {
              console.log(responseError.data.detail);
          });


          api.estado.get({}, function (response) {
              vm.estados = response._embedded.uf;
          }, function (responseError) {
              console.log(responseError.data.detail);
          });


          api.cargoAssociado.get({}, function (response) {
              vm.cargoAssociado = response._embedded.cargo_associado;
              $scope.localLoading = false;
          }, function (responseError) {
              console.log(responseError.data.detail);
              $scope.localLoading = false;
          });

          api.lotacaoAssociado.get({}, function (response) {
              vm.lotacaoAssociado = response._embedded.lotacao_associado;
          }, function (responseError) {
              console.log(responseError.data.detail);
          });


          api.convenio.get({}, function (response) {
              vm.convenios = response._embedded.convenio;
              console.log(vm.convenios);
          }, function (responseError) {
              console.log(responseError.data.detail);
          });

          api.convenio.get({}, function (response) {
            vm.convenios = response._embedded.convenio;
            console.log(vm.convenios);
        }, function (responseError) {
            console.log(responseError.data.detail);
        });


      };


        vm.redirecionar = function (tipoRelatiorio) {
            switch (tipoRelatiorio) {
                case 'associado-por-nome':
                    $state.go('app.relatorio.associado-por-nome')
                    break;
                case 'associado-por-data':
                    $state.go('app.relatorio.associado-por-nascimento')
                    break;
                case 'associado-por-matricula':
                    $state.go('app.relatorio.associado-por-matricula')
                    break;
                case 'associado-por-ativos':
                    $state.go('app.relatorio.relatorio-ativos-inativos')
                    break;
                case 'associado-somente-ativos':
                    $state.go('app.relatorio.associado-somente-ativos')
                    break;
            }
        };


        vm.getRelatorioOrdenandoPorNome = function () {
            var payload = {};
            $scope.localLoading = true;
            $http.get(api.baseUrl + 'associado/gerar-relatorio-ordenado-por-nome', payload, {
                transformRequest: angular.identity,
            }).then(function (result) {
                if (result.data.pdf) {
                    var documento = 'data:application/pdf;base64,' + result.data.pdf;
                    $scope.dataPdf = documento;
                }
                $scope.localLoading = false;
            }, function (err) {
                console.log(err);
            });
        };

        vm.getRelatorioOrdenandoNascimento = function () {
            var payload = {};
            $scope.localLoading = true;
            $http.get(api.baseUrl + 'associado/gerar-relatorio-ordenado-por-nascimento', payload, {
                transformRequest: angular.identity,
            }).then(function (result) {
                if (result.data.pdf) {
                    var documento = 'data:application/pdf;base64,' + result.data.pdf;
                    $scope.dataPdf = documento;
                }
                $scope.localLoading = false;
            }, function (err) {
                console.log(err);
            });
        };


        vm.getRelatorioOrdenandoAtivosInativos = function () {
            var payload = {};
            $scope.localLoading = true;
            $http.get(api.baseUrl + 'associado/gerar-relatorio-ordenado-por-ativos-inativos', payload, {
                transformRequest: angular.identity,
            }).then(function (result) {
                if (result.data.pdf) {
                    var documento = 'data:application/pdf;base64,' + result.data.pdf;
                    $scope.dataPdf = documento;
                }
                $scope.localLoading = false;
            }, function (err) {
                console.log(err);
            });
        };

        vm.getRelatorioOrdenandoPorMatricula = function () {
            var payload = {};
            $scope.localLoading = true;
            $http.get(api.baseUrl + 'associado/gerar-relatorio-ordenado-por-matricula', payload, {
                transformRequest: angular.identity,
            }).then(function (result) {
                if (result.data.pdf) {
                    var documento = 'data:application/pdf;base64,' + result.data.pdf;
                    $scope.dataPdf = documento;
                }
                $scope.localLoading = false;
            }, function (err) {
                console.log(err);
            });
        };

        vm.getRelatorioOrdenandoAtivos = function () {
            var payload = {};
            $scope.localLoading = true;
            $http.get(api.baseUrl + 'associado/gerar-relatorio-ativos-ordenado-por-nome', payload, {
                transformRequest: angular.identity,
            }).then(function (result) {
                if (result.data.pdf) {
                    var documento = 'data:application/pdf;base64,' + result.data.pdf;
                    $scope.dataPdf = documento;
                }
                $scope.localLoading = false;
            }, function (err) {
                console.log(err);
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pessoa', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pessoa', {
            url: '/pessoa',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pessoa/views/pessoa.html',
                    controller: 'PessoaController as vm'
                }
            },
            bodyClass: 'pessoa'
        });


        $stateProvider.state('app.pessoa.add', {
            url: '/adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pessoa/views/cadastrar.html',
                    controller: 'PessoaController as vm'
                }
            },
            bodyClass: 'pessoa'
        });

        $stateProvider.state('app.pessoa.edit', {
            url: '/editar/:idPessoaFisica',
            views: {
                'content@app': {
                    templateUrl: 'app/main/pessoa/views/cadastrar.html',
                    controller: 'PessoaController as vm'
                }
            },
            bodyClass: 'pessoa'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pessoa');




    }

})();
(function () {
    'use strict';

    angular
        .module('app.pessoa')
        .controller('PessoaController', PessoaController);

    /** @ngInject */
    function PessoaController(api, $scope, $stateParams, $state, $mdToast, $mdDialog,$element, $http) {
        var vm = this;
        vm.titulo = "Cadastrar Usuário";
        $scope.localLoading = false;
        /*
         Lista as pessoas cadastradas ativas e inavitas
         */
        vm.listar = function () {
            $scope.localLoading = true;
            vm.preencherDataTable();
            api.pessoa.get({"tpFuncionarioAsspen": true}, function (response) {
                vm.pessoas = response._embedded.pessoa;
                $element.parent().find(".dataTables_empty").remove();
                $scope.localLoading = false;
            }, function (responseError) {
                console.log(responseError.data.detail);
                $scope.localLoading = false;
            });
        };

        vm.obterDados = function () {
            if ($stateParams.idPessoaFisica) {
                $scope.verFoto($stateParams.idPessoaFisica);
                api.pessoa.get({"idPessoaFisica": $stateParams.idPessoaFisica}, function (response) {
                    vm.pessoa = response._embedded.pessoa[0]._embedded[0];
                    vm.pessoa.cargo = vm.pessoa._embedded.cargo.idCargo;
                    vm.pessoa.username = response._embedded.pessoa[0].username;
                    vm.pessoa.perfil = response._embedded.pessoa[0].idPerfil;
                    delete vm.pessoa._embedded;
                }, function (responseError) {
                    console.log(responseError.data.detail);
                });
            }
        }

        vm.init = function () {
            vm.preencherCombos();
        };

        vm.preencherDataTable = function () {
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple_numbers',
                autoWidth: true,
                responsive: true,
                bFilter: true,
                bLengthChange: true,
                "language": {
                    "lengthMenu": "Mostra  _MENU_ registros por página",
                    "zeroRecords": "Não há registros",
                    "info": "Página _PAGE_ de _PAGES_",
                    "infoEmpty": "Não há registros",
                    "infoFiltered": "(filtered from _MAX_ total records)",
                    'search': "Buscar",
                    'searchPlaceholder': "Buscar",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                        "sFirst": "Primeiro",
                        "sLast": "Último"
                    },
                }
            };
        }

        vm.preencherCombos = function () {
            api.cargo.get({}, function (response) {
                vm.cargos = response._embedded.cargo;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });

            api.perfil.get({}, function (response) {
                vm.perfis = response._embedded.perfil;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        };

        vm.cadastrar = function () {
            var perfilUsuario = [vm.pessoa.perfil];
            vm.pessoa.perfilUsuario = perfilUsuario;
            $scope.localLoading = true;

            if ($stateParams.idPessoaFisica) {
                if(!vm.pessoa.inAtivo){
                    vm.pessoa.inAtivo = 0;
                }
                api.pessoa.update({idPessoa: $stateParams.idPessoaFisica, tpFuncionarioAsspen: null,idPessoaFisica:null }, vm.pessoa, function (response) {
                    $scope.localLoading = false;
                    vm.uploadFoto($stateParams.idPessoaFisica);
                }, function (responseError) {
                    var mensagemErro = "Não foi possível Salvar o Usuário, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }

                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );

                    $scope.localLoading = false;
                    console.log(responseError.data.detail);
                });
            } else {
                api.pessoa.save(vm.pessoa, function (response) {
                    vm.uploadFoto(response.idPessoaFisica);
                }, function (responseError) {
                    var mensagemErro = "Não foi possível Salvar o Usuário, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }

                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                    console.log(responseError.data.detail);
                });
            }


        }

        vm.desativarOuAtivar = function (pessoa) {
            var dados = {
                inAtivo: 0
            }
            var msg = "Desativado";
            if (vm.inAtivo[pessoa.idPessoaFisica]) {
                dados.inAtivo = true;
                var msg = "Ativado";
            }

            api.pessoa.delete({idPessoa: pessoa.idPessoaFisica}, dados, function (response) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg"> ' + pessoa.noPessoa + ' ' + msg + ' com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                // console.log(response);
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        }


        vm.validarUsuarioDuplicado = function (username) {
            vm.usuarioDuplicado = false;
            if (username) {
                api.pessoa.get({"username": username}, function (response) {
                    console.log(response._embedded.pessoa.length);
                    console.log($stateParams.idPessoaFisica);
                    if (response._embedded.pessoa.length > 0 && !$stateParams.idPessoaFisica) {
                        vm.usuarioDuplicado = true;
                    }
                    else if (response._embedded.pessoa.length > 0 && $stateParams.idPessoaFisica != response._embedded.pessoa._embedded[0].idPessoaFisica) {
                        vm.usuarioDuplicado = true;
                    }
                    // vm.pessoas = response._embedded.pessoa;
                    console.log(response);
                }, function (responseError) {
                    console.log(responseError.data.detail);
                });
            }
        }

        vm.uploadFoto = function (idPessoaFisica) {
            console.log(idPessoaFisica+'----upload');
            //adicionando form ada para envio do arquivo de forma que a api consiga entender
            console.log(vm.foto.noArquivo[0]);
            console.log(idPessoaFisica);
            console.log(idPessoaFisica+'----upload');
            if (vm.foto.noArquivo[0] != undefined && idPessoaFisica != undefined) {
                var fd = new FormData();
                fd.append('arquivo', vm.foto.noArquivo[0].lfFile);
                fd.append('idPessoaFisica',idPessoaFisica);
                fd.append('isAssociado',false);
                vm.postarFoto(fd);
                $state.go('app.pessoa');

            }else{
                $state.go('app.pessoa');
            }

        }

        vm.postarFoto = function (dadosPost) {
            $scope.localLoading = true;
            //adiciona um novo cardapio
            $http.post(api.baseUrl + 'associado/arquivo', dadosPost, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            }).then(function (result) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Usuário Salvo com Sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                $scope.localLoading = false;
                $state.go('app.pessoa');
            }, function (err) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        'Houve um erro ao fazer upload da foto' +
                        '</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );

                $scope.loadingScreen = false;
                console.log(err);
            });
        }

        $scope.verFoto = function (idPessoaFisica) {
            $http({
                url: api.baseUrl + 'associado/arquivo/' + idPessoaFisica,
                method: "GET",
                params: {}
            }).then(function successCallback(response) {
		if(response.data.file){
                	vm.fotoAvatar = "data:" + response.data.contentType + ";base64," + response.data.file;
		}
            }, function errorCallback(response) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Desculpe, houve um erro ao carregar a foto, Contate os Administradores!')
                        .position(pinTo)
                        .hideDelay(3000)
                );
            });

        }
    }
})();

(function () {
    "use strict";

    angular.module("app.pagamento", ["datatables"]).config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider,
                    msApiProvider,
                    msNavigationServiceProvider) {
        // State

        $stateProvider.state("app.pagamento", {
            url: "/pagamento",
            views: {
                "content@app": {
                    templateUrl: "app/main/pagamento/views/listar.html",
                    controller: "PagamentoController as vm"
                }
            },
            bodyClass: "pagamento"
        });

        $stateProvider.state("app.pagamento.add", {
            url: "/adicionar",
            views: {
                "content@app": {
                    templateUrl: "app/main/pagamento/views/cadastrar.html",
                    controller: "PagamentoController as vm"
                }
            },
            bodyClass: "pagamento"
        });

        $stateProvider.state("app.boleto", {
            url: "/boleto/:idBoleto",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/pagamento/views/boleto/listar.html",
                    controller: "BoletoController as vm"
                }
            },
            bodyClass: "pagamento"
        });


        $stateProvider.state("app.pagamento.view", {
            url: "/visualizar/:idPagamento",
            views: {
                "content@app": {
                    templateUrl: "app/main/pagamento/views/visualizar.html",
                    controller: "PagamentoController as vm"
                }
            },
            bodyClass: "pagamento"
        });

        $stateProvider.state("app.pagamento.relatorio", {
            url: "/relatorio/:idPagamento",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/pagamento/views/relatorio-pagamentos.html",
                    controller: "PagamentoController as vm"
                }
            },
            bodyClass: "relatorio"
        });



        // Translation
        $translatePartialLoaderProvider.addPart("app/main/pagamento");
    }
})();

(function () {
    "use strict";

    angular
        .module("app.pagamento")
        .controller("PagamentoController", PagamentoController);

    /** @ngInject */
    function PagamentoController(api,
                                 $scope,
                                 $stateParams,
                                 $state,
                                 $mdToast,
                                 $timeout,
                                 $mdDialog,
                                 DTOptionsBuilder,
                                 DTColumnBuilder,
                                 $http,
                                 $element) {
        var vm = this;
        vm.titulo = "Cadastrar Pagamento";
        $scope.localLoading = false;
        vm.pesquisa = {};
        vm.resultado = {};
        vm.dtOptions = {};
        vm.mesesBoletos = [];


        vm.dtOptionsPendencia = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: "simple_numbers",
            autoWidth: true,
            responsive: true,
            bFilter: false,
            bLengthChange: true,
            // source:  DTOptionsBuilder.fromSource(vm.resultadoDetalhesPendencias),
            language: {
                lengthMenu: "Mostra  _MENU_ registros por página",
                zeroRecords: "Não há registros",
                info: "Página _PAGE_ de _PAGES_",
                infoEmpty: "Não há registros",
                infoFiltered: "(filtered from _MAX_ total records)",
                search: "Buscar",
                searchPlaceholder: "Buscar",
                oPaginate: {
                    sNext: "Próximo",
                    sPrevious: "Anterior",
                    sFirst: "Primeiro",
                    sLast: "Último"
                }
            }
        };
        vm.dtOptionsSucesso = {};

        vm.initListar = function () {
            vm.pesquisar();
            vm.preencherDataTable();
        };

        vm.idArquvivo = null;

        vm.pesquisar = function () {
            vm.pesquisa.pageSize = -1;
            api.arquivoPagamento.get(vm.pesquisa, function (response) {
                vm.resultadoArquivos = response._embedded.arquivo_pagamento;
                $element.parent().find(".dataTables_empty").remove();
                vm.preencherDataTable();
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        }


        vm.initVisualizar = function () {
            vm.pesquisarDetalhesPendencias();
            vm.pesquisarDetalhesSucesso();

        }



        vm.tratarMes = function (nuMes) {
            var strMes;
            switch (nuMes) {
                case 1:
                    strMes = 'Janeiro';
                    break;
                case 2:
                    strMes = 'Fevereiro';
                    break;
                case 3:
                    strMes = 'Março';
                    break;
                case 4:
                    strMes = 'Abril';
                    break;
                case 5:
                    strMes = 'Maio';
                    break;
                case 6:
                    strMes = 'Junho';
                    break;
                case 7:
                    strMes = 'Julho';
                    break;
                case 8:
                    strMes = 'Agosto';
                    break;
                case 9:
                    strMes = 'Setembro';
                    break;
                case 10:
                    strMes = 'Outubro';
                    break;
                case 11:
                    strMes = 'Novembro';
                    break;
                case 12:
                    strMes = 'Dezembro';
                    break;
                default:
                    strMes = 'Sem mês especificado';
            }
            return strMes
        }

        vm.formatarData = function (data) {
            return moment(data).format('DD/MM/YYYY')
        }

        vm.visualizar = function (arquivo) {
            console.log(arquivo);
        }


        vm.mascararMatricula = function (valor) {
            var matricula = valor;
            matricula = matricula.replace("-", "");
            matricula = matricula.replace(".", "");
            matricula = matricula.replace(".", "");
            matricula = matricula.padStart(8, "0");

            var mascara = "-";
            var position = 7;
            var output = [matricula.slice(0, position), mascara, matricula.slice(position)].join('');

            mascara = '.';
            position = 4;
            output = [output.slice(0, position), mascara, output.slice(position)].join('');

            position = 1;
            output = [output.slice(0, position), mascara, output.slice(position)].join('');

            vm.associado.dsMatriculaFuncional = output;
        }


        vm.preencherDataTableSucesso = function () {
            vm.dtOptionsSucesso = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: "simple_numbers",
                autoWidth: true,
                responsive: true,
                bFilter: false,
                bLengthChange: true,
                processing: true,
                source: vm.resultadoDetalhesSucesso,
                language: {
                    lengthMenu: "Mostra  _MENU_ registros por página",
                    zeroRecords: "Não há registros",
                    info: "Página _PAGE_ de _PAGES_",
                    infoEmpty: "Não há registros",
                    infoFiltered: "(filtered from _MAX_ total records)",
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    oPaginate: {
                        sNext: "Próximo",
                        sPrevious: "Anterior",
                        sFirst: "Primeiro",
                        sLast: "Último"
                    }
                }
            };
        };

        vm.preencherDataTablePendencia = function () {
            vm.dtOptionsPendencia = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: "simple_numbers",
                autoWidth: true,
                responsive: true,
                bFilter: false,
                bLengthChange: true,
                // source:  DTOptionsBuilder.fromSource(vm.resultadoDetalhesPendencias),
                language: {
                    lengthMenu: "Mostra  _MENU_ registros por página",
                    zeroRecords: "Não há registros",
                    info: "Página _PAGE_ de _PAGES_",
                    infoEmpty: "Não há registros",
                    infoFiltered: "(filtered from _MAX_ total records)",
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    oPaginate: {
                        sNext: "Próximo",
                        sPrevious: "Anterior",
                        sFirst: "Primeiro",
                        sLast: "Último"
                    }
                }
            };
        };

        vm.preencherDataTable = function () {
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: "simple_numbers",
                autoWidth: true,
                responsive: true,
                bFilter: false,
                bLengthChange: true,
                source: DTOptionsBuilder.fromSource(vm.resultadoArquivos),
                language: {
                    lengthMenu: "Mostra  _MENU_ registros por página",
                    zeroRecords: "Não há registros",
                    info: "Página _PAGE_ de _PAGES_",
                    infoEmpty: "Não há registros",
                    infoFiltered: "(filtered from _MAX_ total records)",
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    oPaginate: {
                        sNext: "Próximo",
                        sPrevious: "Anterior",
                        sFirst: "Primeiro",
                        sLast: "Último"
                    }
                }
            };
        };

        vm.voltarLista = function () {
            $state.go("app.pagamento");
        };

        vm.cadastrar = function () {
            //Fazendo upload do arquivo de pagamento
            var fd = new FormData();
            $scope.localLoading = true;
            fd.append("arquivo", vm.pagamento.noArquivo[0].lfFile);
            vm.postarPagamento(fd);
        };

        vm.postarPagamento = function (dadosPost) {
            // $scope.loadingScreen = true;
            //adiciona um novo cardapio
            $http
                .post(api.baseUrl + "associado/arquivo-pagamento", dadosPost, {
                    transformRequest: angular.identity,
                    headers: {"Content-Type": undefined}
                })
                .then(
                    function (result) {
                        console.log("-------Resultado upload");
                        console.log(result);
                        console.log("-------");
                        $mdToast.show({
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Arquivo de pagamento salvo com sucesso</span>' +
                            "</md-toast>",
                            hideDelay: 3000,
                            position: "top right"
                        });
                        $scope.localLoading = false;
                        $state.go("app.pagamento");
                    },
                    function (err) {
                        $scope.localLoading = false;
                        console.log(err);
                        if (err.status == 406) {
                            $mdToast.show({
                                template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                                '<span class="md-toast-content md-red-400-bg">' +
                                err.data.detail +
                                "</span>" +
                                "</md-toast>",
                                hideDelay: 3000,
                                position: "top right"
                            });
                            $scope.loadingScreen = false;
                        } else {
                            $mdToast.show({
                                template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                                '<span class="md-toast-content md-red-400-bg">' +
                                "Houve um erro ao processar o pagamento" +
                                "</span>" +
                                "</md-toast>",
                                hideDelay: 3000,
                                position: "top right"
                            });
                            $scope.loadingScreen = false;
                        }
                    }
                );
        };

        vm.preencherCombosBoleto = function () {
            var mesDezoito = 6;
            var anoBase = 2018;
            var data = new Date();
            var anoAtual = data.getFullYear();

            for (var ano = anoBase; ano <= anoAtual; ano++) {
                var mes = 0;
                var mesBase = 1;
                if (ano === 2018) {
                    mesBase = mesDezoito;
                }

                for (mes = mesBase; mes <= 12; mes++) {

                    vm.mesesBoletos.push({
                        'label': mes + "/" + ano,
                        'valor': mes + "/" + ano
                    });
                    var now = new Date();
                    var atual = (now.getMonth() + 1) + "/" + now.getFullYear();
                    if (atual == mes + "/" + ano) {
                        break;
                    }
                }
            }
        };

        vm.getRelatorioPagamento = function () {
            var payload = {};
            $scope.localLoading = true;
            $http.get(api.baseUrl + 'associado/gerar-relatorio-pagamento?idArquivoRelatorio=' + $stateParams.idPagamento, payload, {
                transformRequest: angular.identity,
            }).then(function (result) {
                if (result.data.pdf) {
                    var documento = 'data:application/pdf;base64,' + result.data.pdf;
                    $scope.dataPdf = documento;
                }
                $scope.localLoading = false;
            }, function (err) {
                console.log(err);
            });
        };

        /**
         * ===========================================================
         * TUDO RELACIONADO A PESQIOSA DE BOLETO Pendencia
         * ===========================================================
         */

        vm.pesquisaBoletoPendente = {};
        vm.ordenacaoPesquisaPendente = 'pessoaFisica.noPessoa-ASC';
        vm.itensPorPaginaBoleto = 10;
        vm.resultadoDetalhesPendencias = {};
        vm.pesquisaBoletoPentende = 0;
        vm.paginaBoletoPendente = 1;


        vm.initBoleto = function () {
            var now = new Date();
            vm.pesquisa.mesBoleto = (now.getMonth() + 1) + "/" + now.getFullYear();
        };


        vm.mudarPageSizePendencia = function () {
            vm.paginaBoletoPendente = 1;
            vm.pesquisarDetalhesPendencias();

        };

        vm.pesquisarDetalhesPendencias = function (page) {
            $scope.localLoading = true;
            vm.pesquisaBoletoPendente.pageSize = vm.itensPorPagina;
            vm.pesquisaBoletoPendente.idArquivoPagamento = $stateParams.idPagamento;
            vm.pesquisaBoletoPendente.page = 1;
            vm.pesquisaBoletoPendente.order = vm.ordenacaoPesquisaPendente;
            vm.pesquisaBoletoPendente.isBoleto = 0;
            vm.pesquisaBoletoPendente.pageSize = vm.itensPorPaginaBoleto;
            vm.pesquisaBoletoPendente.status = 0;
            if (page) {
                vm.pesquisaBoletoPendente.page = page;
            }

            api.detalheArquivoPagamento.get(vm.pesquisaBoletoPendente, function (response) {
                vm.resultadoDetalhesPendencias = response;
                $scope.localLoading = false;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        };

        vm.adicionaPaginaPrendenciaBoleto = function (valor) {
            var totalPagina = vm.resultadoDetalhesPendencias.page_count;
            if ((vm.paginaBoletoPendente <= totalPagina) && vm.paginaBoletoPendente >= 1) {
                vm.paginaBoletoPendente = vm.paginaBoletoPendente + valor;
                vm.pesquisarDetalhesPendencias(vm.paginaBoletoPendente);
            }
        };

        vm.ordenarBoletoPendente = function (ordem) {
            vm.ordenacaoPesquisaPendente = ordem;
            vm.pesquisarDetalhesPendencias();
        };

        vm.pesquisaBoletoPago = {};
        vm.ordenacaoPesquisaPago = 'pessoaFisica.noPessoa-ASC';
        vm.itensPorPaginaBoletoPago = 10;
        vm.resultadoDetalhesSucesso = {};
        // vm.pesquisaBoletoPago = 0;
        vm.paginaBoletoPago = 1;


        vm.mudarPageSizeBoleto = function () {
            vm.paginaBoletoPago = 1;
            vm.pesquisarDetalhesSucesso();

        }

        vm.pesquisarDetalhesSucesso = function (page) {

            $scope.localLoading = true;
            vm.pesquisaBoletoPago.pageSize = vm.itensPorPagina;
            vm.pesquisaBoletoPago.page = 1;
            vm.pesquisaBoletoPago.order = vm.ordenacaoPesquisaPago;
            vm.pesquisaBoletoPago.mesBoleto = vm.pesquisa.mesBoleto;
            vm.pesquisaBoletoPago.idArquivoPagamento = $stateParams.idPagamento;
            vm.pesquisaBoletoPago.isBoleto = 0;
            vm.pesquisaBoletoPago.status = 1;
            vm.pesquisaBoletoPago.pageSize = vm.itensPorPaginaBoletoPago;

            if (page) {
                vm.pesquisaBoletoPago.page = page;
            }

            api.detalheArquivoPagamento.get(vm.pesquisaBoletoPago, function (response) {
                vm.resultadoDetalhesSucesso = response;
                $scope.localLoading = false;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        };

        vm.adicionaPaginaBoletoPago = function (valor) {
            var totalPagina = vm.resultadoDetalhesSucesso.page_count;
            if ((vm.paginaBoletoPago <= totalPagina) && vm.paginaBoletoPago >= 1) {
                vm.paginaBoletoPago = vm.paginaBoletoPago + valor;
                vm.pesquisarDetalhesSucesso(vm.paginaBoletoPago);
            }
        }

        vm.ordenarBoletoPago = function (ordem) {
            vm.ordenacaoPesquisaPago = ordem;
            vm.pesquisarDetalhesSucesso();
        }
        /**
         * ===========================================================
         * TUDO RELACIONADO A PESQIOSA DE BOLETO pago
         * ===========================================================
         */
        vm.loadingPagamento = [];
        vm.salvarBoleto = function (detalhePagamento, idLinha) {
            vm.loadingPagamento[idLinha] = true;
            detalhePagamento.mesAno = vm.pesquisa.mesBoleto;
            //Novo processo
            api.detalheArquivoPagamento.save(detalhePagamento, function (responseBoleto) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Pagamento salvo com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                vm.loadingPagamento[idLinha] = false;
                //pesquiso boleto novamente
                vm.pesquisarDetalhesSucesso(vm.paginaBoletoPago);
                vm.pesquisarDetalhesPendencias(vm.paginaBoletoPendente);

            }, function (responseError) {
                vm.loadingPagamento[idLinha] = false;
                var mensagemErro = "O boleto de pagamento não pode ser salvo no momento";
                if (406 == responseError.data.status || 412 == responseError.data.status) {
                    mensagemErro = responseError.data.detail;
                }

                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        '</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
            });
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.pagamento")
        .controller("DialogController", DialogController);

    /** @ngInject */
    function DialogController(api,
                              $scope,
                              $stateParams,
                              $state,
                              $mdToast,
                              $timeout,
                              $filter,
                              $mdDialog) {
        var vm = this;
        $scope.localLoading = false;
        $scope.convenios = {};
        vm.associados = null;
        vm.associado = null;
        vm.pesquisa = {};
        vm.textoAssociadoAutocomplete = "";
        vm.loading = false;


        vm.init = function () {
            vm.getProdutos();
            vm.pesquisar();
        }

        vm.pesquisarAutocomplete = function () {
            return $filter('filter')(vm.associados, {
                _embedded: {
                    pessoaFisica: {
                        noPessoa: vm.textoAssociadoAutocomplete
                    }
                }
            })
        }

        vm.salvarPagamento = function () {
          var produtoQuebrado = vm.boletoPagamento.produto.split("||");
            var payload = {
                tpPagamento: 2,
                mesAno: vm.boletoPagamento.mesAno,
                dsMatriculaFuncional: vm.associado.dsMatriculaFuncional,
                nuCpf: vm.associado._embedded.pessoaFisica.nuCpf,
                noPessoa: vm.associado._embedded.pessoaFisica.noPessoa,
                vlProduto: parseFloat(produtoQuebrado[0]),
                dsProduto: produtoQuebrado[1]
            }
            if (vm.boletoPagamento.nuDependentes > 0) {
                payload.vlProduto = payload.vlProduto * (1 + parseInt(vm.boletoPagamento.nuDependentes));
            }

            console.log('------------------------payload');
            console.log(payload);
            console.log('------------------------payload');
            vm.loading = true;
            api.detalheArquivoPagamento.save(payload, function () {
                vm.loading = false;
                vm.fecharModal();
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Pagamento salvo com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
            }, function (responseError) {
                vm.loading = false;
                vm.loadingPagamento[idLinha] = false;
                var mensagemErro = "O boleto de pagamento não pode ser salvo no momento";
                if (406 == responseError.data.status || 412 == responseError.data.status) {
                    mensagemErro = responseError.data.detail;
                }

                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        '</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
            });
        }

        vm.pesquisar = function () {
            vm.pesquisa.pageSize = -1;
            vm.pesquisa.noAssociado = vm.textoAssociadoAutocomplete;
            vm.pesquisa.inAtivo = true;
            vm.loading = true;

            api.associado.get(vm.pesquisa, function (response) {
                vm.associados = response._embedded.associado;
                vm.loading = false;
            }, function (responseError) {
                $scope.localLoading = false;
                vm.loading = false;
                console.log(responseError.data);
            });
        }

        vm.fecharModal = function () {
            $mdDialog.hide();
        }

        /**
         * Lista os convenios
         */
        vm.getProdutos = function () {
            api.convenio.get({inProdutoCobrado: true}, function (response) {
                $scope.convenios = response._embedded.convenio;
            }, function (responseError) {
                console.log(responseError);
            });

        }

        vm.getProdutos = function () {
            api.convenio.get({}, function (response) {
                $scope.convenios = response._embedded.convenio;
                console.log('------------------------------- convenio');
                console.log($scope.convenios);
                console.log('------------------------------- convenio');
            }, function (responseError) {
                console.log(responseError);
            });

        }
    }
})();

(function () {
    "use strict";

    angular
        .module("app.pagamento")
        .controller("BoletoController", BoletoController);

    /** @ngInject */
    function BoletoController(api,
                              $scope,
                              $stateParams,
                              $state,
                              $mdToast,
                              $timeout,
                              $mdDialog,
                              DTOptionsBuilder,
                              DTColumnBuilder,
                              $http,
                              $element) {
        var vm = this;
        $scope.localLoading = false;
        vm.pesquisa = {};
        vm.resultado = {};
        vm.dtOptions = {};
        vm.mesesBoletos = [];
        vm.boletoPagamento = [];
        $scope.convenios  = {};


        vm.initBoleto = function () {
            var now = new Date();
            vm.pesquisa.mesBoleto = (now.getMonth() + 1) + "/" + now.getFullYear();
        }



        vm.dtOptionsPendencia = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: "simple_numbers",
            autoWidth: true,
            responsive: true,
            bFilter: false,
            bLengthChange: true,
            // source:  DTOptionsBuilder.fromSource(vm.resultadoDetalhesPendencias),
            language: {
                lengthMenu: "Mostra  _MENU_ registros por página",
                zeroRecords: "Não há registros",
                info: "Página _PAGE_ de _PAGES_",
                infoEmpty: "Não há registros",
                infoFiltered: "(filtered from _MAX_ total records)",
                search: "Buscar",
                searchPlaceholder: "Buscar",
                oPaginate: {
                    sNext: "Próximo",
                    sPrevious: "Anterior",
                    sFirst: "Primeiro",
                    sLast: "Último"
                }
            }
        };
        vm.dtOptionsSucesso = {};

        vm.pesquisarBoleto = function () {
            vm.pesquisarDetalhesSucessoBoleto(vm.paginaBoletoPago);
            vm.pesquisarDetalhesPendenciasBoleto(vm.paginaBoletoPendente);
        }


        vm.mascararMatricula = function (valor) {
            var matricula = valor;
            matricula = matricula.replace("-", "");
            matricula = matricula.replace(".", "");
            matricula = matricula.replace(".", "");
            matricula = matricula.padStart(8, "0");

            var mascara = "-";
            var position = 7;
            var output = [matricula.slice(0, position), mascara, matricula.slice(position)].join('');

            mascara = '.';
            position = 4;
            output = [output.slice(0, position), mascara, output.slice(position)].join('');

            position = 1;
            output = [output.slice(0, position), mascara, output.slice(position)].join('');

            vm.associado.dsMatriculaFuncional = output;
        }


        /**
         * ===========================================================
         * TUDO RELACIONADO A PESQIOSA DE BOLETO Pendencia
         * ===========================================================
         */

        vm.pesquisaBoletoPendente = {};
        vm.ordenacaoPesquisaPendente = 'pessoaFisica.noPessoa-ASC';
        vm.itensPorPaginaBoleto = 10;
        vm.resultadoDetalhesPendenciasBoleto = {};
        vm.pesquisaBoletoPentende = 0;
        vm.paginaBoletoPendente = 1;



        vm.mudarPageSizePendencia = function () {
            vm.paginaBoletoPendente = 1;
            vm.pesquisarDetalhesPendenciasBoleto();

        }

        vm.pesquisarDetalhesPendenciasBoleto = function (page) {

            $scope.localLoading = true;
            vm.pesquisaBoletoPendente.pageSize = vm.itensPorPagina;
            vm.pesquisaBoletoPendente.page = 1;
            vm.pesquisaBoletoPendente.order = vm.ordenacaoPesquisaPendente;
            vm.pesquisaBoletoPendente.mesBoleto = vm.pesquisa.mesBoleto;
            vm.pesquisaBoletoPendente.isBoleto = 1;
            vm.pesquisaBoletoPendente.status = 0;
            vm.pesquisaBoletoPendente.pageSize = vm.itensPorPaginaBoleto;
            if (page) {
                vm.pesquisaBoletoPendente.page = page;
            }

            api.detalheArquivoPagamento.get(vm.pesquisaBoletoPendente, function (response) {
                vm.resultadoDetalhesPendenciasBoleto = response;
                $scope.localLoading = false;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        }

        vm.adicionaPaginaPrendenciaBoleto = function (valor) {
            var totalPagina = vm.resultadoDetalhesPendenciasBoleto.page_count;
            if ((vm.paginaBoletoPendente <= totalPagina) && vm.paginaBoletoPendente >= 1) {
                vm.paginaBoletoPendente = vm.paginaBoletoPendente + valor;
                vm.pesquisarDetalhesPendenciasBoleto(vm.paginaBoletoPendente);
            }
        }

        vm.ordenarBoletoPendente = function (ordem) {
            vm.ordenacaoPesquisaPendente = ordem;
            vm.pesquisarDetalhesPendenciasBoleto();
        }

        /**
         * ===========================================================
         * TUDO RELACIONADO A PESQIOSA DE BOLETO pendencia
         * ===========================================================
         */


        /**
         * ===========================================================
         * TUDO RELACIONADO A PESQIOSA DE BOLETO pago
         * ===========================================================
         */
        vm.pesquisaBoletoPago = {};
        vm.ordenacaoPesquisaPago = 'pessoaFisica.noPessoa-ASC';
        vm.itensPorPaginaBoletoPago = 10;
        vm.resultadoDetalhesBoletoPago = {};
        // vm.pesquisaBoletoPago = 0;
        vm.paginaBoletoPago = 1;


        vm.mudarPageSizeBoleto = function () {
            vm.paginaBoletoPago = 1;
            vm.pesquisarDetalhesSucessoBoleto();

        }

        vm.pesquisarDetalhesSucessoBoleto = function (page) {

            $scope.localLoading = true;
            vm.pesquisaBoletoPago.pageSize = vm.itensPorPagina;
            vm.pesquisaBoletoPago.page = 1;
            vm.pesquisaBoletoPago.order = vm.ordenacaoPesquisaPago;
            vm.pesquisaBoletoPago.mesBoleto = vm.pesquisa.mesBoleto;
            vm.pesquisaBoletoPago.isBoleto = 1;
            vm.pesquisaBoletoPago.status = 1;
            vm.pesquisaBoletoPago.pageSize = vm.itensPorPaginaBoletoPago;

            if (page) {
                vm.pesquisaBoletoPago.page = page;
            }

            api.detalheArquivoPagamento.get(vm.pesquisaBoletoPago, function (response) {
                vm.resultadoDetalhesBoletoPago = response;
                console.log(vm.resultadoDetalhesBoletoPago);
                $scope.localLoading = false;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        }

        vm.preencherCombosBoleto = function () {
            var mesDezoito = 4;
            var anoBase = 2018;
            var data = new Date();
            var anoAtual = data.getFullYear();

            for (var ano = anoBase; ano <= anoAtual; ano++) {
                var mes = 0;
                var mesBase = 1;
                if (ano === 2018) {
                    mesBase = mesDezoito;
                }

                for (mes = mesBase; mes <= 12; mes++) {

                    vm.mesesBoletos.push({
                        'label': mes + "/" + ano,
                        'valor': mes + "/" + ano
                    });
                    var now = new Date();
                    var atual = (now.getMonth() + 1) + "/" + now.getFullYear();
                    if (atual == mes + "/" + ano) {
                        break;
                    }
                }
            }
        }

        vm.adicionaPaginaBoletoPago = function (valor) {
            var totalPagina = vm.resultadoDetalhesBoletoPago.page_count;
            if ((vm.paginaBoletoPago <= totalPagina) && vm.paginaBoletoPago >= 1) {
                vm.paginaBoletoPago = vm.paginaBoletoPago + valor;
                vm.pesquisarDetalhesSucessoBoleto(vm.paginaBoletoPago);
            }
        }

        vm.ordenarBoletoPago = function (ordem) {
            vm.ordenacaoPesquisaPago = ordem;
            vm.pesquisarDetalhesSucessoBoleto();
        }
        /**
         * ===========================================================
         * TUDO RELACIONADO A PESQIOSA DE BOLETO pago
         * ===========================================================
         */
        vm.loadingPagamento = [];
        vm.salvarBoleto = function (detalhePagamento, idLinha) {
            vm.loadingPagamento[idLinha] = true;
            detalhePagamento.mesAno = vm.pesquisa.mesBoleto;
            //Novo processo
            api.detalheArquivoPagamento.save(detalhePagamento, function (responseBoleto) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Pagamento salvo com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                vm.loadingPagamento[idLinha] = false;
                //pesquiso boleto novamente
                vm.pesquisarDetalhesSucessoBoleto(vm.paginaBoletoPago);
                vm.pesquisarDetalhesPendenciasBoleto(vm.paginaBoletoPendente);

            }, function (responseError) {
                vm.loadingPagamento[idLinha] = false;
                var mensagemErro = "O boleto de pagamento não pode ser salvo no momento";
                if (406 == responseError.data.status || 412 == responseError.data.status) {
                    mensagemErro = responseError.data.detail;
                }

                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        '</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
            });
        }

        $scope.customFullscreen = false;
        vm.abrirModal = function (ev) {
            $mdDialog.show({
                controller: "DialogController as vm" ,
                templateUrl: 'app/main/pagamento/views/boleto/modal.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                // fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        $stateProvider.state('app.esqueci', {
            url      : '/recuperar-senha',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.esqueci': {
                    templateUrl: 'app/main/login/esqueci-senha.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, OAuth, $state, OAuthToken, api, $mdToast) {
        $scope.usuarioExiste = true;

        $scope.init = function () {
            if (OAuth.isAuthenticated()) {
                $state.go('app.dashboard');
            }
        }

        $scope.logar = function (usuario) {
            //$scope.loading = true;
            $scope.localLoading = true;
            OAuth.getAccessToken(usuario).then(function (resp) {
                console.log(resp);
                $state.go('app.dashboard')
            }, function () {
                $scope.localLoading = false;
                $scope.error_login = "Login ou senha incorretos";
            });
        }
        /*
         * Desloga o usuario, removendo o cookie, e direcionado para o login
         */

        $scope.recuperarSenha = function (usuario) {

        }

        $scope.logout = function () {
            OAuthToken.removeToken();
            $state.go('app.login');
        }

        $scope.recuperarSenha = function (username) {
            $scope.error_login = null;
            $scope.localLoading = true;
            if (username) {
                api.recuperarSenha.save(username, function (response) {
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Sua nova senha foi enviada para o Email '+response.email+'</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;

                    $state.go('app.login');
                }, function (responseError) {
                  $scope.localLoading = false;
                    if (responseError.status == 412) {
                        $scope.error_login = 'Usuário não encontrado.';
                        return;
                    }
                    $mdToast.show(
                      {
                          template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                              '<span class="md-toast-content md-red-400-bg">' +
                              'houve um erro ao recuperar a senha, contate o administrador' +
                              '</span>' +
                              '</md-toast>',
                          hideDelay: 3000,
                          position: 'top right'
                      }
                  );
                });
            }else{
              $scope.localLoading = false;
            }
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.juridico', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.juridico', {
            url: '/juridico',
            views: {
                'content@app': {
                    templateUrl: 'app/main/juridico/views/listar.html',
                    controller: 'JuridicoController as vm'
                }
            },
            bodyClass: 'juridico'
        });

        $stateProvider.state('app.juridico.add', {
            url: '/Adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/juridico/views/cadastrar.html',
                    controller: 'JuridicoController as vm'
                }
            },
            bodyClass: 'juridico'
        });

        $stateProvider.state('app.juridico.visualizar', {
            url: '/Visualizar/:idProcesso',
            views: {
                'content@app': {
                    templateUrl: 'app/main/juridico/views/visualizar.html',
                    controller: 'JuridicoController as vm'
                }
            },
            bodyClass: 'juridico'
        });

        $stateProvider.state('app.juridico.edit', {
            url: '/editar/:idProcesso',
            views: {
                'content@app': {
                    templateUrl: 'app/main/juridico/views/cadastrar.html',
                    controller: 'JuridicoController as vm'
                }
            },
            bodyClass: 'juridico'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/juridico');




    }

})();
(function () {
    'use strict';

    angular
        .module('app.juridico')
        .controller('JuridicoController', JuridicoController);

    /** @ngInject */
    function JuridicoController(api, $element, $scope, $stateParams, $state, $mdToast, $mdDialog, DTOptionsBuilder) {
        var vm = this;
        vm.titulo = "Jurídico";
        vm.processoVisualizar = {};
        vm.processos = {};
        vm.juridico = {};
        vm.init = function () {
            vm.preencherTabela();
            vm.listarProcessos();
        }

        vm.preencherTabela = function () {
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple_numbers',
                autoWidth: true,
                responsive: true,
                bFilter: true,
                bLengthChange: true,
                source: DTOptionsBuilder.fromSource(vm.processos),
                "language": {
                    "lengthMenu": "Mostra  _MENU_ registros por página",
                    "zeroRecords": "Não há registros",
                    "info": "Página _PAGE_ de _PAGES_",
                    "infoEmpty": "Não há registros",
                    "infoFiltered": "(filtered from _MAX_ total records)",
                    'search': "Buscar",
                    'searchPlaceholder': "Buscar",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                        "sFirst": "Primeiro",
                        "sLast": "Último"
                    },
                }
            };
            $element.parent().find(".dataTables_empty").remove();
        }

        vm.listarTribunais = function () {
            api.tribunal.get(function (responseTribunais) {
                console.log(responseTribunais._embedded.tribunal);
                vm.tribunais = responseTribunais._embedded.tribunal;
            });
        }

        vm.listarAdvogados = function () {
            api.advogado.get(function (responseAdvogados) {
                console.log(responseAdvogados._embedded.advogado);
                vm.advogados = responseAdvogados._embedded.advogado;
            });
        }

        vm.listarProcessos = function () {
            vm.preencherTabela();
            api.processo.get({'processo_id': $stateParams.idProcesso}, function (responseProcessosCompleto) {
                if ($stateParams.idProcesso) {
                    var responseProcessos = responseProcessosCompleto._embedded[0];

                    vm.juridico.dtProcesso = moment(responseProcessos.dtProcesso.date, "YYYY-MM-DD ").format('DD/MM/YYYY');
                    vm.juridico.tribunal = responseProcessos._embedded.tribunal.idTribunal;
                    vm.juridico.advogado = responseProcessos._embedded.advogado.idAdvogado;
                    vm.juridico.dsLink = responseProcessos.dsLink;
                    vm.juridico.numProcesso = responseProcessos.numProcesso;
                    vm.juridico.tpProcesso = responseProcessos.tpProcesso;
                    vm.juridico.tpAcaoProcesso = responseProcessos.tpAcaoProcesso;

                    vm.juridico.inProcessoRecebido = responseProcessos.inProcessoRecebido == true ? 1 : 0;
                    var associadoCopy = Object.assign({}, responseProcessos._embedded.associado);
                    if (associadoCopy._embedded != undefined) {
                        vm.associado = associadoCopy;
                        vm.searchText = associadoCopy._embedded.pessoaFisica.noPessoa;
                    }
                    delete responseProcessos._embedded.associado;

                    console.log('-------------zoom');
                    console.log(responseProcessos);
                    console.log('-------------zoom');
                    return;
                }
                vm.processos = responseProcessosCompleto._embedded.processo;
                $element.parent().find(".dataTables_empty").remove();
            });
        }

        vm.cadastrarProcesso = function () {
            vm.juridico.dtProcesso = moment(vm.juridico.dtProcesso, "DD/MM/YYYY").format('YYYY-MM-DD');
            if (vm.associado) {
                vm.juridico.associado = vm.associado.idAssociado;
            }
            //Novo processo
            if (!$stateParams.idProcesso) {
                api.processo.save(vm.juridico, function (ResponseProcesso) {
                    $state.go('^');
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Processo Cadastrado com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                }, function (responseError) {
                    vm.juridico.dtProcesso = moment(vm.juridico.dtProcesso, "YYYY-MM-DD").format('DD/MM/YYYY')
                    var mensagemErro = "Não foi possível Salvar o Processo, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }

                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                });
                return;
            }
            // Fim do novo processo

            //Editar processo
            api.processo.update({processo_id: $stateParams.idProcesso}, vm.juridico, function (ResponseProcesso) {
                $state.go('^');
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Processo Salvo com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
            }, function (responseError) {
                vm.juridico.dtProcesso = moment(vm.juridico.dtProcesso, "YYYY-MM-DD").format('DD/MM/YYYY')
                var mensagemErro = "Não foi possível Editar o Processo, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                if (responseError.data.status == 406 || responseError.data.status == 412) {
                    mensagemErro = responseError.data.detail;
                }

                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        '</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
            });
        }

        vm.listarAssociados = function () {
            api.associado.get(function (responseAssociado) {
                vm.associados = responseAssociado._embedded.associado;
            });
        }


        vm.obterVisualizar = function () {
            api.processo.get({'processo_id': $stateParams.idProcesso}, function (result) {
                console.log('ivusalizacao----------------------');
                console.log(result);
                console.log('ivusalizacao----------------------');
                vm.processoVisualizar = result._embedded[0];
            });

            vm.listarStatusProecsso();

            api.status.get({}, function (result) {
                vm.status = result._embedded.status;
            });
        }

        vm.listarStatusProecsso = function () {
            api.statusProcesso.get({'idProcesso': $stateParams.idProcesso}, function (result) {
                vm.statusProcesso = result._embedded.status_processo;
            });
        }


        vm.formatarData = function (date) {
            return moment(date).format('DD/MM/YYYY');
        }

        vm.salvarStatus = function () {
            if (vm.statusProcessoCadastro) {
                var payload = {
                    "status": vm.statusProcessoCadastro,
                    "processo": $stateParams.idProcesso
                }
                api.statusProcesso.save(payload, function (response) {
                    vm.listarStatusProecsso();
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Andamento Salvo com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                }, function (resp) {
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            'Houve um erro ao salvar o andamento' +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                });
            }
        }

    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.default', [])
            .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State Default
        $stateProvider
                .state('app.default', {
                    url: '/default',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/default/default.html',
                            controller: 'DefaultController as df'
                        }
                    },
                    resolve: {
                        DashboardData: function (msApi)
                        {
                            return msApi.resolve('default@get');
                        }
                    },
                });

        // State Default filho
        $stateProvider
                .state('app.default.lista', {
                    url: '/lista',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/default/lista.html',
                            controller: 'DefaultController as df'
                        }
                    },
                    bodyClass: 'forms'
                });
        // Table


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/default');


//        // Navigation
//        msNavigationServiceProvider.saveItem('fuse', {
//            title: 'DEFAULT',
//            group: true,
//            weight: 1
//        });
//
//        msNavigationServiceProvider.saveItem('fuse.default', {
//            title: 'Default',
//            icon: 'icon-tile-four',
//            state: 'app.default',
//            /*stateParams: {
//             'param1': 'page'
//             },*/
//            translate: 'DEFAULT.DEFAULT_NAV',
//            weight: 1
//        });
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.default')
            .controller('DefaultController', DefaultController);

    /** @ngInject */
    function DefaultController($scope, $interval, $mdSidenav,DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title: vm.dashboardData.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d)
                        {
                            return d.x;
                        },
                        y: function (d)
                        {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            supporting: {
                widgets: {
                    created: {
                        data: vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed: {
                        data: vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened: {
                        data: vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix: {
                        data: vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data: vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed: {
                        data: vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'lineChart',
                            color: ['#03A9F4'],
                            height: 50,
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            isArea: true,
                            interpolate: 'cardinal',
                            clipEdge: true,
                            duration: 500,
                            showXAxis: false,
                            showYAxis: false,
                            showLegend: false,
                            useInteractiveGuideline: true,
                            x: function (d)
                            {
                                return d.x;
                            },
                            y: function (d)
                            {
                                return d.y;
                            },
                            yDomain: [0, 9],
                            xAxis: {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data: []
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange: function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key: widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init: function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d)
                        {
                            return d.label;
                        },
                        y: function (d)
                        {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title: vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d)
                        {
                            return d.label;
                        },
                        y: function (d)
                        {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title: vm.dashboardData.widget9.title,
            weeklySpent: {
                title: vm.dashboardData.widget9.weeklySpent.title,
                count: vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent: {
                title: vm.dashboardData.widget9.totalSpent.title,
                count: vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining: {
                title: vm.dashboardData.widget9.remaining.title,
                count: vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget: vm.dashboardData.widget9.totalBudget,
            chart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#00BCD4'],
                        height: 50,
                        margin: {
                            top: 8,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d)
                        {
                            return d.x;
                        },
                        y: function (d)
                        {
                            return d.y;
                        },
                        yDomain: [0, 9],
                        xAxis: {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange: function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key: vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key: vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key: vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init: function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title: vm.dashboardData.widget11.title,
            table: vm.dashboardData.widget11.table,
            dtOptions: {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                order: [1, 'asc'],
                columnDefs: [
                    {
                        width: '40',
                        orderable: false,
                        targets: [0]
                    },
                    {
                        width: '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.associado', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.associado', {
            url: '/associado',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/listar.html',
                    controller: 'AssociadoController as vm'
                }
            },
            bodyClass: 'associado'
        });


        $stateProvider.state('app.associado.add', {
            url: '/adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/cadastrar.html',
                    controller: 'AssociadoController as vm'
                }
            },
            bodyClass: 'associado'
        });

        $stateProvider.state('app.listar_associado_externo', {
            url: '/associado-exteno/listar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/listar_associado_externo.html',
                    controller: 'AssociadoController as vm'
                }
            },
            bodyClass: 'associado'
        });

        $stateProvider.state('app.listar_associado_externo.aprovar', {
            url: '/associado-exteno/aprovar/:idAssociadoExterno',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/cadastro_associado_externo.html',
                    controller: 'AssociadoController as vm'
                }
            },
            bodyClass: 'associado'
        });

        $stateProvider.state('app.associado.edit', {
            url: '/editar/:idAssociado/:selectedIndex',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/cadastrar.html',
                    controller: 'AssociadoController as vm'
                }
            },
            bodyClass: 'associado'
        });


        $stateProvider.state('app.associado.ficha', {
            url: '/ficha/:idAssociado',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/ficha.html',
                    controller: 'AssociadoController as vm'
                }
            },
            bodyClass: 'associado'
        });

        $stateProvider.state('app.aniversariante', {
            url: '/aniversariante',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/aniversariantes.html',
                    controller: 'AniversarianteController as vm'
                }
            },
            bodyClass: 'associado'
        });

        $stateProvider.state('app.dashboard', {
            url: '/dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/associado/views/dashboard.html',
                    controller: 'DashboardController as vm'
                }
            },
            bodyClass: 'associado'
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/associado');



    }

})();

(function () {
    'use strict';

    angular
        .module('app.associado')
        .controller('ConvenioController', ConvenioController);

    /** @ngInject */
    function ConvenioController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, DTOptionsBuilder, $http, $element) {
        var vm = this;
        vm.titulo = "Cadastrar Convênio";
        $scope.localLoading = false;
        // dados de pesquisa
        vm.pesquisa = {};
        vm.resultado = {};
        vm.dtOptions = {};
        vm.idProduto = null;
        vm.convenio = null;

        vm.pesquisar = function () {
            $scope.localLoading = true;
            api.convenio.get(vm.pesquisa, function (response) {
                $scope.localLoading = false;
                vm.preencherDataTable();
                $element.parent().find(".dataTables_empty").remove();
                vm.pesquisa.pageSize = -1;
                vm.resultadoConvenio = response._embedded.convenio;
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        };

        vm.initListar = function () {
            vm.preencherDataTable();
            vm.pesquisar();
        };

        vm.init = function () {
            vm.obterDados();
        }

        vm.obterDados = function () {
            if ($stateParams.idProduto) {
                api.convenio.get({idProduto: $stateParams.idProduto}, function (response) {
                    vm.convenio = response;
                }, function (responseError) {
                    console.log(responseError.data.detail);
                });
            }
        }

        vm.voltar = function () {
            $state.go('app.convenio');
        }

        vm.cadastrar = function () {
            // payload de pagamento do convenio
            var payload = vm.convenio;
            $scope.localLoading = true;
            if ($stateParams.idProduto) {
                // atualizando convenio
                api.convenio.update({
                    idProduto: $stateParams.idProduto
                }, payload, function (response) {
                    $scope.localLoading = false;
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Convênio Cadastrado com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $state.go('app.convenio');
                }, function (responseError) {
                    var mensagemErro = "Não foi possível Salvar o Convenio, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                });
            } else {
                api.convenio.save(payload, function (response) {
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Convenio Cadastrado com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                    $state.go('app.convenio');
                }, function (responseError) {
                    var mensagemErro = "Não foi possível Salvar o Convenio, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                    console.log(responseError.data.detail);
                });
            }


        }

        vm.desativarOuAtivar = function (convenio) {
            console.log(convenio);
            var dados = {
                inAtivo: 0
            }
            var msg = "Desativado";
            if (vm.inAtivo[convenio.idProduto]) {
                dados.inAtivo = true;
                var msg = "Ativado";
            }

            api.convenio.delete({idProduto: convenio.idProduto}, dados, function (response) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg"> ' + convenio.dsProduto + ' ' + msg + ' com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                // console.log(response);
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        }
        vm.preencherDataTable = function () {
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple_numbers',
                autoWidth: true,
                responsive: true,
                bFilter: false,
                bLengthChange: true,
                source: DTOptionsBuilder.fromSource(vm.resultado),
                "language": {
                    "lengthMenu": "Mostra  _MENU_ registros por página",
                    "zeroRecords": "Não há registros",
                    "info": "Página _PAGE_ de _PAGES_",
                    "infoEmpty": "Não há registros",
                    "infoFiltered": "(filtered from _MAX_ total records)",
                    'search': "Buscar",
                    'searchPlaceholder': "Buscar",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                        "sFirst": "Primeiro",
                        "sLast": "Último"
                    },
                }
            };
        }


    }


})();

(function () {
  'use strict';

  angular
    .module('app.contra_cheque', ['datatables', 'textAngular'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State

    $stateProvider.state('app.contra_cheque', {
      url: '/contra-cheque',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.contra_cheque': {
          templateUrl: 'app/main/contra_cheque/views/contra_resultado.html',
          controller: 'ContraChequeController as vm'
        }
      },
      bodyClass: 'contra_cheque'
    });

    $translatePartialLoaderProvider.addPart('app/main/contra_cheque');


  }

})();

(function () {
    "use strict";

    angular
        .module("app.contra_cheque")
        .controller("ContraChequeController", ComunicacaoController);

    /** @ngInject */
    function ComunicacaoController(api,$scope,$mdToast) {
        var vm = this;
        vm.titulo = "Calculadora de contra-cheque";
        $scope.localLoading = false;
        vm.pagamento = {};
        vm.pagamento.plantao = 0;
        vm.mostrarFormulario = true;
        /**
         * constantes
         */

        vm.adicionalTempoServico = 5;
        vm.totalHorasMes = 200;
        vm.percentualHoraExtra = 0.25;
        vm.adicionalInslubridade = 0.1;
        vm.reducaoImpostoRenda = 869.36;
        vm.reducaoImpostoRendaFerias = 142.80;
        vm.deducaoAsspen = 56.00;
        /**
         * Resultados
         */
        vm.ghapResultado = 0.00;
        vm.tempoServicoResultado = 0.00;
        vm.adicionalNoturnoResultado = 0.00;
        vm.insalubridadeResultado = 0.00;
        vm.rppsResultado = 0.00;
        vm.totalGratNatResult = 0.0;
        vm.rppsGratNatResult = 0.0;
        vm.irGratNatResult = 0.0;
        vm.totalLiquidoGratNatResult = 0.0;


        vm.heigthPage = angular.element("body")[0].clientHeight;


        /**
         * Faz todos os calculos do contra-cheque
         */
        vm.calcularContraCheque = function () {

            // valida se todos os campos foram preenchidos
            if(!vm.pagamento.dsVencimento || !vm.pagamento.alimentacao || !vm.pagamento.ghap){
                var mensagemErro = "Preencha os campos obrigatórios (marcados com *)"
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                return;
            }

            /** =======================================================================================================
             * INICIO DO CALCULO DE VENCIMENTOS
             =========================================================================================================*/
            //calculo a ghap com base na titulacao
            vm.ghapResultado = vm.pagamento.dsVencimento * (vm.pagamento.ghap / 100);
            /**
             * Tempo de servico e 5% do vencimento
             */
            if (vm.pagamento.tempo) {
                vm.tempoServicoResultado = vm.pagamento.dsVencimento * (vm.adicionalTempoServico / 100);
            } else {
                vm.tempoServicoResultado = 0;
            }
            /**
             * caso tenha plantoes calculo as horas extras
             */
            if (vm.pagamento.plantao > 0) {
                /**
                 * ((vm.pagamento.dsVencimento + vm.pagamento.adicional + GHAP + Adicional de tempo de servicao)/totalHorasMes)*(0,25)*8*quantidade de plantoes
                 */
                vm.adicionalNoturnoResultado =
                    (
                        (
                            vm.pagamento.dsVencimento
                            + vm.pagamento.adicional /*Adicional de qualificacao*/
                            + vm.ghapResultado /** GHAP calculado */
                            + vm.tempoServicoResultado
                        ) / vm.totalHorasMes
                    )
                    * (vm.percentualHoraExtra) * 8 * vm.pagamento.plantao /* Quantidade de plantoes */;
            }

            /**
             * Adicional de 10% na insalubridade
             */
            vm.insalubridadeResultado = vm.pagamento.dsVencimento * vm.adicionalInslubridade;

            /****************************
             * Total Bruto dos vencimento
             *****************************/

            vm.totalBrutoResultado = vm.pagamento.dsVencimento +
                vm.ghapResultado +
                vm.pagamento.adicional +
                vm.tempoServicoResultado +
                vm.adicionalNoturnoResultado +
                vm.pagamento.alimentacao +
                vm.insalubridadeResultado;

            /****************************
             * DESCONTOS
             *****************************/


            vm.rppsResultado = (vm.pagamento.dsVencimento + vm.ghapResultado + vm.tempoServicoResultado) * 0.11;
            /**
             * @TODO
             *  vm.reducaoImpostoRenda calcular deducao por dependende do desconto em folha
             */

            vm.irResultado = (vm.totalBrutoResultado - vm.pagamento.alimentacao - vm.rppsResultado) * 0.275 - vm.reducaoImpostoRenda;

            vm.totalDescontosResultado = vm.deducaoAsspen + vm.rppsResultado + vm.irResultado;

            /**
             * SALARIO LIQUIDO
             */
            vm.totalLiquidoResultado = vm.totalBrutoResultado - vm.totalDescontosResultado;

            /** =======================================================================================================
             * FIM DO CALCULO DE VENCIMENTOS
             =========================================================================================================*/


            /** =======================================================================================================
             * INICIO DO CALCULO DE GRATIFICACAO NATALICIA
             =========================================================================================================*/

            vm.totalGratNatResult = vm.pagamento.dsVencimento + vm.ghapResultado + vm.tempoServicoResultado + vm.insalubridadeResultado;

            vm.rppsGratNatResult = vm.rppsResultado;
            vm.irGratNatResult = (vm.totalGratNatResult - vm.rppsGratNatResult) * 0.275 - vm.reducaoImpostoRenda;
            vm.totalLiquidoGratNatResult = vm.totalGratNatResult - (vm.rppsGratNatResult + vm.irGratNatResult);


            /** =======================================================================================================
             * FIM DO CALCULO DE GRATIFICACAO NATALICIA
             =========================================================================================================*/


            /** =======================================================================================================
             * INICIO FÉRIAS
             =========================================================================================================*/
            vm.feriasBrutoResult = (vm.pagamento.dsVencimento + vm.ghapResultado + vm.tempoServicoResultado + vm.insalubridadeResultado) / 3;
            vm.irFeriasResult = vm.feriasBrutoResult * 0.075 - (vm.reducaoImpostoRendaFerias);
            vm.feriasLiquidoResult = vm.feriasBrutoResult - vm.irFeriasResult;


            /** =======================================================================================================
             * FIM DO CALCULO DE FÉRIAS
             =========================================================================================================*/


            /**
             * Mostra formulario de resultado
             */
            vm.mostrarFormulario = false;
        }

        vm.calcularVencimento = function () {

        }

        vm.voltarFormulario = function () {
            vm.mostrarFormulario = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.comunicacao', ['datatables','textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        
        $stateProvider.state('app.comunicacao', {
            url: '/comunicacao',
            views: {
                'content@app': {
                    templateUrl: 'app/main/comunicacao/views/listar.html',
                    controller: 'ComunicacaoController as vm'
                }
            },
            bodyClass: 'comunicacao'
        });


        $stateProvider.state('app.comunicacao.add', {
            url: '/adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/comunicacao/views/cadastrar.html',
                    controller: 'ComunicacaoController as vm'
                }
            },
            bodyClass: 'comunicacao'
        });

        $stateProvider.state('app.comunicacao.edit', {
            url: '/editar/:idComunicacao',
            views: {
                'content@app': {
                    templateUrl: 'app/main/comunicacao/views/cadastrar.html',
                    controller: 'ComunicacaoController as vm'
                }
            },
            bodyClass: 'comunicacao'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/comunicacao');


    }

})();
(function () {
    "use strict";

    angular
        .module("app.comunicacao")
        .controller("ComunicacaoController", ComunicacaoController);

    /** @ngInject */
    function ComunicacaoController(api,
                                   $scope,
                                   $stateParams,
                                   $state,
                                   $mdToast,
                                   $mdDialog,
                                   DTOptionsBuilder,
                                   $http,
                                   $element) {
        var vm = this;
        vm.titulo = "Cadastrar Comunicação";
        $scope.localLoading = false;
        // dados de pesquisa
        vm.pesquisa = {};
        vm.resultado = {};
        vm.dtOptions = {};
        vm.idComunicacao = null;
        vm.comunicacao = null;
        vm.resultadoComunicacao = {};

        vm.pesquisar = function () {
            $scope.localLoading = true;
            api.comunicacao.get(
                vm.pesquisa,
                function (response) {
                    $scope.localLoading = false;
                    vm.preencherDataTable();
                    $element
                        .parent()
                        .find(".dataTables_empty")
                        .remove();
                    vm.pesquisa.pageSize = -1;
                    vm.resultadoComunicacao = response._embedded.comunicado;

                    angular.forEach(vm.resultadoComunicacao, function (value, key) {
                        if (value.dtEnvio) {

                            vm.resultadoComunicacao[key].dtEnvioFormatado = moment(
                                value.dtEnvio.date
                            ).format("DD/MM/YYYY");
                        }else{

                            vm.resultadoComunicacao[key].dtEnvioFormatado = "";
                        }

                    });
                },
                function (responseError) {
                    console.log(responseError.data.detail);
                }
            );
        };

        vm.initListar = function () {
            vm.preencherDataTable();
            vm.pesquisar();
        };

        vm.init = function () {
            vm.obterDados();
        };

        vm.obterDados = function () {
            if ($stateParams.idComunicacao) {
                vm.obterAnexoComunicado($stateParams.idComunicacao);
                api.comunicacao.get(
                    {idComunicacao: $stateParams.idComunicacao},
                    function (response) {
                        vm.comunicacao = response;

                    },
                    function (responseError) {
                        console.log(responseError.data.detail);
                    }
                );
            }
        };

        vm.obterAnexoComunicado = function (idComunidado) {
            api.anexoComunicado.get(
                {idComunicado: idComunidado},
                function (response) {
                    vm.anexosComunicado = response._embedded.anexo_comunicado;
                },
                function (responseError) {
                    console.log(responseError.data.detail);
                }
            );
        }

        vm.cadastrar = function (inEnviado) {
            if ($stateParams.idComunicacao) {
                vm.motarPostComunicado(inEnviado, $stateParams.idComunicacao);
            } else {
                vm.motarPostComunicado(inEnviado);
            }
        };

        /**
         * Monta os dados para post via http para subir as requisicoes junto com os arquivos
         * @param idComunicado|undefined do comunicado caso haja
         */
        vm.motarPostComunicado = function (inEnviado, idComunicado) {
            var anexos = [];
            var fd = new FormData();
            fd.append('dsTituloComunicadoInformativo', vm.comunicacao.dsTituloComunicadoInformativo);
            fd.append('dsComunicadoInformativo', vm.comunicacao.dsComunicadoInformativo);
            fd.append('inEnviado', inEnviado);

            //pegando vários anexos
            var log = [];
            angular.forEach(vm.anexo, function (arquivoAtual, key) {
                anexos.push();
                fd.append('arquivo[]', arquivoAtual.lfFile);
            }, log);
            console.log(vm.anexo);
            vm.salvarComunicadoComAnexo(fd, idComunicado);
        }

        vm.salvarComunicadoComAnexo = function (dadosPost, idComunicado) {
            $scope.localLoading = true;

            if (idComunicado) {
                //adiciona um novo cardapio
                $http.put(api.baseUrl + 'associado/comunicado/' + idComunicado, dadosPost, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }).then(function (result) {
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Comunicado Salvo com Sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.loadingScreen = false;
                    $state.go("app.comunicacao");

                }, function (err) {
                    console.log('erro anexo---------------------');
                    console.log(err);
                    console.log('erro anexo---------------------');
                    var mensagemErro =
                        "Não foi possível Salvar a Comunicação, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (
                        responseError.data.status == 406 ||
                        responseError.data.status == 412
                    ) {
                        mensagemErro = responseError.data.detail;
                    }

                    $mdToast.show({
                        template:
                        '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        "</span>" +
                        "</md-toast>",
                        hideDelay: 3000,
                        position: "top right"
                    });
                    $scope.localLoading = false;
                });
            } else {
                //adiciona um novo cardapio
                $http.post(api.baseUrl + 'associado/comunicado', dadosPost, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }).then(function (result) {
                    $scope.localLoading = false;
                    $mdToast.show({
                        template:
                        '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Comunicado Cadastrado com sucesso</span>' +
                        "</md-toast>",
                        hideDelay: 3000,
                        position: "top right"
                    });
                    $state.go("app.comunicacao");
                }, function (err) {
                    var mensagemErro = "Não foi possível Salvar a Comunicação, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (
                        responseError.data.status == 406 ||
                        responseError.data.status == 412
                    ) {
                        mensagemErro = responseError.data.detail;
                    }
                    $mdToast.show({
                        template:
                        '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        "</span>" +
                        "</md-toast>",
                        hideDelay: 3000,
                        position: "top right"
                    });
                    $scope.localLoading = false;
                });
            }
        }

        vm.isImagem = function (mime) {
            var types = [
                "image/gif",
                "image/jpeg",
                "image/jpeg",
                "image/jpeg",
                "text/xml-svg"
            ];

            if (types.indexOf(mime) !== -1) {
                return true;
            }
            return false;
        }

        vm.isDocumento = function (mime) {

        }

        vm.showConfirm = function (ev, idAnexo) {
            var mensagem = "Deseja realmente remover o anexo?"
            var confirmacao = function () {
                api.anexoComunicado.delete({"idAnexoComunicado": idAnexo}, function (response) {
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Anexo Removido com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );

                    vm.obterAnexoComunicado($stateParams.idComunicacao);

                }, function (responseError) {
                    console.log(responseError.data.detail);
                });
            };

            vm.confirmTemplate(mensagem, confirmacao, ev);

        };


        vm.confirmTemplate = function (mensagem, callBackSim, ev) {
            var confirm = $mdDialog.confirm()
                .title('Confirmação')
                .textContent(mensagem)
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Sim')
                .cancel('Não');
            $mdDialog.show(confirm).then(callBackSim);
        }

        vm.preencherDataTable = function () {
            vm.dtOptions = {
                dom:
                    '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: "simple_numbers",
                autoWidth: true,
                responsive: true,
                bFilter: false,
                bLengthChange: true,
                source: DTOptionsBuilder.fromSource(vm.resultadoComunicacao),
                language: {
                    lengthMenu: "Mostra  _MENU_ registros por página",
                    zeroRecords: "Não há registros",
                    info: "Página _PAGE_ de _PAGES_",
                    infoEmpty: "Não há registros",
                    infoFiltered: "(filtered from _MAX_ total records)",
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    oPaginate: {
                        sNext: "Próximo",
                        sPrevious: "Anterior",
                        sFirst: "Primeiro",
                        sLast: "Último"
                    }
                }
            };
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.associado')
        .controller('BoletimController', BoletimController);

    /** @ngInject */
    function BoletimController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, DTOptionsBuilder, $http, $element) {
        var vm = this;
        vm.titulo = "Cadastrar Boletim";
        $scope.localLoading = false;
        // dados de pesquisa
        vm.pesquisa = {};
        vm.resultado = {};
        vm.dtOptions = {};
        vm.idBoletim = null;
        vm.boletim = null;


        vm.pesquisar = function () {
            $scope.localLoading = true;
            api.boletim.get(vm.pesquisa, function (response) {
                $scope.localLoading = false;
                vm.preencherDataTable();
                $element.parent().find(".dataTables_empty").remove();
                vm.pesquisa.pageSize = -1;
                vm.resultadoBoletim = response._embedded.boletim;
                angular.forEach(vm.resultadoBoletim, function (value, key) {
                    vm.resultadoBoletim[key].dtEnvioFormatado = moment(value.dtEnvio.date).format('DD/MM/YYYY');
                });

            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        };

        vm.initListar = function () {
            vm.preencherDataTable();
            vm.pesquisar();
        };

        vm.init = function () {

        }

        vm.obterDados = function () {
            if ($stateParams.idBoletim) {
                api.boletim.get({idBoletim: $stateParams.idBoletim}, function (response) {
                    vm.boletim = response;
                    console.log(vm.boletim);
                }, function (responseError) {
                    console.log(responseError.data.detail);
                });
            }
        }

        vm.cadastrar = function (inEnviado) {
            // payload de pagamento do boletim
            var payload = vm.boletim;
            payload.inEnviado = inEnviado;

            $scope.localLoading = true;


            if ($stateParams.idBoletim) {
                // atualizando boletim
                api.boletim.update({
                    idBoletim: $stateParams.idBoletim
                }, payload, function (response) {
                    $scope.localLoading = false;
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Boletim Cadastrado com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $state.go('app.boletim');
                }, function (responseError) {
                    var mensagemErro = "Não foi possível Salvar o Boletim, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                });
            } else {
                api.boletim.save(payload, function (response) {
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                            '<span class="md-toast-content md-green-400-bg">Boletim Cadastrado com sucesso</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                    $state.go('app.boletim');
                }, function (responseError) {
                    var mensagemErro = "Não foi possível Salvar o Boletim, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                    if (responseError.data.status == 406 || responseError.data.status == 412) {
                        mensagemErro = responseError.data.detail;
                    }

                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    $scope.localLoading = false;
                    console.log(responseError.data.detail);
                });
            }


        }

        vm.preencherDataTable = function () {
            vm.dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple_numbers',
                autoWidth: true,
                responsive: true,
                bFilter: false,
                bLengthChange: true,
                source: DTOptionsBuilder.fromSource(vm.resultado),
                "language": {
                    "lengthMenu": "Mostra  _MENU_ registros por página",
                    "zeroRecords": "Não há registros",
                    "info": "Página _PAGE_ de _PAGES_",
                    "infoEmpty": "Não há registros",
                    "infoFiltered": "(filtered from _MAX_ total records)",
                    'search': "Buscar",
                    'searchPlaceholder': "Buscar",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                        "sFirst": "Primeiro",
                        "sLast": "Último"
                    },
                }
            };
        }


    }


})();

(function () {
  'use strict';

  angular
    .module('app.associado_externo', ['datatables', 'textAngular'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State



    $stateProvider.state('app.associado_externo_recadastro', {
      url: '/atualizacao/:idAssociado',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.associado_externo_recadastro': {
          templateUrl: 'app/main/associado_externo/views/cadastro_associado.html',
          controller: 'AssociadoExternoController as vm'
        }
      },
      bodyClass: 'associado_externo'
    });

    $stateProvider.state('app.associado_externo', {
      url: '/associado-externo',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.associado_externo': {
          templateUrl: 'app/main/associado_externo/views/cadastro_associado.html',
          controller: 'AssociadoExternoController as vm'
        }
      },
      bodyClass: 'associado_externo'
    });

    $translatePartialLoaderProvider.addPart('app/main/associado_externo');


  }

})();

(function () {
  "use strict";

  angular
    .module("app.associado_externo")
    .controller("AssociadoExternoController", AssociadoController);

  /** @ngInject */
  function AssociadoController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, $timeout, DTOptionsBuilder, $http, $rootScope) {
    var vm = this;
    vm.titulo = "Cadastrar Associado";
    $scope.localLoading = false;
    vm.isTelefoneAdicionado = true;
    vm.telefones = [];
    vm.dependentes = [];
    vm.produtos = {};
    $scope.localLoadingDependente = {};
    vm.usuarioDuplicado = false;
    vm.inAtivo = {};
    vm.dependenteEdicao = false;
    vm.indexEdicao = 0;
    vm.msWizard = {};
    vm.fotoAvatar = false;
    vm.selectedTab = 0;
    vm.pesquisaAssociado = {};
    vm.totalPaginas = 0;
    vm.paginaAtual = 1;
    vm.itensPorPagina = 10;
    vm.ordenacao = "pessoaFisica.noPessoa-ASC";
    vm.qtdDenpendente = [];
    vm.mostrarFormulario = 1;
    vm.idAssociado = null;


    vm.adicionaPagina = function (valor) {
      var totalPagina = vm.pesquisaAssociado.page_count;
      if ((vm.paginaAtual <= totalPagina) && vm.paginaAtual >= 1) {
        vm.paginaAtual = vm.paginaAtual + valor;
        vm.pesquisar(vm.paginaAtual);
      }
    }

    vm.ordenar = function (ordem) {
      vm.ordenacao = ordem;
      vm.pesquisar();
    }

    vm.mudatPageSize = function () {
      vm.paginaAtual = 1;
      vm.pesquisar();

    }

    vm.setWizard = function (msWizard) {
      if ($stateParams.selectedIndex == 1) {
        $timeout(function () {
          msWizard.selectedIndex = parseInt($stateParams.selectedIndex);
          msWizard.nextPage();
          angular.element('#tab2').triggerHandler('click');
        }, 3000);
      }

    }

    vm.incrementDependentes = function () {
      for (var i = 0; i <= 10; i++) {
        vm.qtdDenpendente.push(i);
      }
    }

    vm.init = function () {
      vm.associado = { dtFiliacao: moment().format('DD/MM/YYYY') };
      if (typeof $rootScope.pesquisa == 'undefined') {
        $rootScope.pesquisa = {};
      }
      if ($stateParams.idAssociado) {
        vm.preencherDadosAssociado();
      }
      vm.preencherCombos();
      vm.incrementDependentes();
    };

    vm.preencherDadosAssociado = function () {
      api.associado.get({
        "tpFuncionarioAsspen": false,
        "idAssociado": $stateParams.idAssociado
      }, function (response) {
        var dadosAssociado = response._embedded.associado[0];

        var nascimentoPai = null;
        var nascimentoMae = null;
        var nascimentoAssociado = null;
        var dtExpedicao = null;

        if (dadosAssociado.dtNascimentoMae) {
          nascimentoMae = moment(dadosAssociado.dtNascimentoMae.date).format('DD/MM/YYYY');
        }

        if (dadosAssociado.dtNascimentoPai) {
          nascimentoPai = moment(dadosAssociado.dtNascimentoPai.date).format('DD/MM/YYYY');
        }

        if (dadosAssociado._embedded.pessoaFisica.dtNascimento) {
          nascimentoAssociado = moment(dadosAssociado._embedded.pessoaFisica.dtNascimento.date).format('DD/MM/YYYY');
        }

        if (dadosAssociado._embedded.pessoaFisica.dtExpedicao) {
          dtExpedicao = moment(dadosAssociado._embedded.pessoaFisica.dtExpedicao.date).format('DD/MM/YYYY');
        }

        vm.associado = {
          "dtFiliacao": moment(dadosAssociado.dtFiliacao.date).format('DD/MM/YYYY'),
          "pessoaFisica": {
            "estadoExpeditor": dadosAssociado._embedded.pessoaFisica._embedded.estadoExpeditor.idEstado,
            "orgaoExpeditor": dadosAssociado._embedded.pessoaFisica._embedded.orgaoExpeditor.idOrgaoEmissor,
            "dtExpedicao": dtExpedicao,
            "dsMatricula": dadosAssociado._embedded.pessoaFisica.dsMatricula,
            "idPessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica,
            "nuCpf": dadosAssociado._embedded.pessoaFisica.nuCpf,
            "noPessoa": dadosAssociado._embedded.pessoaFisica.noPessoa,
            "dsRg": dadosAssociado._embedded.pessoaFisica.dsRg,
            "dtNascimento": nascimentoAssociado,
            "tpEstadoCivil": dadosAssociado._embedded.pessoaFisica.tpEstadoCivil,
            "dsEmail": dadosAssociado._embedded.pessoaFisica.dsEmail,
            "tpSexo": dadosAssociado._embedded.pessoaFisica.tpSexo
          },
          "dsMatriculaFuncional": dadosAssociado.dsMatriculaFuncional,
          "inConjugeServidor": dadosAssociado.inConjugeServidor,
          "noConjuge": dadosAssociado.noConjuge,
          "noGuerra": dadosAssociado.noGuerra,
          "cargoAssociado": dadosAssociado._embedded.cargoAssociado ? dadosAssociado._embedded.cargoAssociado.idCargoAssociado : null,
          "lotacaoAssociado": dadosAssociado._embedded.lotacaoAssociado ? dadosAssociado._embedded.lotacaoAssociado.idLotacaoAssociado : null,
          "noMae": dadosAssociado.noMae,
          "dtNascimentoMae": nascimentoMae,
          "noPai": dadosAssociado.noPai,
          "dtNascimentoPai": nascimentoPai
        };

        //faz a mascara de matricula ao preencher a tela
        vm.mascararMatricula();


        if (dadosAssociado.dtNascimentoConjuge) {
          vm.associado.dtNascimentoConjuge = moment(dadosAssociado.dtNascimentoConjuge.date).format('DD/MM/YYYY');
        }

        api.pessoa.get({ "idPessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica }, function (response) {
          vm.associado.pessoaFisica.username = response._embedded.pessoa[0].username;
        }, function (responseError) {
          console.log(responseError.data.detail);
        });

        api.endereco.get({ "pessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica }, function (response) {
          vm.endereco = response._embedded.endereco[0];
        }, function (responseError) {
          console.log(responseError.data.detail);
        });


        api.telefone.get({ "pessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica }, function (response) {
          vm.telefones = response._embedded.telefone;
        }, function (responseError) {
          console.log(responseError.data.detail);
        });


        api.dependente.get({ "associado": dadosAssociado.idAssociado }, function (response) {
          var dependenteLoop = response._embedded.dependente;
          angular.forEach(dependenteLoop, function (dado, chave) {
            console.log('Teste ' + chave);
            var dependenteAtual = {
              "idDependente": dado.idDependente,
              "noDependente": dado.noDependente,
              "tpParentesco": dado.tpParentesco
            };
            if (dado.dtNascimento) {
              dependenteAtual.dtNasciment = moment(dado.dtNascimento.date).format("DD/MM/YYYY")
            }
            vm.dependentes.push(dependenteAtual);

          })
        }, function (responseError) {
          console.log(responseError.data.detail);
        });

        api.convenioAssociado.get({ "associado": dadosAssociado.idAssociado }, function (response) {
          var produtosArray = response._embedded.conveio_associado;

          produtosArray.forEach(function (value) {
            vm.produtos[value.produto.idProduto] = {
              'valor': true,
              'tipoPagamento': value.tpPagamento,
              'nuDependentes': value.nuDependentes,
              'data': moment(value.dtVinculo.date).format("DD/MM/YYYY")
            };
          });
        }, function (responseError) {
          console.log(responseError.data.detail);
        });


        $scope.localLoading = false;
      }, function (responseError) {
        console.log(responseError.data.detail);
        $scope.localLoading = false;
      });
    }

    vm.isAssociadoCadastrado = function () {
      if (vm.associado.pessoaFisica.nuCpf) {
        api.associadoExterno.get({ cpf: vm.associado.pessoaFisica.nuCpf }, function (response) {
          $scope.localLoading = false;
          if (response.isCadastrado) {
            vm.mostrarFormulario = 3;
          }
        }, function (responseError) {
          console.log(responseError.data.detail);
        });
      }
    }

    vm.cadastrarTelefone = function () {
      if (vm.telefone && !vm.inTelefoneCadastrado(vm.telefone, vm.telefones)) {
        vm.telefones.push({ "dsTelefone": vm.telefone });
        vm.telefone = "";
      }
    }


    vm.cadastrarDependente = function () {
      if (vm.dependente.tpParentesco && !vm.inDependente(vm.dependente.noDependente, vm.dependentes)) {
        vm.dependentes.push({
          "noDependente": vm.dependente.noDependente,
          "dtNascimento": vm.dependente.dtNascimento,
          "tpParentesco": vm.dependente.tpParentesco
        });

        vm.dependente.noDependente = "";
        vm.dependente.dtNascimento = "";
        vm.dependente.tpParentesco = "";
      }
    }

    vm.inTelefoneCadastrado = function (needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i].dsTelefone == needle) {
          return true;
        }
      }
      return false;
    }

    vm.inDependente = function (needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i].noDependente == needle) {
          return true;
        }
      }
      return false;
    }

    vm.preencherCombos = function () {

      api.orgaoExpeditor.get({}, function (response) {
        vm.orgaoExpeditor = response._embedded.orgao_expeditor;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });


      api.estado.get({}, function (response) {
        vm.estados = response._embedded.uf;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });


      api.cargoAssociado.get({}, function (response) {
        vm.cargoAssociado = response._embedded.cargo_associado;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });

      api.lotacaoAssociado.get({}, function (response) {
        vm.lotacaoAssociado = response._embedded.lotacao_associado;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });


      api.convenio.get({}, function (response) {
        vm.convenios = response._embedded.convenio;
        console.log(vm.convenios);
      }, function (responseError) {
        console.log(responseError.data.detail);
      });

      vm.parentesco = [
        {
          "noParentesco": "Pai",
          "tpParentesco": "P"
        },
        {
          "noParentesco": "Mãe",
          "tpParentesco": "M"
        },
        {
          "noParentesco": "Filho(a)",
          "tpParentesco": "F"
        },
        {
          "noParentesco": "Cônjuge",
          "tpParentesco": "C"
        }
      ];

    };

    vm.salvarAssociadoExterno = function () {
      var payload = {
        "associado": vm.associado,
        "dependentes": vm.dependentes,
        "telefones": vm.telefones,
        "endereco": vm.endereco,
        "produtos": vm.produtos
      };

      if( vm.telefones.length < 1){
        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
              '<span class="md-toast-content md-red-400-bg">' +
              'É necessário cadastrar ao menos um telefone de contato' +
              '</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
        return;
      }
      $rootScope.loadingProgress = true;
      if ($stateParams.idAssociado) {
        api.associadoExterno.update({ associado_id: $stateParams.idAssociado, idAssociado: $stateParams.idAssociado }, payload, function (response) {
          console.log('response')
          console.log(response)
          console.log(response)
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Seu cadstro foi atualizado com sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          vm.mostrarFormulario = 4;

          $rootScope.loadingProgress = false;
        }, function (responseError) {
          var mensagemErro = "Não foi possível salvar os dados, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
          if (responseError.data.status == 406 || responseError.data.status == 412) {
            mensagemErro = responseError.data.detail;
          }

          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                '<span class="md-toast-content md-red-400-bg">' +
                mensagemErro +
                '</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          $rootScope.loadingProgress = false;
        });

      } else {
        api.associadoExterno.save(payload, function (response) {
          $scope.uploadFoto(response.idAssociadoExterno);

          $timeout(function () {
            $mdToast.show(
              {
                template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                  '<span class="md-toast-content md-green-400-bg">Associado Cadastrado com sucesso</span>' +
                  '</md-toast>',
                hideDelay: 3000,
                position: 'top right'
              }
            );
            //
            $rootScope.loadingProgress = false;
            vm.mostrarFormulario = 2;
          }, 3000);


        }, function (responseError) {
          var mensagemErro = "Não foi possível Salvar o Associado, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
          if (responseError.data.status == 406 || responseError.data.status == 412) {
            mensagemErro = responseError.data.detail;
          }

          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                '<span class="md-toast-content md-red-400-bg">' +
                mensagemErro +
                '</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          $rootScope.loadingProgress = false;
        });
      }



    }

    vm.showConfirmTelefone = function (ev, telefone, index) {
      var mensagem = "Deseja realmente remover o telefone?"
      var confirmacao = function () {
        //caso o telefone ainda não esteja na base de dados
        if (!telefone.idTelefone) {
          return vm.telefones.splice(index, 1);
        }
        api.telefone.delete({ "idTelefone": telefone.idTelefone }, function (response) {
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Telefone Removido com sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          return vm.telefones.splice(index, 1);

        }, function (responseError) {
          console.log(responseError.data.detail);
        });
      };

      vm.confirmTemplate(mensagem, confirmacao, ev);

    };

    vm.showConfirmDependente = function (ev, dependente, index) {
      var mensagem = "Deseja realmente remover o dependente?"
      var confirmacao = function () {
        $scope.localLoadingDependente[index] = true;
        //caso o dependente ainda não esteja na base de dados
        if (!dependente.idDependente) {
          $scope.localLoadingDependente[index] = false;
          return vm.dependentes.splice(index, 1);

        }
        api.dependente.delete({ "idDependente": dependente.idDependente }, function (response) {
          $scope.localLoadingDependente[index] = false;
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Dependente removido com sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          vm.dependentes.splice(index, 1);
        }, function (responseError) {
          $scope.localLoadingDependente[index] = false;
          console.log(responseError.data.detail);
        });
      };

      vm.confirmTemplate(mensagem, confirmacao, ev);

    };

    vm.confirmTemplate = function (mensagem, callBackSim, ev) {
      var confirm = $mdDialog.confirm()
        .title('Confirmação')
        .textContent(mensagem)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('Sim')
        .cancel('Não');
      $mdDialog.show(confirm).then(callBackSim);
    }


    /*
     * Abre a modal de desativar o usuario
     *
     */
    $scope.perguntasDesativar = {
      processo: false,
      convenios: false
    };
    $scope.motivo = null;
    $scope.motivoDissociacao = [
      { idMotivo: 1, dsMotivo: 'Solicitação' },
      { idMotivo: 2, dsMotivo: 'Exoneração' },
      { idMotivo: 3, dsMotivo: 'Falecimento' },
      { idMotivo: 4, dsMotivo: 'Aposentadoria' },
    ];
    // $rootScope.associadoDesativar = null;


    vm.validarUsuarioDuplicado = function (username) {
      vm.usuarioDuplicado = false;
      if (username) {
        api.pessoa.get({ "username": username }, function (response) {
          if (response._embedded.pessoa.length > 0 && !$stateParams.idPessoaFisica) {
            vm.usuarioDuplicado = true;
          } else if (response._embedded.pessoa.length > 0 && $stateParams.idPessoaFisica != response._embedded.pessoa._embedded[0].idPessoaFisica) {
            vm.usuarioDuplicado = true;
          }
          // vm.pessoas = response._embedded.pessoa;
          console.log(response);
        }, function (responseError) {
          console.log(responseError.data.detail);
        });
      }
    }


    $scope.uploadFoto = function (idAssociado) {
      if (vm.foto.noArquivo[0] != undefined && idAssociado != undefined) {
        var fd = new FormData();
        fd.append('arquivo', vm.foto.noArquivo[0].lfFile);
        fd.append('id', idAssociado);
        vm.postarFoto(fd, idAssociado);
      }

    }

    vm.postarFoto = function (dadosPost) {
      $scope.loadingScreen = true;
      //adiciona um novo cardapio
      $http.post(api.baseUrl + 'upload-foto', dadosPost, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      }).then(function (result) {
        console.log('>>>>>>>>>>>>>>>>')
        console.log(result)
        console.log('>>>>>>>>>>>>>>>>')
      }, function (err) {
        console.log(err);
      });
    }

    vm.mascararMatricula = function () {
      var matricula = vm.associado.dsMatriculaFuncional;
      matricula = matricula.replace("-", "");
      matricula = matricula.replace(".", "");
      matricula = matricula.replace(".", "");
      matricula = matricula.padStart(8, "0");

      var mascara = "-";
      var position = 7;
      var output = [matricula.slice(0, position), mascara, matricula.slice(position)].join('');

      mascara = '.';
      position = 4;
      output = [output.slice(0, position), mascara, output.slice(position)].join('');

      position = 1;
      output = [output.slice(0, position), mascara, output.slice(position)].join('');

      vm.associado.dsMatriculaFuncional = output;
    }

    vm.preencherDependenteEdicao = function (dependente, index) {
      vm.dependenteEdicao = true;
      vm.indexEdicao = index;
      vm.dependente = dependente;

      vm.dependentes.splice(index, 1);
    }


    vm.editarDependente = function () {
      //caso o dependente ainda não esteja na base de dados
      var dadosDependente = {
        "noDependente": vm.dependente.noDependente,
        "dtNascimento": vm.dependente.dtNascimento,
        "tpParentesco": vm.dependente.tpParentesco
      };

      if (vm.dependente.idDependente) {
        dadosDependente['idDependente'] = vm.dependente.idDependente;
      }

      //removendo indice anterior
      //Adicionando o editado
      vm.dependentes.splice(vm.indexEdicao + 1, 0, dadosDependente);

      $mdToast.show(
        {
          template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
            '<span class="md-toast-content md-green-400-bg">Dados Alterados. Salve para persistir as informações</span>' +
            '</md-toast>',
          hideDelay: 3000,
          position: 'top right'
        }
      );

      vm.dependenteEdicao = false;
      vm.indexEdicao = -1;

      vm.dependente.noDependente = "";
      vm.dependente.dtNascimento = "";
      vm.dependente.tpParentesco = "";
    }

    vm.uploadFoto = function (idAssociadoExterno) {
      if (vm.foto.noArquivo[0] != undefined && idAssociadoExterno != undefined) {
        var fd = new FormData();
        fd.append('arquivo', vm.foto.noArquivo[0].lfFile);
        fd.append('id', idAssociadoExterno);
        vm.postarFoto(fd, idAssociadoExterno);
      }

    }


    vm.postarFoto = function (dadosPost) {
      $scope.loadingScreen = true;
      //adiciona um novo cardapio
      $http.post(api.baseUrl + 'upload-foto', dadosPost, {
        headers: { 'Content-Type': undefined }
      }).then(function (result) {
        console.log(result)
      }, function (err) {
        console.error(result)
      });
    }


    vm.sairSemSalvar = function () {
      $state.go('app.associado');
    }
    // faz download de um cadapio dentro da tela de edicao
    $scope.verFoto = function (idPessoaFisica) {
      $http({
        url: api.baseUrl + 'associado/arquivo/' + idPessoaFisica,
        method: "GET",
        params: {}
      }).then(function successCallback(response) {
        if (response.data.file != null) {
          vm.fotoAvatar = "data:" + response.data.contentType + ";base64," + response.data.file;
        }
      }, function errorCallback(response) {

        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
              '<span class="md-toast-content md-red-400-bg">' +
              'Desculpe, houve um erro ao carregar a foto, Contate os Administradores!' +
              '</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
      });

    }

  }

})();

(function () {
    'use strict';

    angular
        .module('app.associado')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, $timeout, DTOptionsBuilder, $http, $element) {
        var vm = this;
        vm.titulo = "Dashboard";
        vm.associadosAtivos = 0;
        vm.associadosInativos = 0;
        $scope.localLoading = false;
        $scope.localLoadingSave = false;
        vm.comunicado = {};
        vm.aniversariantes = {};

        vm.init = function () {
          vm.listarAniversariante();
          vm.listarAtivos();
          vm.listarInativos();
        };

        vm.listarAniversariante = function(){
          //
          api.associadoAniversariante.get({}, function (response) {
          vm.aniversariantes = response._embedded.associado_aniversariante;
        }, function (responseError) {
            console.log(responseError.data.detail);
        });

        }

        vm.listarAtivos = function(){
          api.associado.get({pageSize:1,inAtivo:true}, function (response) {
            vm.associadosAtivos = response.total_items;
            $scope.localLoading = false;
        }, function (responseError) {
            $scope.localLoading = false;
            console.log(responseError.data.detail);
        });
        }

        vm.listarInativos = function(){
          api.associado.get({pageSize:1,inAtivo:false}, function (response) {
            vm.associadosInativos = response.total_items;
            console.log(response);
        }, function (responseError) {
            $scope.localLoading = false;
            console.log(responseError.data.detail);
        });
        }



    }


})();

(function () {
  'use strict';

  angular
    .module('app.associado')
    .controller('AssociadoController', AssociadoController);

  /** @ngInject */
  function AssociadoController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, $timeout, DTOptionsBuilder, $http, $rootScope) {
    var vm = this;
    vm.titulo = "Cadastrar Associado";
    $scope.localLoading = false;
    vm.isTelefoneAdicionado = true;
    vm.telefones = [];
    vm.dependentes = [];
    vm.produtos = {};
    $scope.localLoadingDependente = {};
    vm.usuarioDuplicado = false;
    vm.inAtivo = {};
    vm.dependenteEdicao = false;
    vm.indexEdicao = 0;
    vm.msWizard = {};
    vm.fotoAvatar = false;
    vm.selectedTab = 0;
    vm.pesquisaAssociado = {};
    vm.totalPaginas = 0;
    vm.paginaAtual = 1;
    vm.itensPorPagina = 10;
    vm.ordenacao = "pessoaFisica.noPessoa-ASC";
    vm.qtdDenpendente = [];
    vm.associadoExternoPesquisa = {};
    vm.resultadoAssociadoExterno = [];
    vm.associadoExternoAprovacao = {};

    vm.tratarDataParaBr = function (data) {
      return moment(data).format('DD/MM/YYYY');
    }


    vm.adicionaPagina = function (valor) {
      var totalPagina = vm.pesquisaAssociado.page_count;
      if ((vm.paginaAtual <= totalPagina) && vm.paginaAtual >= 1) {
        vm.paginaAtual = vm.paginaAtual + valor;
        vm.pesquisar(vm.paginaAtual);
      }
    }

    vm.ordenar = function (ordem) {
      vm.ordenacao = ordem;
      vm.pesquisar();
    }

    vm.mudatPageSize = function () {
      vm.paginaAtual = 1;
      vm.pesquisar();

    }

    vm.setWizard = function (msWizard) {
      if ($stateParams.selectedIndex == 1) {
        $timeout(function () {
          msWizard.selectedIndex = parseInt($stateParams.selectedIndex);
          msWizard.nextPage();
          angular.element('#tab2').triggerHandler('click');
        }, 3000);
      }

    }

    vm.incrementDependentes = function () {
      for (var i = 0; i <= 10; i++) {
        vm.qtdDenpendente.push(i);
      }
    }

    vm.init = function () {
      vm.associado = { dtFiliacao: moment().format('DD/MM/YYYY') };
      if (typeof $rootScope.pesquisa == 'undefined') {
        $rootScope.pesquisa = {};
      }
      vm.preencherCombos();
      vm.incrementDependentes();
    };
    vm.idAssociado = null;

    vm.obterDados = function () {

      if ($stateParams.selectedIndex) {
        vm.selectedTab = $stateParams.selectedIndex;
      }
      if ($stateParams.idAssociado) {
        vm.titulo = "Editar Associado";
        $scope.localLoading = true;
        vm.idAssociado = $stateParams.idAssociado;
        api.associado.get({
          "tpFuncionarioAsspen": false,
          "idAssociado": $stateParams.idAssociado
        }, function (response) {
          var dadosAssociado = response._embedded.associado[0];

          var nascimentoPai = null;
          var nascimentoMae = null;
          var nascimentoAssociado = null;
          var dtExpedicao = null;

          if (dadosAssociado.dtNascimentoMae) {
            nascimentoMae = moment(dadosAssociado.dtNascimentoMae.date).format('DD/MM/YYYY');
          }

          if (dadosAssociado.dtNascimentoPai) {
            nascimentoPai = moment(dadosAssociado.dtNascimentoPai.date).format('DD/MM/YYYY');
          }

          if (dadosAssociado._embedded.pessoaFisica.dtNascimento) {
            nascimentoAssociado = moment(dadosAssociado._embedded.pessoaFisica.dtNascimento.date).format('DD/MM/YYYY');
          }

          if (dadosAssociado._embedded.pessoaFisica.dtExpedicao) {
            dtExpedicao = moment(dadosAssociado._embedded.pessoaFisica.dtExpedicao.date).format('DD/MM/YYYY');
          }

          vm.associado = {
            "dtFiliacao": moment(dadosAssociado.dtFiliacao.date).format('DD/MM/YYYY'),
            "pessoaFisica": {
              "estadoExpeditor": dadosAssociado._embedded.pessoaFisica._embedded.estadoExpeditor.idEstado,
              "orgaoExpeditor": dadosAssociado._embedded.pessoaFisica._embedded.orgaoExpeditor.idOrgaoEmissor,
              "dtExpedicao": dtExpedicao,
              "dsMatricula": dadosAssociado._embedded.pessoaFisica.dsMatricula,
              "idPessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica,
              "nuCpf": dadosAssociado._embedded.pessoaFisica.nuCpf,
              "noPessoa": dadosAssociado._embedded.pessoaFisica.noPessoa,
              "dsRg": dadosAssociado._embedded.pessoaFisica.dsRg,
              "dtNascimento": nascimentoAssociado,
              "tpEstadoCivil": dadosAssociado._embedded.pessoaFisica.tpEstadoCivil,
              "dsEmail": dadosAssociado._embedded.pessoaFisica.dsEmail,
              "tpSexo": dadosAssociado._embedded.pessoaFisica.tpSexo
            },
            "dsMatriculaFuncional": dadosAssociado.dsMatriculaFuncional,
            "inConjugeServidor": dadosAssociado.inConjugeServidor,
            "noConjuge": dadosAssociado.noConjuge,
            "noGuerra": dadosAssociado.noGuerra,
            "cargoAssociado": dadosAssociado._embedded.cargoAssociado ? dadosAssociado._embedded.cargoAssociado.idCargoAssociado : null,
            "lotacaoAssociado": dadosAssociado._embedded.lotacaoAssociado ? dadosAssociado._embedded.lotacaoAssociado.idLotacaoAssociado : null,
            "noMae": dadosAssociado.noMae,
            "dtNascimentoMae": nascimentoMae,
            "noPai": dadosAssociado.noPai,
            "dtNascimentoPai": nascimentoPai
          };

          //faz a mascara de matricula ao preencher a tela
          vm.mascararMatricula();


          if (dadosAssociado.dtNascimentoConjuge) {
            vm.associado.dtNascimentoConjuge = moment(dadosAssociado.dtNascimentoConjuge.date).format('DD/MM/YYYY');
          }

          $scope.verFoto(dadosAssociado._embedded.pessoaFisica.idPessoaFisica);

          api.pessoa.get({ "idPessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica }, function (response) {
            vm.associado.pessoaFisica.username = response._embedded.pessoa[0].username;
          }, function (responseError) {
            console.log(responseError.data.detail);
          });

          api.endereco.get({ "pessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica }, function (response) {
            vm.endereco = response._embedded.endereco[0];
          }, function (responseError) {
            console.log(responseError.data.detail);
          });


          api.telefone.get({ "pessoaFisica": dadosAssociado._embedded.pessoaFisica.idPessoaFisica }, function (response) {
            vm.telefones = response._embedded.telefone;
          }, function (responseError) {
            console.log(responseError.data.detail);
          });


          api.dependente.get({ "associado": dadosAssociado.idAssociado }, function (response) {
            var dependenteLoop = response._embedded.dependente;
            angular.forEach(dependenteLoop, function (dado, chave) {
              console.log('Teste ' + chave);
              var dependenteAtual = {
                "idDependente": dado.idDependente,
                "noDependente": dado.noDependente,
                "tpParentesco": dado.tpParentesco
              };
              if (dado.dtNascimento) {
                dependenteAtual.dtNasciment = moment(dado.dtNascimento.date).format("DD/MM/YYYY")
              }
              vm.dependentes.push(dependenteAtual);

            })
          }, function (responseError) {
            console.log(responseError.data.detail);
          });

          api.convenioAssociado.get({ "associado": dadosAssociado.idAssociado }, function (response) {
            var produtosArray = response._embedded.conveio_associado;

            produtosArray.forEach(function (value) {
              vm.produtos[value.produto.idProduto] = {
                'valor': true,
                'tipoPagamento': value.tpPagamento,
                'nuDependentes': value.nuDependentes,
                'data': moment(value.dtVinculo.date).format("DD/MM/YYYY")
              };
            });
          }, function (responseError) {
            console.log(responseError.data.detail);
          });


          $scope.localLoading = false;
        }, function (responseError) {
          console.log(responseError.data.detail);
          $scope.localLoading = false;
        });
      }
    }

    vm.preencherDataTable = function () {
      vm.dtOptions = {
        dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        autoWidth: true,
        responsive: true,
        bFilter: false,
        "language": {
          "lengthMenu": "Mostra  _MENU_ registros por página",
          "zeroRecords": "Não há registros",
          "info": "Página _PAGE_ de _PAGES_",
          "infoEmpty": "Não há registros",
          "infoFiltered": "(filtered from _MAX_ total records)",
          'search': "Buscar",
          'searchPlaceholder': "Buscar",
          "oPaginate": {
            "sNext": "Próximo",
            "sPrevious": "Anterior",
            "sFirst": "Primeiro",
            "sLast": "Último"
          },
        }
      };
    }


    vm.cadastrarTelefone = function () {
      if (vm.telefone && !vm.inTelefoneCadastrado(vm.telefone, vm.telefones)) {
        vm.telefones.push({ "dsTelefone": vm.telefone });
        vm.telefone = "";
      }
    }


    vm.cadastrarDependente = function () {
      if (vm.dependente.tpParentesco && !vm.inDependente(vm.dependente.noDependente, vm.dependentes)) {
        vm.dependentes.push({
          "noDependente": vm.dependente.noDependente,
          "dtNascimento": vm.dependente.dtNascimento,
          "tpParentesco": vm.dependente.tpParentesco
        });

        vm.dependente.noDependente = "";
        vm.dependente.dtNascimento = "";
        vm.dependente.tpParentesco = "";
      }
    }

    vm.inTelefoneCadastrado = function (needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i].dsTelefone == needle) {
          return true;
        }
      }
      return false;
    }

    vm.inDependente = function (needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i].noDependente == needle) {
          return true;
        }
      }
      return false;
    }

    vm.preencherCombos = function () {

      api.orgaoExpeditor.get({}, function (response) {
        vm.orgaoExpeditor = response._embedded.orgao_expeditor;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });


      api.estado.get({}, function (response) {
        vm.estados = response._embedded.uf;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });


      api.cargoAssociado.get({}, function (response) {
        vm.cargoAssociado = response._embedded.cargo_associado;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });

      api.lotacaoAssociado.get({}, function (response) {
        vm.lotacaoAssociado = response._embedded.lotacao_associado;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });


      api.convenio.get({}, function (response) {
        vm.convenios = response._embedded.convenio;
        console.log(vm.convenios);
      }, function (responseError) {
        console.log(responseError.data.detail);
      });

      vm.parentesco = [
        {
          "noParentesco": "Pai",
          "tpParentesco": "P"
        },
        {
          "noParentesco": "Mãe",
          "tpParentesco": "M"
        },
        {
          "noParentesco": "Filho(a)",
          "tpParentesco": "F"
        },
        {
          "noParentesco": "Cônjuge",
          "tpParentesco": "C"
        }
      ];

    };

    vm.cadastrarAssociado = function (redirect) {
      var payload = {
        "associado": vm.associado,
        "dependentes": vm.dependentes,
        "telefones": vm.telefones,
        "endereco": vm.endereco,
        "produtos": vm.produtos
      };
      $scope.localLoading = true;
      if ($stateParams.idAssociado) {
        if (!payload.inAtivo) {
          payload.inAtivo = 0;
        }
        api.associado.update({
          idAssociadoEditar: $stateParams.idAssociado
        }, payload, function (response) {
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Associado Salvo com Sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          vm.uploadFoto(response.idAssociado);
          $scope.localLoading = false;
          if (redirect == true) {
            $state.go('app.associado.ficha', { idAssociado: response.idAssociado });
          }
        }, function (responseError) {
          var mensagemErro = "Não foi possível Salvar o Usuário, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
          if (responseError.data.status == 406 || responseError.data.status == 412) {
            mensagemErro = responseError.data.detail;
          }
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                '<span class="md-toast-content md-red-400-bg">' +
                mensagemErro +
                '</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );

          $scope.localLoading = false;

        });
      } else {
        api.associado.save(payload, function (response) {
          vm.uploadFoto(response.idAssociado);
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Associado Cadastrado com sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          //
          $scope.localLoading = false;
          $state.go('app.associado.edit', { idAssociado: response.idAssociado, selectedIndex: 1 });
        }, function (responseError) {
          var mensagemErro = "Não foi possível Salvar o Associado, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
          if (responseError.data.status == 406 || responseError.data.status == 412) {
            mensagemErro = responseError.data.detail;
          }

          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                '<span class="md-toast-content md-red-400-bg">' +
                mensagemErro +
                '</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          $scope.localLoading = false;
        });
      }


    }

    vm.showConfirmTelefone = function (ev, telefone, index) {
      var mensagem = "Deseja realmente remover o telefone?"
      var confirmacao = function () {
        //caso o telefone ainda não esteja na base de dados
        if (!telefone.idTelefone) {
          return vm.telefones.splice(index, 1);
        }
        api.telefone.delete({ "idTelefone": telefone.idTelefone }, function (response) {
          return vm.telefones.splice(index, 1);
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Telefone Removido com sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );

        }, function (responseError) {
          console.log(responseError.data.detail);
        });
      };

      vm.confirmTemplate(mensagem, confirmacao, ev);

    };

    vm.showConfirmDependente = function (ev, dependente, index) {
      var mensagem = "Deseja realmente remover o dependente?"
      var confirmacao = function () {
        $scope.localLoadingDependente[index] = true;
        //caso o dependente ainda não esteja na base de dados
        if (!dependente.idDependente) {
          $scope.localLoadingDependente[index] = false;
          return vm.dependentes.splice(index, 1);

        }
        api.dependente.delete({ "idDependente": dependente.idDependente }, function (response) {
          $scope.localLoadingDependente[index] = false;
          $mdToast.show(
            {
              template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                '<span class="md-toast-content md-green-400-bg">Dependente removido com sucesso</span>' +
                '</md-toast>',
              hideDelay: 3000,
              position: 'top right'
            }
          );
          vm.dependentes.splice(index, 1);
        }, function (responseError) {
          $scope.localLoadingDependente[index] = false;
          console.log(responseError.data.detail);
        });
      };

      vm.confirmTemplate(mensagem, confirmacao, ev);

    };

    vm.confirmTemplate = function (mensagem, callBackSim, ev) {
      var confirm = $mdDialog.confirm()
        .title('Confirmação')
        .textContent(mensagem)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('Sim')
        .cancel('Não');
      $mdDialog.show(confirm).then(callBackSim);
    }


    /*
     * Abre a modal de desativar o usuario
     *
     */
    $scope.perguntasDesativar = {
      processo: false,
      convenios: false
    };
    $scope.motivo = null;
    $scope.motivoDissociacao = [
      { idMotivo: 1, dsMotivo: 'Solicitação' },
      { idMotivo: 2, dsMotivo: 'Exoneração' },
      { idMotivo: 3, dsMotivo: 'Falecimento' },
      { idMotivo: 4, dsMotivo: 'Aposentadoria' },
    ];
    // $rootScope.associadoDesativar = null;

    vm.modalDesativar = function (event, associado) {
      var host = window.location.host;
      var protocol = window.location.protocol;

      $rootScope.associadoDesativar = associado;
      $mdDialog.show({
        controller: AssociadoController,
        // templateUrl: protocol+"//"+host+"/app/main/associado/views/modal-desativar.html",
        template: '<div class="simple-table-container md-whiteframe-4dp" style="height: 100%">\n' +
          '    <div class="content">\n' +
          '        <div layout-wrap layout-gt-sm="row">\n' +
          '            <div class="table-title">Antes de desativar você cofirma que:</div>\n' +
          '            <div flex="100" style="padding-left: 35px;">\n' +
          '               <div class="row">\n' +
          '                   <md-input-container>\n' +
          '                       <md-checkbox ng-model="perguntasDesativar.processo"\n' +
          '                                    aria-label=" O associado não tem processos jurídicos vínculados a ASSPEN.">\n' +
          '                           O associado não tem processos jurídicos vínculados a ASSPEN.\n' +
          '                       </md-checkbox>\n' +
          '                   </md-input-container>\n' +
          '               </div>\n' +
          '               <div class="row">\n' +
          '                   <md-input-container>\n' +
          '                       <md-checkbox ng-model="perguntasDesativar.convenios"\n' +
          '                                    aria-label=" O associado não tem processos jurídicos vínculados a ASSPEN.">\n' +
          '                           Desvinculou o associado dos convênios.\n' +
          '                       </md-checkbox>\n' +
          '                   </md-input-container>\n' +
          '               </div>\n' +
          '            </div>\n' +
          '        </div>\n' +
          '        <div layout-wrap layout-gt-sm="row">\n' +
          '            <div class="table-title">Qual o motivo da dissociação?</div>\n' +
          '            <div flex="100"  style="padding-left: 35px;">\n' +
          '                <md-input-container>\n' +
          '                    <md-select ng-model="motivo"\n' +
          '                               name="motivo"\n' +
          '                               placeholder="Motivos da dissociação"\n' +
          '                               required>\n' +
          '                        <md-option ng-repeat="motivo in motivoDissociacao" value="{{motivo.idMotivo}}">\n' +
          '                            {{motivo.dsMotivo}}\n' +
          '                        </md-option>\n' +
          '                    </md-select>\n' +
          '                </md-input-container>\n' +
          '            </div>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="navigation" flex layout="row" layout-align="left center" style="padding-left: 25px;padding-bottom: 25px;">\n' +
          '            <md-button class="md-raised md-warn" ng-click="desativarOuAtivar();" ng-disabled="perguntasDesativar.processo == false || perguntasDesativar.convenios == false || motivo == null">\n' +
          '                Desativar\n' +
          '            </md-button>\n' +
          '            <md-button class="md-raised md-accent" ng-click="cancelarDesativacao();">\n' +
          '                Cancelar\n' +
          '            </md-button>\n' +
          '        </div>\n' +
          '\n' +
          '    </div>\n' +
          '</div>',
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
      });
    }

    $scope.desativarAssociado = function (associado) {
      vm.desativarOuAtivar(associado);
    };

    $scope.cancelarDesativacao = function () {
      $mdDialog.hide();
    };

    vm.desativarOuAtivar = function (associado) {
      if (!associado) {
        associado = $rootScope.associadoDesativar;
      }

      var dados = {
        inAtivo: 0
      }

      var pessoa = associado._embedded.pessoaFisica;
      if (associado._embedded.pessoaFisica.inAtivo) {
        associado._embedded.pessoaFisica.inAtivo = false;
        vm.inAtivo[associado._embedded.pessoaFisica.idPessoaFisica] = false;
        dados.inAtivo = 0;
      } else {
        associado._embedded.pessoaFisica.inAtivo = true;
        vm.inAtivo[associado._embedded.pessoaFisica.idPessoaFisica] = true;
        dados.inAtivo = 1;
      }


      var msg = "Desativado";
      if (vm.inAtivo[pessoa.idPessoaFisica]) {
        var msg = "Ativado";
      }

      api.pessoa.delete({ idPessoa: pessoa.idPessoaFisica + '*' + $scope.motivo }, dados, function (response) {
        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
              '<span class="md-toast-content md-green-400-bg"> ' + pessoa.noPessoa + ' ' + msg + ' com sucesso</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
        $scope.perguntasDesativar = {
          processo: false,
          convenios: false
        };
        $mdDialog.hide();
        $scope.motivo = null;
        $rootScope.associadoDesativar = null;
      }, function (responseError) {
        console.log(responseError.data.detail);
      });
    }

    $scope.desativarOuAtivar = vm.desativarOuAtivar;

    vm.validarUsuarioDuplicado = function (username) {
      vm.usuarioDuplicado = false;
      if (username) {
        api.pessoa.get({ "username": username }, function (response) {
          if (response._embedded.pessoa.length > 0 && !$stateParams.idPessoaFisica) {
            vm.usuarioDuplicado = true;
          } else if (response._embedded.pessoa.length > 0 && $stateParams.idPessoaFisica != response._embedded.pessoa._embedded[0].idPessoaFisica) {
            vm.usuarioDuplicado = true;
          }
          // vm.pessoas = response._embedded.pessoa;
          console.log(response);
        }, function (responseError) {
          console.log(responseError.data.detail);
        });
      }
    }

    vm.pesquisarAssociadoExterno = function () {
      api.associadoExternoAsspen.get({ associado_id: $stateParams.idAssociadoExterno }, function (response) {
        vm.resultadoAssociadoExterno = response;
        $scope.localLoading = false;
      }, function (responseError) {
        $scope.localLoading = false;
        console.log(responseError.data.detail);
      });
    }

    vm.visualizarAssociadoExterno = function (associadoExternoAsspen) {
      $state.go('app.listar_associado_externo.aprovar', { idAssociadoExterno: associadoExternoAsspen.idAssociadoExterno });

    }

    vm.carregarCadastroAssociadoExterno = function () {
      vm.preencherCombos();


      $scope.loadingTable = true;
      api.associadoExterno.get({ associado_id: $stateParams.idAssociadoExterno }, function (response) {
        $scope.loadingTable = false;
        console.log(response.dsDadosAssociado);
        vm.associadoExternoAprovacao = response.dsDadosAssociado;
        vm.enderecoExterno = response.dsDadosAssociado.endereco;
        vm.dependentesExterno = response.dsDadosAssociado.dependentes;
        vm.telefonesExterno = response.dsDadosAssociado.telefones;

        vm.idAssociadoExterno = $stateParams.idAssociadoExterno;
        console.log(vm.associadoExternoAprovacao);
      }, function (responseError) {
        $scope.loadingTable = false;
        console.log(responseError.data.detail);
      });
    }


    vm.cadastrarAssociadoExterno = function () {
      var payload = {
        "associado": vm.associadoExternoAprovacao.associado,
        "dependentes": vm.dependentesExterno,
        "telefones": vm.telefonesExterno,
        "endereco": vm.enderecoExterno,
        "idAssociadoExterno": $stateParams.idAssociadoExterno,
        "produtos": []
      };

      $scope.loadingTable = true;
      api.associadoExternoAdm.save(payload, function (response) {
        // vm.uploadFoto(response.idAssociado);
        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
              '<span class="md-toast-content md-green-400-bg">Associado Cadastrado com sucesso</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
        console.log('response associado externo>>>>>');
        console.log(response);
        console.log('response associado externo>>>>>');
        $scope.loadingTable = false;
        $state.go('app.associado.ficha', { idAssociado: response.idAssociado });
      }, function (responseError) {
        var mensagemErro = "Não foi possível Salvar o Associado, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
        if (responseError.data.status == 406 || responseError.data.status == 412) {
          mensagemErro = responseError.data.detail;
        }

        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
              '<span class="md-toast-content md-red-400-bg">' +
              mensagemErro +
              '</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
        $scope.loadingTable = false;
      });
    }

    vm.pesquisar = function (page) {
      console.log('------------------pesquisa');
      console.log($rootScope.pesquisa)
      console.log('------------------');

      if (typeof $rootScope.pesquisa == 'undefined') {
        $rootScope.pesquisa = {};
      }
      $scope.localLoading = true;
      $rootScope.pesquisa.pageSize = $rootScope.pesquisa.pageSize ? $rootScope.pesquisa.pageSize : vm.itensPorPagina;
      $rootScope.pesquisa.page = $rootScope.pesquisa.page ? $rootScope.pesquisa.page : 1;
      $rootScope.pesquisa.order = $rootScope.pesquisa.order ? $rootScope.pesquisa.order : vm.ordenacao;
      if (page) {
        $rootScope.pesquisa.page = page;
      }

      vm.paginaAtual = $rootScope.pesquisa.page;

      api.associado.get($rootScope.pesquisa, function (response) {
        vm.resultadoAssociado = response._embedded.associado;
        vm.pesquisaAssociado = response;
        $scope.localLoading = false;
      }, function (responseError) {
        $scope.localLoading = false;
        console.log(responseError.data.detail);
      });
    }

    vm.primeiraPagina = function () {
      vm.pesquisar(1);
    }

    vm.ultimaPagina = function () {
      vm.pesquisar(vm.pesquisaAssociado.page_count);
    }


    vm.getFicha = function () {
      var associado = {};
      associado.idAssociado = $stateParams.idAssociado;
      vm.idAssociado = $stateParams.idAssociado;
      $scope.localLoading = true;
      $http.get(api.baseUrl + 'associado/relatorio-ficha-matricula?idAssociado=' + $stateParams.idAssociado, associado, {
        transformRequest: angular.identity,
      }).then(function (result) {
        if (result.data.pdf) {
          var documento = 'data:application/pdf;base64,' + result.data.pdf;
          $scope.dataPdf = documento;
        }
        $scope.localLoading = false;
      }, function (err) {
        console.log(err);
      });
    };

    vm.uploadFoto = function (idAssociado) {
      if (vm.foto.noArquivo[0] != undefined && idAssociado != undefined) {
        var fd = new FormData();
        fd.append('arquivo', vm.foto.noArquivo[0].lfFile);
        fd.append('idAssociado', idAssociado);
        fd.append('isAssociado', true);
        vm.postarFoto(fd, idAssociado);
      }

    }

    vm.postarFoto = function (dadosPost, idAssociado) {
      $scope.loadingScreen = true;
      //adiciona um novo cardapio
      $http.post(api.baseUrl + 'associado/arquivo', dadosPost, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      }).then(function (result) {
        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
              '<span class="md-toast-content md-green-400-bg">Associado Salvo com Sucesso</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
        $scope.loadingScreen = false;
      }, function (err) {
        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
              '<span class="md-toast-content md-red-400-bg">' +
              'Houve um erro ao fazer upload da foto' +
              '</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );

        $scope.loadingScreen = false;
        console.log(err);
      });
    }

    vm.mascararMatricula = function () {
      var matricula = vm.associado.dsMatriculaFuncional;
      matricula = matricula.replace("-", "");
      matricula = matricula.replace(".", "");
      matricula = matricula.replace(".", "");
      matricula = matricula.padStart(8, "0");

      var mascara = "-";
      var position = 7;
      var output = [matricula.slice(0, position), mascara, matricula.slice(position)].join('');

      mascara = '.';
      position = 4;
      output = [output.slice(0, position), mascara, output.slice(position)].join('');

      position = 1;
      output = [output.slice(0, position), mascara, output.slice(position)].join('');

      vm.associado.dsMatriculaFuncional = output;
    }

    vm.preencherDependenteEdicao = function (dependente, index) {
      vm.dependenteEdicao = true;
      vm.indexEdicao = index;
      vm.dependente = dependente;

      vm.dependentes.splice(index, 1);
    }


    vm.editarDependente = function () {
      //caso o dependente ainda não esteja na base de dados
      var dadosDependente = {
        "noDependente": vm.dependente.noDependente,
        "dtNascimento": vm.dependente.dtNascimento,
        "tpParentesco": vm.dependente.tpParentesco
      };

      if (vm.dependente.idDependente) {
        dadosDependente['idDependente'] = vm.dependente.idDependente;
      }

      //removendo indice anterior
      //Adicionando o editado
      vm.dependentes.splice(vm.indexEdicao + 1, 0, dadosDependente);

      $mdToast.show(
        {
          template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
            '<span class="md-toast-content md-green-400-bg">Dados Alterados. Salve para persistir as informações</span>' +
            '</md-toast>',
          hideDelay: 3000,
          position: 'top right'
        }
      );

      vm.dependenteEdicao = false;
      vm.indexEdicao = -1;

      vm.dependente.noDependente = "";
      vm.dependente.dtNascimento = "";
      vm.dependente.tpParentesco = "";
    }

    vm.sairSemSalvar = function () {
      $state.go('app.associado');
    }
    // faz download de um cadapio dentro da tela de edicao
    $scope.verFoto = function (idPessoaFisica) {
      $http({
        url: api.baseUrl + 'associado/arquivo/' + idPessoaFisica,
        method: "GET",
        params: {}
      }).then(function successCallback(response) {
        if (response.data.file != null) {
          vm.fotoAvatar = "data:" + response.data.contentType + ";base64," + response.data.file;
        }
      }, function errorCallback(response) {

        $mdToast.show(
          {
            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
              '<span class="md-toast-content md-red-400-bg">' +
              'Desculpe, houve um erro ao carregar a foto, Contate os Administradores!' +
              '</span>' +
              '</md-toast>',
            hideDelay: 3000,
            position: 'top right'
          }
        );
      });

    }

  }


})();

(function () {
    'use strict';

    angular
        .module('app.associado')
        .controller('AniversarianteController', AniversarianteController);

    /** @ngInject */
    function AniversarianteController(api, $scope, $stateParams, $state, $mdToast, $mdDialog, $timeout, DTOptionsBuilder, $http, $element) {
        var vm = this;
        vm.titulo = "Cadastrar Comunicado de Aniversariante";
        $scope.localLoading = false;
        $scope.localLoadingSave = false;
        vm.comunicado = {};

        vm.init = function () {
            vm.getComunicadoAniversatiante();
        };

        vm.getComunicadoAniversatiante = function () {
            $scope.localLoading = true;
            api.aniversariante.get({}, function (response) {
                $scope.localLoading = false;
                vm.comunicado = response;
                vm.destacarTag();
            }, function (responseError) {
                console.log(responseError.data.detail);
            });
        };

        vm.destacarTag = function () {
            return false;
            var test = vm.comunicado.dsComunicadoAniversariante.indexOf("<span style='color: red;font-weight: bold'>[associado]</span>") > -1;
            if (vm.comunicado.dsComunicadoAniversariante.indexOf("[associado]") > -1 && (!test)) {
                var template = "<span style='color: red;font-weight: bold'>[associado]</span>";
                vm.comunicado.dsComunicadoAniversariante = vm.comunicado.dsComunicadoAniversariante.replace("/" + template + "/g", "");
                vm.comunicado.dsComunicadoAniversariante = vm.comunicado.dsComunicadoAniversariante.replace("[associado]",  template);
            }
        }

        vm.salvarComunicadoAniversatiante = function () {
            $scope.localLoadingSave = true;
            api.aniversariante.save(vm.comunicado, function (response) {
                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-green-400-bg" >' +
                        '<span class="md-toast-content md-green-400-bg">Informativo de aniversariante salvo com sucesso com sucesso</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                $scope.localLoadingSave = false;
            }, function (responseError) {
                var mensagemErro = "Não foi possível Salvar o informativo, entre em contato com o admintrador do sistema ou tente novamente mais tarde";
                if (responseError.data.status == 406 || responseError.data.status == 412) {
                    mensagemErro = responseError.data.detail;
                }

                $mdToast.show(
                    {
                        template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                        '<span class="md-toast-content md-red-400-bg">' +
                        mensagemErro +
                        '</span>' +
                        '</md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    }
                );
                $scope.localLoading = false;
                console.log(responseError.data.detail);
            });
        };
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($mdSidenav, $translate, $mdToast, $scope, OAuthToken, $state, api, $rootScope, msNavigationService) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'pt',
                'flag': 'pt-br'
            },
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////


        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            menu();
            api.usuario.get({}, function (response) {
                removeMenus()
                if (response._embedded.usuario[0]) {
                    vm.usuarioLogado = response._embedded.usuario[0].noPessoa;
                    $rootScope.usuarioLogado = vm.usuarioLogado;
                }
            }, function (responseError) {
                if (401 === responseError.status) {
                console.log(responseError.data.detail);

                    var mensagemErro = 'Sua sessão expirou acesse novamente';
                    if (responseError.mensagem) {
                        mensagemErro = responseError.mensagem;
                    }
                    $mdToast.show(
                        {
                            template: '<md-toast class="md-toast md-warn md-red-400-bg" >' +
                            '<span class="md-toast-content md-red-400-bg">' +
                            mensagemErro +
                            '</span>' +
                            '</md-toast>',
                            hideDelay: 3000,
                            position: 'top right'
                        }
                    );
                    OAuthToken.removeToken();
                    $state.go('app.login');
                }
            });


            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        function removeMenus(perfil) {
            if (perfil == undefined) {
                perfil = '';
            }
            // caso administrativo remove todos os menus exceto associado
            if (perfil.toLowerCase() == 'administrativo') {
                msNavigationService.deleteItem('pessoa');
                msNavigationService.deleteItem('juridico');
                msNavigationService.deleteItem('comunicacao');
                msNavigationService.deleteItem('financeiro');
                msNavigationService.deleteItem('relatorio');
            }
        }

        function menu() {
            msNavigationService.saveItem('dashboard', {
                title: 'Dashboard',
                icon: 'icon-chart-areaspline',
                state: 'app.dashboard',
                weight: 1
            });

            // Navigation
            msNavigationService.saveItem('cadastro', {
                title: 'Cadastros',
                group: true,
                weight: 1
            });

            msNavigationService.saveItem('cadastro.usuario', {
                title: 'Usuários',
                icon: 'icon-account-box',
                state: 'app.pessoa'
            });


            // menu de associado
            msNavigationService.saveItem('cadastro.associado', {
                title: 'Associados',
                icon: 'icon-account-multiple',
                group: true,
                // state: 'app.associado',
                /*stateParams: {
                 'param1': 'page'
                 },*/
                weight: 1
            });

              // menu de associado
              msNavigationService.saveItem('cadastro.associado.listar', {
                title: 'Lista de Associados',
                icon: 'icon-account-multiple',
                state: 'app.associado',
                /*stateParams: {
                 'param1': 'page'
                 },*/
                weight: 1
            });

            msNavigationService.saveItem('cadastro.associado.externo', {
              title: 'Aprovação de Cadastro',
              icon: 'icon-account-alert',
              state: 'app.listar_associado_externo',
              weight: 1
          });


            // Navigation
            msNavigationService.saveItem('juridico', {
                title: 'Juridico',
                group: true,
            });
            //juridico
            msNavigationService.saveItem('juridico.processos', {
                title: 'Processos',
                icon: 'icon-library-books',
                state: 'app.juridico',
                /*stateParams: {
                 'param1': 'page'
                 },*/
                weight: 1
            });

            // Navigation
            msNavigationService.saveItem('financeiro', {
                title: 'Financeiro',
                group: true,
                weight: 1
            });

            msNavigationService.saveItem('financeiro.pagamento', {
                title: 'Pagamentos',
                icon: 'icon-cash-multiple',
                state: 'app.pagamento',
                weight: 1
            });

            msNavigationService.saveItem('financeiro.boleto', {
                title: 'Boletos',
                icon: 'icon-file-delimited',
                state: 'app.boleto',
                weight: 1
            });

            // Navigation
            msNavigationService.saveItem('gestao', {
                title: 'Gestão',
                group: true,
                weight: 1
            });

            msNavigationService.saveItem('gestao.relatorio', {
                title: 'Relatórios',
                icon: 'icon-book-variant',
                state: 'app.relatorio',
                weight: 1
            });

            msNavigationService.saveItem('gestao.relatorio-associado', {
              title: 'Relatório Associados',
              icon: 'icon-book-variant',
              state: 'app.relatorio-associado',
              weight: 1
          });

            msNavigationService.saveItem('cadastro.convenio', {
                title: 'Convênio',
                icon: 'icon-view-dashboard',
                state: 'app.convenio',
                weight: 1
            });

            // Navigation
            msNavigationService.saveItem('comunicacao', {
                title: 'Comunicação',
                group: true,
                weight: 1
            });

            msNavigationService.saveItem('comunicacao.aniversariante', {
                title: 'Aniversariante',
                icon: 'icon-calendar-check',
                state: 'app.aniversariante'
            });

            //boletim
            msNavigationService.saveItem('comunicacao.boletim', {
                title: 'Boletim',
                icon: 'icon-message-text-outline',
                state: 'app.boletim'
            });

            msNavigationService.saveItem('comunicacao.comunicado', {
                title: 'Comunicação',
                icon: 'icon-comment-multipe-outline',
                state: 'app.comunicacao'
            });


        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }


        $scope.logout = function () {
            OAuthToken.removeToken();
            $state.go('app.login');
        }
        init();
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function () {
    "use strict";

    /**
     * Main module of the Fuse
     */
    angular
        .module("fuse", [
            "app.core",
            "app.navigation",
            "app.toolbar",
            "app.sample",
            "app.default",
            "app.pessoa",
            "app.associado",
            "app.contra_cheque",
            "app.boletim",
            "app.juridico",
            "app.pagamento",
            "app.comunicacao",
            "app.relatorio",
            "app.convenio",
            "app.associado_externo",
            "ngMask",
            "idf.br-filters",
            "ngCpfCnpj",
            "lfNgMdFileInput",
            "angularTrix",
            "ngMaterial",
            "textAngular",
            "ui.utils.masks",

        ])
        .filter('matricula', function () {

            return function (valor) {
                var matricula = valor;
                matricula = matricula.replace("-", "");
                matricula = matricula.replace(".", "");
                matricula = matricula.replace(".", "");
                matricula = matricula.padStart(8, "0");

                var mascara = "-";
                var position = 7;
                var output = [matricula.slice(0, position), mascara, matricula.slice(position)].join('');

                mascara = '.';
                position = 4;
                output = [output.slice(0, position), mascara, output.slice(position)].join('');

                position = 1;
                output = [output.slice(0, position), mascara, output.slice(position)].join('');

                return output;
            }


        })
        .config(['$provide', function ($provide) {
            $provide.decorator('taOptions', ['$delegate', function (taOptions) {
                taOptions.forceTextAngularSanitize = true;
                taOptions.keyMappings = [];
                taOptions.toolbar = [
                    ['h1', 'h2', 'h3', 'p', 'pre', 'quote'],
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['html', 'insertImage', 'insertLink']
                ];
                taOptions.classes = {
                    focussed: '',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-button-group',
                    toolbarButton: '',
                    toolbarButtonActive: 'active',
                    disabled: 'disabled',
                    textEditor: 'ta-text-editor',
                    htmlEditor: 'md-input'
                };
                return taOptions; // whatever you return will be the taOptions
            }]);
            $provide.decorator('taTools', ['$delegate', function (taTools) {
                taTools.h1.display = '<md-button aria-label="Título 1">H1</md-button>';
                taTools.h2.display = '<md-button aria-label="Título 2">H2</md-button>';
                taTools.h3.display = '<md-button aria-label="Título 3">H3</md-button>';
                taTools.p.display = '<md-button aria-label="Parágrafo">P</md-button>';
                taTools.pre.display = '<md-button aria-label="Pre formatado">pre</md-button>';
                taTools.quote.display = '<md-button class="md-icon-button" aria-label="Citação"> <md-icon md-font-icon="icon-format-quote" class="icon s24 ng-scope md-font icon-format-quote material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.bold.display = '<md-button class="md-icon-button" aria-label="Negrito"><md-icon md-font-icon="icon-format-bold" class="icon s24 ng-scope md-font icon-format-bold material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.italics.display = '<md-button class="md-icon-button" aria-label="Italico"><md-icon md-font-icon="icon-format-italic" class="icon s24 ng-scope md-font icon-format-italic material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.underline.display = '<md-button class="md-icon-button" aria-label="Sublinhado"><md-icon md-font-icon="icon-format-underline" class="icon s24 ng-scope md-font icon-format-underline material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.ul.display = '<md-button class="md-icon-button" aria-label="Listar Ordenada"><md-icon md-font-icon="icon-format-list-bulleted" class="icon s24 ng-scope md-font icon-format-list-bulleted material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.ol.display = '<md-button class="md-icon-button" aria-label="Lista Numerada"><md-icon md-font-icon="icon-format-list-numbers" class="icon s24 ng-scope md-font icon-format-list-numbers material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.undo.display = '<md-button class="md-icon-button" aria-label="Desfazer"><md-icon md-font-icon="icon-undo" class="icon s24 ng-scope md-font icon-undo material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.redo.display = '<md-button class="md-icon-button" aria-label="Refazer"><md-icon md-font-icon="icon-redo" class="icon s24 ng-scope md-font icon-redo material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.justifyLeft.display = '<md-button class="md-icon-button" aria-label="Align left"><md-icon md-font-icon="icon-format-align-left" class="icon s24 ng-scope md-font icon-format-align-left material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.justifyRight.display = '<md-button class="md-icon-button" aria-label="Align right"><md-icon md-font-icon="icon-format-align-right" class="icon s24 ng-scope md-font icon-format-align-right material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.justifyCenter.display = '<md-button class="md-icon-button" aria-label="Align center"><md-icon md-font-icon="icon-format-align-center" class="icon s24 ng-scope md-font icon-format-align-center material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.justifyFull.display = '<md-button class="md-icon-button" aria-label="Justify"><md-icon md-font-icon="icon-format-align-justify" class="icon s24 ng-scope md-font icon-format-align-justify material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.clear.display = '<md-button class="md-icon-button" aria-label="Clear formatting"><md-icon md-font-icon="icon-format-clear" class="icon s24 ng-scope md-font icon-format-clear material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.html.display = '<md-button class="md-icon-button" aria-label="Show HTML"><md-icon md-font-icon="icon-format-header-pound" class="icon s24 ng-scope md-font icon-format-header-pound material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.insertLink.display = '<md-button class="md-icon-button" aria-label="Insert link"><md-icon md-font-icon="icon-link-variant" class="icon s24 ng-scope md-font icon-link-variant material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                taTools.insertImage.display = '<md-button class="md-icon-button" aria-label="Insert photo"><md-icon md-font-icon="icon-folder-image" class="icon s24 ng-scope md-font icon-folder-image material-icons md-default-theme" aria-hidden="true"></md-icon></md-button>';
                return taTools;
            }]);
        }]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function() {
  "use strict";

  angular.module("app.core").run(runBlock);

  /** @ngInject */
  function runBlock(
    msUtils,
    fuseGenerator,
    fuseConfig,
    $rootScope,
    OAuth,
    $state
  ) {
    /**
     * Generate extra classes based on registered themes so we
     * can use same colors with non-angular-material elements
     */
    fuseGenerator.generate();

    /**
     * Disable md-ink-ripple effects on mobile
     * if 'disableMdInkRippleOnMobile' config enabled
     */
    if (
      fuseConfig.getConfig("disableMdInkRippleOnMobile") &&
      msUtils.isMobile()
    ) {
      var bodyEl = angular.element("body");
      bodyEl.attr("md-no-ink", true);
    }

    $rootScope.$on("$stateChangeStart", function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      var dominiosLivres = ["app.contra_cheque", "app.esqueci", "app.login","app.associado_externo",'app.associado_externo_recadastro'];
      //Verificar se o usuario esta acessando uma rota diferente do login
      if (dominiosLivres.indexOf(toState.name) === -1) {
        console.log(toState.name)
        if (!OAuth.isAuthenticated()) {
          event.preventDefault();
          $state.go("app.associado_externo");
        }
      }
    });

    /**
     * Put isMobile() to the html as a class
     */
    if (msUtils.isMobile()) {
      angular.element("html").addClass("is-mobile");
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if (browserInfo) {
      var htmlClass =
        browserInfo.browser + " " + browserInfo.version + " " + browserInfo.os;
      angular.element("html").addClass(htmlClass);
    }
  }
})();

(function ()
{
    'use strict';

    angular
            .module('app.core')
            .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider, OAuthProvider, OAuthTokenProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */

        OAuthProvider.configure({
             baseUrl: 'http://api.gestaoasspen.com.br/',
            // baseUrl: 'http://asspen.local/',
            // baseUrl: 'http://localhost:8082/',
            // baseUrl: 'http://apiteste.gestaoasspen.com.br/',
            clientId: 'asspen',
            clientSecret: 'asspen',
            grantPath: '/oauth'
                    //revokePath: '/oauth2/revoke'
        });
        /*
         * @todo quando tiver um certificado e for utilizar https
         * Desabilita a segurança (SSL/HTTPS)
         */
        OAuthTokenProvider.configure({
            name: 'token',
            options: {
                secure: false
            }
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, OAuth, OAuthToken, api) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                $rootScope.loadingProgress = true;
            }
        );
//adiciono tag para saber em qual ambiente estou
        if (api.baseUrl == 'http://asspen.local/' || api.baseUrl == 'http://localhost:8080/' ||
        api.baseUrl == 'http://localhost:8081/'  || api.baseUrl == 'http://localhost:8082/' ) {
            $rootScope.ambiente = '[DEV]';

        } else if (api.baseUrl == 'http://apiteste.gestaoasspen.com.br/') {
            $rootScope.ambiente = '[HMG]';

        } else {
            $rootScope.ambiente = '';

        }

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        //Removend o token inválido e redirecionando
        $rootScope.$on('oauth:error', function (event, rejection) {
          var ignora = '/dominio/usuario';
          console.log('dominio---------------');
          console.log(rejection.config.url);
          console.log('event---------------');
            if (undefined != rejection.config  && undefined != rejection.config.url
              && rejection.config.url.indexOf('/dominio/usuario') !== -1
              && rejection.config.url.indexOf('/associado-externo')!== -1){
              event.preventDefault();
            }
            OAuthToken.removeToken();
            $state.go('app.associado_externo');
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(true);


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts['verticalNavigation'].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts['verticalNavigation'].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts['verticalNavigation'].navigation,
                        controller: 'NavigationController as vm'
                    }
                }
            });

        $urlRouterProvider.otherwise('/associado-externo');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
            .module('fuse')
            .config(config);

    /** @ngInject */
    function config()
    {
       //
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource) {
        var api = {};

        // Base Url
        api.baseUrl = 'http://api.gestaoasspen.com.br/';
        // api.baseUrl = 'http://apiteste.gestaoasspen.com.br/',
        // api.baseUrl = 'http://asspen.local/';
        // api.baseUrl = 'http://localhost:8082/';

        api.pessoa = $resource(api.baseUrl + 'gestao-pessoas/pessoa/:idPessoa', {
            idPessoaFisica: '@idPessoaFisica',
            tpFuncionarioAsspen: '@tpFuncionarioAsspen'
        },
            {
                update: {
                    method: 'PUT'
                },
                delete: {
                    method: 'PATCH'
                }
            }
        );

        //GESTAO PESSOAS
        api.cargo = $resource(api.baseUrl + 'gestao-pessoas/cargo');
        api.perfil = $resource(api.baseUrl + 'gestao-pessoas/perfil');
        api.recuperarSenha = $resource(api.baseUrl + 'resetar-senha');
        api.telefone = $resource(api.baseUrl + 'gestao-pessoas/telefone/:idTelefone', {}, {
            delete: {
                method: 'DELETE'
            }
        });
        api.endereco = $resource(api.baseUrl + 'gestao-pessoas/endereco');

        //FIM--GESTAO PESSOAS

        //ASSOCIADO
        api.convenio = $resource(api.baseUrl + 'associado/convenio/:idProduto', {},
            {
                update: {
                    method: 'PUT'
                },
                delete: {
                    method: 'PATCH'
                }
            });
        api.cargoAssociado = $resource(api.baseUrl + 'associado/cargo-associado');
        api.lotacaoAssociado = $resource(api.baseUrl + 'associado/lotacao-associado');
        api.arquivo = $resource(api.baseUrl + 'associado/arquivo');
        api.aniversariante = $resource(api.baseUrl + 'associado/aniversariante');
        api.associado = $resource(api.baseUrl + 'associado/associado/:idAssociadoEditar', {},
            {
                update: {
                    method: 'PUT'
                },
                delete: {
                    method: 'PATCH'
                }
            });

        api.comunicacao = $resource(api.baseUrl + 'associado/comunicado/:idComunicacao', {},
            {
                update: {
                    method: 'PUT'
                },
                delete: {
                    method: 'PATCH'
                }
            });

        api.dependente = $resource(api.baseUrl + 'associado/dependente/:idDependente', {
            associado: '@associado'
        }, {
            delete: {
                method: 'DELETE'
            }
        });
        api.convenioAssociado = $resource(api.baseUrl + 'associado/conveio-associado', {
            associado: '@associado'
        });
        api.boletim = $resource(api.baseUrl + 'associado/boletim/:idBoletim', {}, {
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'PATCH'
            }
        });
        api.arquivoPagamento = $resource(api.baseUrl + 'associado/arquivo-pagamento');
        api.detalheArquivoPagamento = $resource(api.baseUrl + 'associado/detalhe-arquivo-pagamento');
        //FIM--ASSOCIADO

        //DOMINIO
        api.estado = $resource(api.baseUrl + 'dominio/uf');
        api.orgaoExpeditor = $resource(api.baseUrl + 'dominio/orgao-expeditor');
        api.usuario = $resource(api.baseUrl + 'dominio/usuario');
        //FIM--DOMINIO

        //JURIDICO
        api.tribunal = $resource(api.baseUrl + 'juridico/tribunal');
        api.advogado = $resource(api.baseUrl + 'juridico/advogado');
        api.associadoAniversariante = $resource(api.baseUrl + 'associado/associado-aniversariante');
        api.processo = $resource(api.baseUrl + 'juridico/processo/:processo_id', {},
            {
                update: {
                    method: 'PUT'
                },
                delete: {
                    method: 'PATCH'
                }
            });
        api.status = $resource(api.baseUrl + 'juridico/status/:processo_id');


        api.anexoComunicado = $resource(api.baseUrl + 'associado/anexo-comunicado/:idAnexoComunicado', {}, {
            delete: {
                method: 'DELETE'
            }
        });
        api.statusProcesso = $resource(api.baseUrl + 'juridico/status-processo/:processo_id');


        api.associadoExterno = $resource(api.baseUrl + 'suporte/associado-externo/:associado_id', {}, {
            update: {
                method: 'PUT'
            },
            delete: {
                method: 'PATCH'
            }
        });
        api.associadoExternoAdm = $resource(api.baseUrl + 'associado/associado-service-aprovacao:associado_id');

        api.associadoExternoAsspen = $resource(api.baseUrl + 'associado/associado-service-aprovacao/:associado_id');

        return api;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.convenio', ['datatables','ui.utils.masks'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        
        $stateProvider.state('app.convenio', {
            url: '/convenio',
            views: {
                'content@app': {
                    templateUrl: 'app/main/convenio/views/listar.html',
                    controller: 'ConvenioController as vm'
                }
            },
            bodyClass: 'convenio'
        });


        $stateProvider.state('app.convenio.add', {
            url: '/adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/convenio/views/cadastrar.html',
                    controller: 'ConvenioController as vm'
                }
            },
            bodyClass: 'convenio'
        });

        $stateProvider.state('app.convenio.edit', {
            url: '/editar/:idProduto',
            views: {
                'content@app': {
                    templateUrl: 'app/main/convenio/views/cadastrar.html',
                    controller: 'ConvenioController as vm'
                }
            },
            bodyClass: 'convenio'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/convenio');


    }

})();
(function () {
    'use strict';

    angular
        .module('app.boletim', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        
        $stateProvider.state('app.boletim', {
            url: '/boletim',
            views: {
                'content@app': {
                    templateUrl: 'app/main/boletim/views/listar.html',
                    controller: 'BoletimController as vm'
                }
            },
            bodyClass: 'boletim'
        });


        $stateProvider.state('app.boletim.add', {
            url: '/adicionar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/boletim/views/cadastrar.html',
                    controller: 'BoletimController as vm'
                }
            },
            bodyClass: 'boletim'
        });

        $stateProvider.state('app.boletim.edit', {
            url: '/editar/:idBoletim',
            views: {
                'content@app': {
                    templateUrl: 'app/main/boletim/views/cadastrar.html',
                    controller: 'BoletimController as vm'
                }
            },
            bodyClass: 'boletim'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/boletim');


    }

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">HOJE</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">Versões</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/default/default.html","<h1><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><div flex-gt-md=\"25\"></div><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Adicionar\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Listar\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n100{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div class=\"h3 secondary-text font-weight-500\">\nRESPONSÁVEIS{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Último{{vm.widget1.data.extra.label}}:</span>\n <span class=\"h4 ml-8\">15/08/2016{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Adicionar</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Listar</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-72 line-height-72\">135{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">ALUNOS{{vm.widget1.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Último{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n15/08/2016{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget1.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><div flex-gt-md=\"25\"></div><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Adicionar</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Listar</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">6{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">TURMAS{{vm.widget1.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Último{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n15/08/2016{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"blue-grey-fg font-size-72 line-height-72\">1.325,00{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">FINANCEIRO{{vm.widget1.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Último{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n15/08/2016{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget1.detail}}</div></ms-widget-back></ms-widget></div></h1>");
$templateCache.put("app/main/default/lista.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\">{{vm.employees}}<div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span>\n</div><div class=\"title\">Simple Table</div></div></div><div class=\"content\">\nTables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:\n</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>\nThe ability for users to query and manipulate data at scale</li></ul><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Employees</div><table class=\"simple\" \nms-responsive-table><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class=\"text-right\">Age</th><th \nclass=\"text-right\">Start Date</th><th class=\"text-right\">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-repeat=\"person in vm.employees\"><td class=\"name\">{{person.name}}</td><td class=\"position\">\n{{person.position}}</td><td class=\"office\">{{person.office}}</td><td class=\"age text-right\">{{person.age}}</td><td \nclass=\"start-date text-right\">{{person.startDate}}</td><td class=\"salary text-right\">{{person.salary | currency}}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/login/esqueci-senha.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-init=\"init()\"><div id=\"login-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><image src=\"/assets/images/logos/logo.png\"></div><div class=\"title a\" style=\"color: red\" \nng-show=\"error_login\">{{error_login}}</div><div class=\"title\">Recupere sua senha digitando o usuário</div><form \nname=\"esqueciSenhaForm\" novalidate ng-submit=\"recuperarSenha(vm.form)\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"usuario\" style=\"text-transform: lowercase\" \nng-model=\"vm.form.username\" placeholder=\"Usuário\" required><div ng-messages=\"loginForm.usuario.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Digite o usuário</span></div><div ng-show=\"!usuarioExiste\"><span>\nUsuário não encontrado.</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between center\"><a ui-sref=\"app.login\" style=\"cursor: pointer\" \nclass=\"forgot-password md-accent-color\">Voltar para o Login.</a></div><md-button type=\"submit\" ng-if=\"!localLoading\" \nstyle=\"text-align: center\" class=\"md-raised md-accent submit-button\" aria-label=\"Recuperar\" \nng-disabled=\"esqueciSenhaForm.$invalid || esqueciSenhaForm.$pristine\">Recuperar</md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" \nid=\"toolbar-progress-login\" ng-if=\"localLoading\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div></form></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-init=\"init()\"><div id=\"login-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><image src=\"/assets/images/logos/logo.png\"></div><div class=\"title a\" style=\"color: red\" \nng-show=\"error_login\">{{error_login}}</div><div class=\"title\" translate=\"LOGIN.TITLE\">Acesse com seu usuário e senha\n</div><form name=\"loginForm\" novalidate ng-submit=\"logar(vm.form)\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"usuario\" ng-model=\"vm.form.username\" class=\"text-to-lower\" \nplaceholder=\"Usuário\" required><div ng-messages=\"loginForm.usuario.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Digite o usuário</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" \ntranslate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Digite a senha</span></div>\n</div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><a ui-sref=\"app.esqueci\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Esqueceu a senha?</a></div><md-button type=\"submit\" ng-if=\"!localLoading\" \nstyle=\"text-align: center\" class=\"md-raised md-accent submit-button\" aria-label=\"Acessar\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">Acessar</md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" \nid=\"toolbar-progress-login\" ng-if=\"localLoading\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div></form></div></div></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/associado/views/aniversariantes.html","<div id=\"conteudo\" ng-init=\"vm.init();\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\n{{ vm.titulo }}</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" \nng-init=\"vm.obterDados()\"><div class=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\">\n<md-progress-circular id=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-if=\"!localLoading\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Mensagem para os aniversatiantes</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><span>Coloque a Tag <span style=\"color: red;font-weight: bold\">[associado]</span>\n, onde ficará o nome do associado aniversariante</span></div><div layout=\"column\" layout-gt-xs=\"row\" flex><fieldset \nflex=\"100\"><legend><h2>Comunicado</h2></legend><div layout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"100\">\n<text-angular ng-keyup=\"vm.destacarTag()\" ng-model=\"vm.comunicado.dsComunicadoAniversariante\"></text-angular></div>\n</div></fieldset></div></form><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.salvarComunicadoAniversatiante();\" ng-disabled=\"msWizard.formsIncomplete()\" \nng-if=\"!localLoadingSave\">Salvar</md-button><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoadingSave\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></md-tab-body></md-tab>\n</md-tabs></ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/associado/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.init();vm.obterDados();\"><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px\">{{ vm.titulo }}</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\"><div class=\"content\"><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\"><md-progress-circular id=\"default-progress\" \nclass=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div\n class=\"avatar-wrapper right\" style=\"position: relative;  right: 0px;z-index: 999\"><img \nstyle=\"height: 80px;width: 80px;z-index: 9999\" class=\"md-avatar avatar\" ng-show=\"vm.fotoAvatar\" \nng-src=\"{{vm.fotoAvatar}}\"> <img style=\"height: 80px;width: 80px\" class=\"md-avatar avatar\" ng-show=\"!vm.fotoAvatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-button class=\"md-fab\" ng-if=\"vm.idAssociado\" aria-label=\"Ficha associado\" \nui-sref=\"app.associado.ficha({idAssociado:vm.idAssociado})\" \nstyle=\"position: relative; left: 0; margin-right: 16px;z-index: 999\"><md-icon md-font-icon=\"icon-library-books\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Visualizar Ficha</md-tooltip></md-button><div class=\"borda-arredondada\" \nng-if=\"vm.idAssociado\">Matrícula Asspen {{vm.associado.pessoaFisica.dsMatricula}}</div></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\" style=\"margin-top: -20px\"><ms-form-wizard flex><md-tabs \nmd-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" ng-init=\"vm.setWizard(msWizard)\"><md-tab \nid><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Matrícula</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height: 84px;vertical-align: bottom\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"dtFiliacao\" ng-model=\"vm.associado.dtFiliacao\" placeholder=\"Data da Filiação*\" mask=\"99/99/9999\" \nrequired><div ng-messages=\"wizardStep1.dtFiliacao.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA Data de Filiação é Obrigatória.</span></div><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container><md-input-container flex=\"5\">\n</md-input-container><md-input-container flex=\"25\" flex-gt-xs=\"25\"><input type=\"text\" name=\"dtNascimento\" \nng-model=\"vm.associado.pessoaFisica.dtNascimento\" placeholder=\"Data de Nascimento Associado*\" mask=\"99/99/9999\"><div \nng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA Data de Nascimento é Obrigatória.</span></div><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container><md-input-container flex=\"25\" \nflex-gt-xs=\"25\"><md-select ng-model=\"vm.associado.pessoaFisica.tpSexo\" name=\"tpSexo\" placeholder=\"Sexo\"><md-option \nvalue=\"M\">Masculino</md-option><md-option value=\"F\">Feminino</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"dsMatriculaFuncional\" ng-model=\"vm.associado.dsMatriculaFuncional\" placeholder=\"Matrícula Funcional*\" \nmask=\"9.999.999-%\" ng-blur=\"vm.mascararMatricula()\" required><div \nng-messages=\"wizardStep1.dsMatriculaFuncional.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPrrencha a Matrícula Funcional do Associado</span></div></div></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"nomeAssociado\" \nng-model=\"vm.associado.pessoaFisica.noPessoa\" placeholder=\"Nome do Associado*\" required><div \nng-messages=\"wizardStep1.nomeAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Nome do associado é obrigatório</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"cpf\" \nng-model=\"vm.associado.pessoaFisica.nuCpf\" placeholder=\"CPF*\" mask=\"999.999.999-99\" ng-cpf required><div \nng-messages=\"wizardStep1.cpf.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o Cpf.</span></div><div \nng-message=\"cpf\">CPF inválido</div></div></md-input-container><div flex=\"5\"></div><div flex=\"100\" flex-gt-xs=\"50\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"40\"><input type=\"text\" name=\"rgAssociado\" \nng-model=\"vm.associado.pessoaFisica.dsRg\" placeholder=\"RG*\" required><div ng-messages=\"wizardStep1.rgAssociado.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o RG do associado.</span></div></div></md-input-container>\n<md-input-container flex=\"30\"><input type=\"text\" name=\"dtExpedicao\" ng-model=\"vm.associado.pessoaFisica.dtExpedicao\" \nplaceholder=\"Dt Expedição\" mask=\"99/99/9999\"><div ng-messages=\"wizardStep1.dtExpedicao.$error\" role=\"alert\"><div \nng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container>\n<md-input-container flex=\"20\"><md-select ng-model=\"vm.associado.pessoaFisica.orgaoExpeditor\" \nname=\"orgaoExpeditorAssociado\" placeholder=\"Órgão Expedidor*\" required><md-option \nng-repeat=\"orgaoExpeditor in vm.orgaoExpeditor\" ng-init=\"vm.associado.pessoaFisica.orgaoExpeditor = 1\" \nvalue=\"{{orgaoExpeditor.idOrgaoEmissor}}\">{{orgaoExpeditor.noOrgaoEmissor}}</md-option></md-select><div \nng-messages=\"wizardStep1.orgaoExpeditorAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Orgão Expeditor.</span></div></div></md-input-container><md-input-container flex=\"10\"><md-select \nng-model=\"vm.associado.pessoaFisica.estadoExpeditor\" placeholder=\"UF*\" required name=\"estadoExpeditorAssociado\">\n<md-option ng-init=\"vm.associado.pessoaFisica.estadoExpeditor = 7\" ng-repeat=\"estado in vm.estados\" \nvalue=\"{{estado.idEstado}}\">{{estado.dsSigla}}</md-option></md-select><div \nng-messages=\"wizardStep1.estadoExpeditorAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Estado Expeditor.</span></div></div></md-input-container></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\" \nflex-gt-xs=\"50\"><md-select ng-model=\"vm.associado.pessoaFisica.tpEstadoCivil\" name=\"tpEstadoCivil\" \nplaceholder=\"Estado Civil*\" required><md-option value=\"C\">Casado</md-option><md-option value=\"D\">Divorciado</md-option>\n<md-option value=\"S\">Solteiro</md-option><md-option value=\"V\">Viúvo</md-option></md-select><div \nng-messages=\"wizardStep1.tpEstadoCivil.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Estado Civil é Obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" style=\"margin-top: 0px\"><span ng-show=\"vm.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><md-checkbox \nng-model=\"vm.associado.inConjugeServidor\" aria-label=\"Cônjuge é servidor do sistema penitenciário?*\">\nCônjuge é servidor do sistema penitenciário?</span></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex ng-show=\"vm.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"noPessoaConjuge\" ng-model=\"vm.associado.noConjuge\" placeholder=\"Nome Cônjuge*\" \nng-required=\"vm.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><div ng-messages=\"wizardStep1.noPessoaConjuge.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>O Nome é Obrigatório.</span></div></div></md-input-container><div \nflex=\"5\"></div><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input type=\"text\" name=\"dtNascimento\" \nng-model=\"vm.associado.dtNascimentoConjuge\" placeholder=\"Data de Nascimento Cônjuge\" mask=\"99/99/9999\"><div \nng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA Data de Nascimento é Obrigatória.</span></div><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><lf-ng-md-file-input lf-files=\"vm.foto.noArquivo\" \nlf-placeholder=\"Foto\" lf-browse-label=\"Selecione\" lf-drag-and-drop-label=\"Arraste a Foto, Solte aqui ou Selecione\" \naccept=\"image/*\" preview progress drag></lf-ng-md-file-input><div ng-messages=\"wizardStep1.noArquivo.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Selecione um arquivo para a foto</span></div></div></md-input-container>\n</div></form><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.sairSemSalvar()\">Sair</md-button><div \nclass=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cadastrarAssociado();msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Salvar e Próximo</md-button></div></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid\" id=\"tab2\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Dados Funcionais</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"noGuerra\" ng-model=\"vm.associado.noGuerra\" \nplaceholder=\"Nome de Guerra\"><div ng-messages=\"wizardStep2.noGuerra.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>O Nome de Guerra é Obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><md-select ng-model=\"vm.associado.cargoAssociado\" name=\"cargoAssociado\" \nplaceholder=\"Cargo*\" required><md-option ng-repeat=\"cargo in vm.cargoAssociado\" value=\"{{cargo.idCargoAssociado}}\">\n{{cargo.noCargoAssociado}}</md-option></md-select><div ng-messages=\"wizardStep2.cargoAssociado.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>O Cargo é Obrigatório.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><md-select \nng-model=\"vm.associado.lotacaoAssociado\" name=\"lotacaoAssociado\" placeholder=\"Lotação*\" required><md-option \nng-repeat=\"lotacao in vm.lotacaoAssociado\" value=\"{{lotacao.idLotacaoAssociado}}\">{{lotacao.noLotacaoAssociado}}\n</md-option></md-select><div ng-messages=\"wizardStep2.lotacaoAssociado.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>A Lotação é Obrigatória</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"noGuerra\" ng-model=\"vm.associado.pessoaFisica.dsEmail\" \nplaceholder=\"Email*\" class=\"text-to-lower\" required><div ng-messages=\"wizardStep2.noGuerra.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O Nome de Guerra é Obrigatório.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><h3 class=\"md-title\" ng-if=\"vm.telefoneAssociado.length > 1\">Telefones</h3><h3 \nclass=\"md-title\" ng-if=\"vm.telefoneAssociado.length <= 1\">Telefone</h3></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex><div flex=\"100\" flex-gt-xs=\"100\"><md-input-container><input type=\"text\" name=\"Telefone\" mask=\"(99)99999-999?9\" \nng-model=\"vm.telefone\" placeholder=\"Telefone\"><div ng-messages=\"wizardStep2.telefone.$error\" role=\"alert\"><div \nng-if=\"!vm.isTelefoneAdicionado\"><span>Ao menos um Telefone é Obrigatório.</span></div></div></md-input-container>\n<md-button class=\"md-fab\" aria-label=\"Cadastar Novo Telefone\" style=\"\" ng-click=\"vm.cadastrarTelefone()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"left\">Adicionar Telefone</md-tooltip></md-button></div></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"datatable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Telefone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remover</span></div></th></tr></thead><tbody><tr ng-repeat=\"(index, telefone) in vm.telefones\">\n<td>{{ telefone.dsTelefone}}</td><td><md-icon md-font-icon=\"icon-trash\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.showConfirmTelefone($event, telefone, index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon></td>\n</tr></tbody></table></div><div flex=\"55\"></div></div></form><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\"></md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.sairSemSalvar()\">\nSair sem Salvar</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cadastrarAssociado();msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Salvar e Próximo</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">>\n</md-button></div></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid || wizardStep3.$invalid\">3</span><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Endereço</span>\n</span></md-tab-label><md-tab-body><form name=\"wizardStep3\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"noMae\" \nng-model=\"vm.associado.noMae\" placeholder=\"Nome da mãe*\" required><div ng-messages=\"wizardStep3.noMae.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>O Nome da mãe é requerido.</span></div></div></md-input-container><div \nflex=\"5\"></div><md-input-container flex=\"50\"><input type=\"text\" name=\"dtNascimentoMae\" \nng-model=\"vm.associado.dtNascimentoMae\" mask=\"99/99/9999\" placeholder=\"Data de Nascimento da mãe\"><div \nng-messages=\"wizardStep3.dtNascimentoMae.$error\" role=\"alert\"><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"noPai\" ng-model=\"vm.associado.noPai\" \nplaceholder=\"Nome do pai\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\"><input type=\"text\" \nname=\"dtNascimentoPai\" mask=\"99/99/9999\" ng-model=\"vm.associado.dtNascimentoPai\" \nplaceholder=\"Data de Nascimento do pai\"><div ng-messages=\"wizardStep3.dtNascimentoPai.$error\" role=\"alert\"><div \nng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"nuCep\" \nng-model=\"vm.endereco.nuCep\" placeholder=\"CEP*\" mask=\"99999-999\" required><div ng-messages=\"wizardStep3.nuCep.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o CEP.</span></div></div></md-input-container><div flex=\"5\">\n</div><md-input-container flex=\"50\"><md-select ng-model=\"vm.endereco.estado\" name=\"estado\" placeholder=\"Estado*\" \nrequired><md-option ng-repeat=\"estado in vm.estados\" ng-init=\"vm.endereco.estado = 7\" value=\"{{estado.idEstado}}\">\n{{estado.noEstado}}</md-option></md-select><div ng-messages=\"wizardStep4.estado.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O Estado é requerido.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" name=\"dsEndereco\" \nng-model=\"vm.endereco.dsEndereco\" placeholder=\"Endereço*\" required><div ng-messages=\"wizardStep3.dsEndereco.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o endereço.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"dsBairro\" \nng-model=\"vm.endereco.dsBairro\" placeholder=\"Bairro*\" required><div ng-messages=\"wizardStep3.dsBairro.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o Bairro.</span></div></div></md-input-container><div flex=\"5\">\n</div><md-input-container flex=\"50\"><input type=\"text\" name=\"dsCidade\" ng-model=\"vm.endereco.dsCidade\" \nplaceholder=\"Cidade*\" required><div ng-messages=\"wizardStep4.dsCidade.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Preencha a Cidade.</span></div></div></md-input-container></div></form><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\"></md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.sairSemSalvar()\">\nSair sem Salvar</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cadastrarAssociado();msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Salvar e Próximo</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">>\n</md-button></div></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep3.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep3.$invalid || wizardStep4.$invalid \">4</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep3.$valid && wizardStep4.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Produtos</span></span></md-tab-label><md-tab-body><form name=\"wizardStep4\" \nclass=\"md-inline-form\" layout=\"row\" layout-wrap ms-form-wizard-form novalidate><div flex=\"33\" \nng-repeat=\"convenio in vm.convenios\"><md-card><md-card-content style=\"height: 315px\"><md-checkbox \nng-model=\"vm.produtos[convenio.idProduto][\'valor\']\"><span style=\"white-space: nowrap\">\n{{convenio.dsProduto | uppercase}}</span></md-checkbox><div layout=\"row\" layout-wrap flex style=\"font-size: 14px\" \nng-if=\"vm.produtos[convenio.idProduto][\'data\']\">Vinculado Em: {{vm.produtos[convenio.idProduto][\'data\']}}</div><div \nlayout=\"row\" layout-wrap flex style=\"font-size: 14px\"><md-radio-group \nng-disabled=\"vm.produtos[convenio.idProduto][\'valor\'] != true\" \nng-model=\"vm.produtos[convenio.idProduto][\'tipoPagamento\']\"><div><md-radio-button ng-value=\"1\" aria-label=\"Folha\" \nng-disabled=\"vm.produtos[convenio.idProduto][\'valor\'] != true\" style=\"padding-right: 2px\">Folha</md-radio-button></div>\n<div><md-radio-button ng-value=\"2\" aria-label=\"Boleto\" ng-disabled=\"vm.produtos[convenio.idProduto][\'valor\'] != true\">\nBoleto</md-radio-button></div><div><md-radio-button ng-value=\"3\" aria-label=\"Sem Desconto\" \nng-disabled=\"vm.produtos[convenio.idProduto][\'valor\'] != true\">S/ Desconto</md-radio-button></div></md-radio-group>\n</div><div layout=\"row\" layout-wrap flex style=\"font-size: 14px\" ng-if=\"convenio.inProdutoPorQuantidadeDependentes\">\n<md-select ng-disabled=\"vm.produtos[convenio.idProduto][\'valor\'] != true\" \nng-model=\"vm.produtos[convenio.idProduto][\'nuDependentes\']\" placeholder=\"Qtd Dependentes\" class=\"md-no-underline\">\n<md-option ng-repeat=\"qtd in vm.qtdDenpendente\" value=\"{{qtd}}\">{{qtd}}</md-option></md-select></div></md-card-content>\n</md-card></div></form><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\"></md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.sairSemSalvar()\">Sair sem Salvar</md-button><div class=\"steps\">\n<span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span>\n</div><md-button class=\"md-raised md-warn\" ng-click=\"vm.cadastrarAssociado();msWizard.nextStep();\" \nng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Salvar e Próximo</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">></md-button></div></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep3.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid || wizardStep5.$invalid \">5</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep5.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Dependentes</span></span></md-tab-label><md-tab-body><form name=\"wizardStep5\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"60\"><input type=\"text\" name=\"Nome Dependente\" ng-model=\"vm.dependente.noDependente\" \nplaceholder=\"Nome do Dependente\"></md-input-container><md-input-container flex=\"20\"><input type=\"text\" \nname=\"dtDependente\" mask=\"99/99/9999\" ng-model=\"vm.dependente.dtNascimento\" placeholder=\"Data Nascimento\">\n</md-input-container><div ng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div><md-input-container flex=\"20\"><md-select \nng-model=\"vm.dependente.tpParentesco\" name=\"parentesco\" placeholder=\"Parentesco\"><md-option \nng-repeat=\"parentesco in vm.parentesco\" value=\"{{parentesco.tpParentesco}}\">{{parentesco.noParentesco}}</md-option>\n</md-select></md-input-container><md-button class=\"md-fab\" aria-label=\"Cadastrar Dependente\" style=\"\" \nng-if=\"!vm.dependenteEdicao\" ng-click=\"vm.cadastrarDependente()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Dependente</md-tooltip></md-button><md-button class=\"md-fab\" \naria-label=\"Editar Dependente\" ng-if=\"vm.dependenteEdicao\" style=\"\" ng-click=\"vm.editarDependente()\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Editar Dependente</md-tooltip></md-button></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><div flex=\"100\" class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data de Nascimento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Parentesco</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remover</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"dependente in vm.dependentes\"><td>{{dependente.noDependente}}</td><td>{{dependente.dtNascimento}}\n</td><td><span ng-if=\"dependente.tpParentesco == \'P\'\">Pai</span> <span ng-if=\"dependente.tpParentesco == \'M\'\">Mãe\n</span> <span ng-if=\"dependente.tpParentesco == \'F\'\">Filho</span> <span ng-if=\"dependente.tpParentesco == \'C\'\">Cônjuge\n</span></td><td><md-progress-circular ng-if=\"localLoadingDependente[$index]\" \nstyle=\"margin-left:auto; margin-right:auto; display:block; float: left\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"35\"></md-progress-circular><md-icon md-font-icon=\"icon-trash\" \nng-init=\"localLoadingDependente[$index] = false\" ng-if=\"!localLoadingDependente[$index]\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.showConfirmDependente($event, dependente, $index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon>\n<md-icon md-font-icon=\"icon-tooltip-edit\" ng-init=\"localLoadingDependente[$index] = false\" \nng-if=\"!localLoadingDependente[$index]\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.preencherDependenteEdicao(dependente, $index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon></td>\n</tr></tbody></table></div></div><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\"></md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.sairSemSalvar()\">Sair sem Salvar</md-button><div class=\"steps\">\n<span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span>\n</div><md-button class=\"md-raised md-warn\" ng-click=\"vm.cadastrarAssociado(true);\" \nng-disabled=\"msWizard.currentStepInvalid()\">Salvar e Próximo</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">\n</md-button></div></form></md-tab-body></md-tab></md-tabs></ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/associado/views/cadastro_associado_externo.html","<div id=\"conteudo\" ng-init=\"vm.carregarCadastroAssociadoExterno();\" class=\"associado_externo\" layout=\"column\"><div \nclass=\"md-title mt-32 tituloGrid ng-binding\" style=\"padding-left: 10px\">Aprovar associado</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" style=\"width: 100%\"><div class=\"content\"><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\"><md-progress-circular id=\"default-progress\" \nclass=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div\n class=\"white-bg md-whiteframe-4dp\" layout=\"row\"><ms-form-wizard flex style=\"width: 100%\"><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" ng-init=\"vm.setWizard(msWizard)\"><md-tab id><md-tab-body>\n<div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px;color: #757575\">Dados Pessoais</div><hr \nstyle=\"color: #ccc\"><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 84px;vertical-align: bottom\"><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"cpf\" ng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.nuCpf\" \nplaceholder=\"CPF*\" ng-blur=\"vm.isAssociadoCadastrado()\" mask=\"999.999.999-99\" ng-cpf required><div \nng-messages=\"wizardStep1.cpf.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o Cpf.</span></div><div \nng-message=\"cpf\">CPF inválido</div></div></md-input-container><md-input-container flex=\"5\"></md-input-container>\n<md-input-container flex=\"25\" flex-gt-xs=\"25\"><input type=\"text\" name=\"dtNascimento\" \nng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.dtNascimento\" placeholder=\"Data de Nascimento*\" \nmask=\"99/99/9999\"><div ng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA Data de Nascimento é Obrigatória.</span></div><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container><md-input-container flex=\"25\" \nflex-gt-xs=\"25\"><md-select ng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.tpSexo\" name=\"tpSexo\" \nplaceholder=\"Sexo\"><md-option value=\"M\">Masculino</md-option><md-option value=\"F\">Feminino</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"text\" name=\"dsMatriculaFuncional\" ng-model=\"vm.associadoExternoAprovacao.associado.dsMatriculaFuncional\" \nplaceholder=\"Matrícula Funcional*\" mask=\"9.999.999-%\" ng-blur=\"vm.mascararMatricula()\" required><div \nng-messages=\"wizardStep1.dsMatriculaFuncional.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPrrencha a Matrícula Funcional do Associado</span></div></div></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"nomeAssociado\" \nng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.noPessoa\" placeholder=\"Nome do Associado*\" required><div \nng-messages=\"wizardStep1.nomeAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Nome do associado é obrigatório</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex><div flex=\"100\" flex-gt-xs=\"50\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"25\"><input \ntype=\"text\" name=\"rgAssociado\" ng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.dsRg\" placeholder=\"RG*\" \nrequired><div ng-messages=\"wizardStep1.rgAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o RG do associado.</span></div></div></md-input-container><md-input-container flex=\"25\"><input type=\"text\" \nname=\"dtExpedicao\" ng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.dtExpedicao\" \nplaceholder=\"Dt Expedição\" mask=\"99/99/9999\"><div ng-messages=\"wizardStep1.dtExpedicao.$error\" role=\"alert\"><div \nng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container><div \nflex=\"5\"></div><md-input-container flex=\"30\"><md-select \nng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.orgaoExpeditor\" name=\"orgaoExpeditorAssociado\" \nplaceholder=\"Órgão Expedidor*\" required><md-option ng-repeat=\"orgaoExpeditor in vm.orgaoExpeditor\" \nng-init=\"vm.associadoExternoAprovacao.associado.pessoaFisica.orgaoExpeditor = 1\" \nvalue=\"{{orgaoExpeditor.idOrgaoEmissor}}\">{{orgaoExpeditor.noOrgaoEmissor}}</md-option></md-select><div \nng-messages=\"wizardStep1.orgaoExpeditorAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Orgão Expeditor.</span></div></div></md-input-container><md-input-container flex=\"20\"><md-select \nng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.estadoExpeditor\" placeholder=\"UF*\" required \nname=\"estadoExpeditorAssociado\"><md-option \nng-init=\"vm.associadoExternoAprovacao.associado.pessoaFisica.estadoExpeditor = 7\" ng-repeat=\"estado in vm.estados\" \nvalue=\"{{estado.idEstado}}\">{{estado.dsSigla}}</md-option></md-select><div \nng-messages=\"wizardStep1.estadoExpeditorAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Estado Expeditor.</span></div></div></md-input-container></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.tpEstadoCivil\" name=\"tpEstadoCivil\" \nplaceholder=\"Estado Civil*\" required><md-option value=\"C\">Casado</md-option><md-option value=\"D\">Divorciado</md-option>\n<md-option value=\"S\">Solteiro</md-option><md-option value=\"V\">Viúvo</md-option></md-select><div \nng-messages=\"wizardStep1.tpEstadoCivil.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Estado Civil é Obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" style=\"margin-top: 0px\"><span \nng-show=\"vm.associadoExternoAprovacao.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><md-checkbox \nng-model=\"vm.associadoExternoAprovacao.inConjugeServidor\" aria-label=\"Cônjuge é servidor do sistema penitenciário?*\">\nCônjuge é servidor do sistema penitenciário?</span></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex ng-show=\"vm.associadoExternoAprovacao.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"noPessoaConjuge\" ng-model=\"vm.associadoExternoAprovacao.noConjuge\" \nplaceholder=\"Nome Cônjuge*\" ng-required=\"vm.associadoExternoAprovacao.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><div\n ng-messages=\"wizardStep1.noPessoaConjuge.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Nome é Obrigatório.\n</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"dtNascimento\" ng-model=\"vm.associadoExternoAprovacao.dtNascimentoConjuge\" \nplaceholder=\"Data de Nascimento Cônjuge\" mask=\"99/99/9999\"><div ng-messages=\"wizardStep1.dtNascimento.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>A Data de Nascimento é Obrigatória.</span></div><div ng-message=\"mask\">\n<span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container></div></form><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"localLoading\"><md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" \nid=\"toolbar-progress-login\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n</div><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px;color: #757575\">Dados Funcionais</div><hr \nstyle=\"color: #ccc\"><form name=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"noGuerra\" ng-model=\"vm.associadoExternoAprovacao.associado.noGuerra\" placeholder=\"Nome de Guerra\"><div \nng-messages=\"wizardStep2.noGuerra.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Nome de Guerra é Obrigatório.\n</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.associadoExternoAprovacao.associado.cargoAssociado\" name=\"cargoAssociado\" placeholder=\"Cargo*\" required>\n<md-option ng-repeat=\"cargo in vm.cargoAssociado\" value=\"{{cargo.idCargoAssociado}}\">{{cargo.noCargoAssociado}}\n</md-option></md-select><div ng-messages=\"wizardStep2.cargoAssociado.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>O Cargo é Obrigatório.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"50\"><md-select ng-model=\"vm.associadoExternoAprovacao.associado.lotacaoAssociado\" \nname=\"lotacaoAssociado\" placeholder=\"Lotação*\" required><md-option ng-repeat=\"lotacao in vm.lotacaoAssociado\" \nvalue=\"{{lotacao.idLotacaoAssociado}}\">{{lotacao.noLotacaoAssociado}}</md-option></md-select><div \nng-messages=\"wizardStep2.lotacaoAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>A Lotação é Obrigatória\n</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"noEmail\" ng-model=\"vm.associadoExternoAprovacao.associado.pessoaFisica.dsEmail\" placeholder=\"Email*\" \nclass=\"text-to-lower\" required><div ng-messages=\"wizardStep2.noEmail.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Email é Obrigatório.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<h3 class=\"md-title\" ng-if=\"vm.telefoneAssociado.length > 1\">Telefones</h3><h3 class=\"md-title\" \nng-if=\"vm.telefoneAssociado.length <= 1\">Telefone</h3></div><div layout=\"column\" layout-gt-xs=\"row\" flex><div \nflex=\"100\" flex-gt-xs=\"100\"><md-input-container><input type=\"text\" name=\"Telefone\" mask=\"(99)99999-999?9\" \nng-model=\"vm.telefone\" placeholder=\"Telefone\"><div ng-messages=\"wizardStep2.telefone.$error\" role=\"alert\"><div \nng-if=\"!vm.isTelefoneAdicionado\"><span>Ao menos um Telefone é Obrigatório.</span></div></div></md-input-container>\n<md-button class=\"md-fab\" aria-label=\"Cadastar Novo Telefone\" style=\"\" ng-click=\"vm.cadastrarTelefone()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"left\">Adicionar Telefone</md-tooltip></md-button></div></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"datatable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Telefone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remover</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(index, telefone) in vm.telefonesExterno\"><td>{{ telefone.dsTelefone}}</td><td><md-icon \nmd-font-icon=\"icon-trash\" class=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.showConfirmTelefone($event, telefone, index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon></td>\n</tr></tbody></table></div><div flex=\"55\"></div></div></form><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px;color: #757575\">Filiação e Endereço</div><hr style=\"color: #ccc\"><form name=\"wizardStep3\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"50\"><input type=\"text\" name=\"noMae\" ng-model=\"vm.associadoExternoAprovacao.associado.noMae\" \nplaceholder=\"Nome da mãe*\" required><div ng-messages=\"wizardStep3.noMae.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O Nome da mãe é requerido.</span></div></div></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"50\"><input type=\"text\" name=\"dtNascimentoMae\" \nng-model=\"vm.associadoExternoAprovacao.associado.dtNascimentoMae\" mask=\"99/99/9999\" \nplaceholder=\"Data de Nascimento da mãe\"><div ng-messages=\"wizardStep3.dtNascimentoMae.$error\" role=\"alert\"><div \nng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"noPai\" \nng-model=\"vm.associadoExternoAprovacao.associado.noPai\" placeholder=\"Nome do pai\"></md-input-container><div flex=\"5\">\n</div><md-input-container flex=\"50\"><input type=\"text\" name=\"dtNascimentoPai\" mask=\"99/99/9999\" \nng-model=\"vm.associadoExternoAprovacao.associado.dtNascimentoPai\" placeholder=\"Data de Nascimento do pai\"><div \nng-messages=\"wizardStep3.dtNascimentoPai.$error\" role=\"alert\"><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"nuCep\" \nng-model=\"vm.enderecoExterno.nuCep\" placeholder=\"CEP*\" mask=\"99999-999\" required><div \nng-messages=\"wizardStep3.nuCep.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o CEP.</span></div></div>\n</md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\"><md-select ng-model=\"vm.enderecoExterno.estado\" \nname=\"estado\" placeholder=\"Estado*\" required><md-option ng-repeat=\"estado in vm.estados\" \nng-init=\"vm.enderecoExterno.estado = 7\" value=\"{{estado.idEstado}}\">{{estado.noEstado}}</md-option></md-select><div \nng-messages=\"wizardStep4.estado.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Estado é requerido.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\">\n<input type=\"text\" name=\"dsEndereco\" ng-model=\"vm.enderecoExterno.dsEndereco\" placeholder=\"Endereço*\" required><div \nng-messages=\"wizardStep3.dsEndereco.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o endereço.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\">\n<input type=\"text\" name=\"dsBairro\" ng-model=\"vm.enderecoExterno.dsBairro\" placeholder=\"Bairro*\" required><div \nng-messages=\"wizardStep3.dsBairro.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o Bairro.</span></div>\n</div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\"><input type=\"text\" name=\"dsCidade\" \nng-model=\"vm.enderecoExterno.dsCidade\" placeholder=\"Cidade*\" required><div ng-messages=\"wizardStep4.dsCidade.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha a Cidade.</span></div></div></md-input-container></div></form>\n<div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px;color: #757575\">Dependentes</div><hr \nstyle=\"color: #ccc\"><form name=\"wizardStep5\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"60\"><input type=\"text\" name=\"Nome Dependente\" \nng-model=\"vm.dependente.noDependente\" placeholder=\"Nome do Dependente\"></md-input-container><md-input-container \nflex=\"20\"><input type=\"text\" name=\"dtDependente\" mask=\"99/99/9999\" ng-model=\"vm.dependente.dtNascimento\" \nplaceholder=\"Data Nascimento\"></md-input-container><div ng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div\n ng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div><md-input-container flex=\"20\">\n<md-select ng-model=\"vm.dependente.tpParentesco\" name=\"parentesco\" placeholder=\"Parentesco\"><md-option \nng-repeat=\"parentesco in vm.parentesco\" value=\"{{parentesco.tpParentesco}}\">{{parentesco.noParentesco}}</md-option>\n</md-select></md-input-container><md-button class=\"md-fab\" aria-label=\"Cadastrar Dependente\" style=\"\" \nng-if=\"!vm.dependenteEdicao\" ng-click=\"vm.cadastrarDependente()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Dependente</md-tooltip></md-button><md-button class=\"md-fab\" \naria-label=\"Editar Dependente\" ng-if=\"vm.dependenteEdicao\" style=\"\" ng-click=\"vm.editarDependente()\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Editar Dependente</md-tooltip></md-button></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><div flex=\"100\" class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data de Nascimento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Parentesco</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remover</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"dependente in vm.dependentesExterno\"><td>{{dependente.noDependente}}</td><td>\n{{dependente.dtNascimento}}</td><td><span ng-if=\"dependente.tpParentesco == \'P\'\">Pai</span> <span \nng-if=\"dependente.tpParentesco == \'M\'\">Mãe</span> <span ng-if=\"dependente.tpParentesco == \'F\'\">Filho</span> <span \nng-if=\"dependente.tpParentesco == \'C\'\">Cônjuge</span></td><td><md-progress-circular \nng-if=\"localLoadingDependente[$index]\" style=\"margin-left:auto; margin-right:auto; display:block; float: left\" \nid=\"toolbar-progress-login\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"35\"></md-progress-circular><md-icon \nmd-font-icon=\"icon-trash\" ng-init=\"localLoadingDependente[$index] = false\" ng-if=\"!localLoadingDependente[$index]\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.showConfirmDependente($event, dependente, $index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon>\n<md-icon md-font-icon=\"icon-tooltip-edit\" ng-init=\"localLoadingDependente[$index] = false\" \nng-if=\"!localLoadingDependente[$index]\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.preencherDependenteEdicao(dependente, $index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon></td>\n</tr></tbody></table></div></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\">\n<md-progress-circular id=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"!loadingTable\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.voltarAprovacao()\">Sair</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.cadastrarAssociadoExterno();\" ng-disabled=\"msWizard.currentStepInvalid()\">Salvar</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\"></md-button></div></form></md-tab-body></md-tab></md-tabs></ms-form-wizard>\n</div></div></div></div>");
$templateCache.put("app/main/associado/views/dashboard.html","<div layout=\"row\" ng-init=\"vm.init()\"><div class=\"widget-group\" layout=\"column\" flex=\"25\"><ms-widget flex>\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\" style=\"line-height:30px\"><div \nclass=\"pt-8 pb-32 ng-scope layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72 ng-binding\">{{vm.associadosAtivos}}</div><div \nclass=\"h3 secondary-text font-weight-500 ng-binding\">Associados Ativos</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Associados</span></div>\n</ms-widget-front></ms-widget><ms-widget flex style=\"padding-bottom:0px\" layout-align=\"end end\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\" style=\"line-height:30px\"><div \nclass=\"pt-8 pb-32 ng-scope layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-72 line-height-72 ng-binding\">{{vm.associadosInativos}}</div><div \nclass=\"h3 secondary-text font-weight-500 ng-binding\">Associados Inativos</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Associados</span></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"column\" flex=\"75\" \nstyle=\"padding-top: 12px;padding-right: 12px;	flex-grow: 1;flex-basis: auto\"><div \nclass=\"simple-table-container md-whiteframe-4dp\" style=\"height: 100%\"><div class=\"table-title\" \nng-if=\"!vm.aniversariantes.length > 0\" style=\"text-align: center; margin: auto\">Não há aniversariantes</div><div \nclass=\"ms-responsive-table-wrapper\" style=\"margin: 0 auto\" ng-if=\"vm.aniversariantes.length > 0\"><div \nclass=\"table-title\" style=\"padding: 10px\">Próximos aniversariantes</div><table class=\"simple\" \nms-responsive-table=\"true\" style=\"width: 95%\" align=\"center\"><thead><tr><th>Dt. Nascimento</th><th>Nome</th></tr>\n</thead><tbody><tr ng-repeat=\"aniversariante in vm.aniversariantes\"><td style=\"padding: 10px 8px\">\n{{aniversariante.dt_nascimento_format}}</td><td style=\"padding: 8px 8px\">{{aniversariante.no_pessoa | uppercase }}</td>\n</tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/associado/views/ficha.html","<div ng-init=\"vm.getFicha()\" style=\"width: 100%; height: 100%\"><md-button class=\"md-fab\" aria-label=\"Editar Associado\" \nui-sref=\"app.associado.edit({idAssociado:vm.idAssociado})\" \nstyle=\"position: absolute; left: 0; margin-right: 16px;margin-top: 50px\"><md-icon md-font-icon=\"icon-tooltip-edit\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Ficha Associado</md-tooltip></md-button><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><object \nng-show=\"dataPdf\" data=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/associado/views/listar.html","<div id=\"conteudo\" ng-init=\"vm.pesquisar()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\nAssociados</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Lista de Associados Cadastrados</div><div \nclass=\"content page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.preencherCombos()\"><form \nname=\"wizardStep1\" class=\"md-inline-form\" novalidate flex-offset=\"3\" ng-submit=\"vm.pesquisar()\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><div flex=\"5\"></div><md-input-container flex=\"30\"><input type=\"text\" name=\"nomeAssociado\" \nng-model=\"pesquisa.noAssociado\" placeholder=\"Nome do Associado\"></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"30\"><input type=\"text\" name=\"matriculaAspen\" ng-model=\"pesquisa.matriculaAsspen\" \nplaceholder=\"Matrícula Asspen\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"30\"><input \ntype=\"text\" name=\"CPF\" ng-model=\"pesquisa.nuCpf\" name=\"nuCpf\" mask=\"999.999.999-99\" placeholder=\"CPF\">\n</md-input-container><div flex=\"5\"><md-button class=\"md-fab\" aria-label=\"Listar Telefone\" style=\"\" type=\"submit\">\n<md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Pesquisar Associado</md-tooltip></md-button></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><div flex=\"5\"></div><md-input-container flex=\"30\"><md-select ng-model=\"pesquisa.inAtivo\" \nname=\"inAtivo\" placeholder=\"Ativo/Inativo\" required><md-option value=\"\">--</md-option><md-option value=\"true\">Ativo\n</md-option><md-option value=\"false\">Inativo</md-option></md-select></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"30\"><md-select ng-model=\"pesquisa.cargoAssociado\" name=\"cargoAssociado\" placeholder=\"Cargo\">\n<md-option value=\"\">--</md-option><md-option ng-repeat=\"cargo in vm.cargoAssociado\" value=\"{{cargo.idCargoAssociado}}\">\n{{cargo.noCargoAssociado}}</md-option></md-select><div ng-messages=\"wizardStep2.cargoAssociado.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>O Cargo é Obrigatório.</span></div></div></md-input-container><div flex=\"40\"></div>\n</div></form></div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" \nng-init=\"vm.listar()\"><md-button class=\"md-fab\" aria-label=\"Cadastar Novo Usuário\" ui-sref=\"app.associado.add\" \nstyle=\"position: absolute; right: 0; margin-right: 16px\"><md-icon md-font-icon=\"icon-account-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Associado</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp DataTables_Table_1_wrapper\"><table class=\"dataTable row-border hover\" \nng-if=\"!localLoading\"><thead><tr><th class=\"secondary-text\" style=\"width: 15px\"><div class=\"table-header\"><span \nclass=\"column-title\">Matrícula Asspen<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\': vm.ordenacao == \'pessoaFisica.dsMatricula-ASC\'}\" \nng-click=\"vm.ordenar(\'pessoaFisica.dsMatricula-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\': vm.ordenacao == \'pessoaFisica.dsMatricula-DESC\'}\" \nng-click=\"vm.ordenar(\'pessoaFisica.dsMatricula-DESC\')\" style=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \naria-hidden=\"true\"></md-icon></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nome<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\': vm.ordenacao == \'pessoaFisica.noPessoa-ASC\'}\" ng-click=\"vm.ordenar(\'pessoaFisica.noPessoa-ASC\')\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-up\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\': vm.ordenacao == \'pessoaFisica.noPessoa-DESC\'}\" ng-click=\"vm.ordenar(\'pessoaFisica.noPessoa-DESC\')\" \naria-hidden=\"true\"></md-icon></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">CPF<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\': vm.ordenacao == \'pessoaFisica.nuCpf-ASC\'}\" ng-click=\"vm.ordenar(\'pessoaFisica.nuCpf-ASC\')\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-up\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\': vm.ordenacao == \'pessoaFisica.nuCpf-DESC\'}\" ng-click=\"vm.ordenar(\'pessoaFisica.nuCpf-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\" style=\"width: 15px\"><div class=\"table-header\"><span class=\"column-title\">Ações</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\" style=\"width: 20px\"><span class=\"column-title\">Ativo</span></div>\n</th></tr></thead><tbody><tr ng-if=\"localLoading\"><td colspan=\"6\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></td></tr><tr \nng-repeat=\"associado in vm.resultadoAssociado\" \nng-init=\"vm.inAtivo[associado._embedded.pessoaFisica.idPessoaFisica] = associado._embedded.pessoaFisica.inAtivo;\" \nng-if=\"!localLoading\"><td>{{associado._embedded.pessoaFisica.dsMatricula }}</td><td>\n{{associado._embedded.pessoaFisica.noPessoa|uppercase}}</td><td class=\"text-to-lower\">\n{{associado._embedded.pessoaFisica.nuCpf|brCpf}}</td><td style=\"min-width: 150px\"><a \nui-sref=\"app.associado.edit({idAssociado:associado.idAssociado})\"><md-icon md-font-icon=\"icon-tooltip-edit\" \ntitle=\"Editar\" aria-label=\"Editar\" class=\"icon s24 ng-scope md-font icon-tooltip-edit material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></a><a ui-sref=\"app.associado.ficha({idAssociado:associado.idAssociado})\"><md-icon \nmd-font-icon=\"icon-eye\" title=\"Visualizar\" aria-label=\"Visualizar\" \nclass=\"icon s24 ng-scope md-font icon-eye material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a></td><td>\n<md-button md-no-ink class=\"md-warn md-raised\" ng-click=\"vm.desativarOuAtivar(associado)\" \nng-if=\"!associado._embedded.pessoaFisica.inAtivo\">Ativar</md-button><md-button md-no-ink \nng-click=\"vm.modalDesativar($event, associado)\" class=\"md-primary md-raised\" \nng-if=\"associado._embedded.pessoaFisica.inAtivo\">Desativar</md-button></td></tr><tr><td colspan=\"5\"><div \nclass=\"layout-row layout-align-space-between-center\"><div class=\"layout-row layout-align-start-center\"><span \nstyle=\"padding-right: 8px\">Mostrar</span><md-select style=\"margin: 0px\" ng-model=\"vm.itensPorPagina\" \nng-change=\"vm.mudatPageSize()\" placeholder=\"Itens Por Pagina\" class=\"md-no-underline\"><md-option value=\"10\">10\n</md-option><md-option value=\"20\">20</md-option><md-option value=\"30\">30</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"50\">50</md-option><md-option value=\"100\">100</md-option></md-select><span \nstyle=\"padding-left: 8px\">registros</span></div><div><md-button ng-click=\"vm.primeiraPagina()\" title=\"Primeira página\">\nPrimeira</md-button><md-button ng-disabled=\"vm.paginaAtual <= 1\" ng-click=\"vm.adicionaPagina(-1)\">Anterior</md-button>\n<b>{{vm.paginaAtual}} de {{vm.pesquisaAssociado.page_count}}</b><md-button \nng-disabled=\"vm.paginaAtual >=  vm.pesquisaAssociado.page_count\" style=\"text-align: right\" \nng-click=\"vm.adicionaPagina(1)\">Próximo</md-button><md-button ng-click=\"vm.ultimaPagina()\" title=\"Última página\">Última\n</md-button></div></div></td></tr></tbody></table><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/associado/views/listar_associado_externo.html","<div id=\"conteudo\" ng-init=\"vm.pesquisarAssociadoExterno()\"><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px\">Associados</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">\nAssociados pendentes de aprovação</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp DataTables_Table_1_wrapper\" style=\"border-top: #3ea830 solid 1px;\"><table \nclass=\"dataTable row-border hover\" ng-if=\"!localLoading\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Dt. Cadastro</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">CPF</span></div></th><th class=\"secondary-text\" style=\"width: 15px\">\n<div class=\"table-header\"><span class=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr \nng-if=\"localLoading\"><td colspan=\"6\"><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></td></tr><tr \nng-repeat=\"associadoExternoPesquisa in vm.resultadoAssociadoExterno\" \nng-init=\"vm.inAtivo[associado._embedded.pessoaFisica.idPessoaFisica] = associado._embedded.pessoaFisica.inAtivo;\" \nng-if=\"!localLoading\"><td>{{vm.tratarDataParaBr(associadoExternoPesquisa.dtCadastro.date)}}</td><td>\n{{associadoExternoPesquisa.dsDadosAssociado.associado.pessoaFisica.noPessoa|uppercase}}</td><td class=\"text-to-lower\" \nstyle=\"min-width: 150px\">{{associadoExternoPesquisa.dsDadosAssociado.associado.pessoaFisica.nuCpf}}</td><td \nstyle=\"min-width: 50px\"><md-button md-no-ink class=\"md-accent md-raised\" \nng-click=\"vm.visualizarAssociadoExterno(associadoExternoPesquisa)\">Visualizar</md-button></td></tr></tbody></table><div\n layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/associado/views/modal-desativar.html","<div class=\"simple-table-container md-whiteframe-4dp\" style=\"height: 100%\"><div class=\"content\"><div layout-wrap \nlayout-gt-sm=\"row\"><div class=\"table-title\">Antes de desativar você cofirma que:</div><div flex=\"100\" \nstyle=\"padding-left: 35px\"><div class=\"row\"><md-input-container><md-checkbox ng-model=\"perguntasDesativar.processo\" \naria-label=\" O associado não tem processos jurídicos vínculados a ASSPEN.\">\nO associado não tem processos jurídicos vínculados a ASSPEN.</md-checkbox></md-input-container></div><div class=\"row\">\n<md-input-container><md-checkbox ng-model=\"perguntasDesativar.convenios\" \naria-label=\" O associado não tem processos jurídicos vínculados a ASSPEN.\">Desvinculou o associado dos convênios.\n</md-checkbox></md-input-container></div></div></div><div layout-wrap layout-gt-sm=\"row\"><div class=\"table-title\">\nQual o motivo da dissociação?</div><div flex=\"100\" style=\"padding-left: 35px\"><md-input-container><md-select \nng-model=\"motivo\" name=\"motivo\" placeholder=\"Motivos da dissociação\" required><md-option \nng-repeat=\"motivo in motivoDissociacao\" value=\"{{motivo.idMotivo}}\">{{motivo.dsMotivo}}</md-option></md-select>\n</md-input-container></div></div><div class=\"navigation\" flex layout=\"row\" layout-align=\"left center\" \nstyle=\"padding-left: 25px;padding-bottom: 25px\"><md-button class=\"md-raised md-warn\" ng-click=\"desativarOuAtivar();\" \nng-disabled=\"perguntasDesativar.processo == false || perguntasDesativar.convenios == false || motivo == null\">Desativar\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"cancelarDesativacao();\">Cancelar</md-button></div></div>\n</div>");
$templateCache.put("app/main/associado_externo/views/cadastro_associado.html","<div id=\"conteudo\" ng-init=\"vm.init();\" class=\"associado_externo\" layout=\"column\" layout-align=\"center center\"><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\"><div \nclass=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\"><md-progress-circular \nid=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" md-diameter=\"40\">\n</md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp card_principal\" ng-if=\"!loadingTable\" \nstyle=\"margin-top: -20px\" layout=\"row\"><span ng-if=\"vm.mostrarFormulario == 2\" class=\"md-display-1\" \nstyle=\"padding: 50px\">Seu cadastro foi enviado para aprovação na ASSPEN-DF. </span><span \nng-if=\"vm.mostrarFormulario == 3\" class=\"md-display-2\" style=\"padding: 50px\">Você já possui cadastro na ASSPEN-DF. \n</span><span ng-if=\"vm.mostrarFormulario == 4\" class=\"md-display-2\" style=\"padding: 50px\">\nAtualização enviada com sucesso</span><ms-form-wizard flex ng-if=\"vm.mostrarFormulario == 1\"><md-tabs \nmd-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" ng-init=\"vm.setWizard(msWizard)\"><md-tab \nid><md-tab-body><img style=\"max-height: 250px;width: 100%\" src=\"assets/images/logos/logo3.jpg\"><div \nclass=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px;color: #757575\">Dados Pessoais</div><hr \nstyle=\"color: #ccc\"><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 84px;vertical-align: bottom\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"cpf\" ng-model=\"vm.associado.pessoaFisica.nuCpf\" placeholder=\"CPF\" \nng-blur=\"vm.isAssociadoCadastrado()\" mask=\"999.999.999-99\" ng-cpf required><div ng-messages=\"wizardStep1.cpf.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o Cpf.</span></div><div ng-message=\"cpf\">CPF inválido</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"25\"><input type=\"text\" name=\"dtNascimento\" \nng-model=\"vm.associado.pessoaFisica.dtNascimento\" placeholder=\"Data de Nascimento\" mask=\"99/99/9999\" required><div \nng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA Data de Nascimento é Obrigatória.</span></div><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"25\"><md-select ng-model=\"vm.associado.pessoaFisica.tpSexo\" name=\"tpSexo\" placeholder=\"Sexo\"><md-option \nvalue=\"M\">Masculino</md-option><md-option value=\"F\">Feminino</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"dsMatriculaFuncional\" ng-model=\"vm.associado.dsMatriculaFuncional\" placeholder=\"Matrícula Funcional\" \nmask=\"9.999.999-%\" ng-blur=\"vm.mascararMatricula()\" required><div \nng-messages=\"wizardStep1.dsMatriculaFuncional.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPrrencha a Matrícula Funcional do Associado</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"nomeAssociado\" ng-model=\"vm.associado.pessoaFisica.noPessoa\" \nplaceholder=\"Nome do Associado*\" required><div ng-messages=\"wizardStep1.nomeAssociado.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O Nome do associado é obrigatório</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"100\" flex-gt-xs=\"100\"><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"25\"><input type=\"text\" name=\"rgAssociado\" ng-model=\"vm.associado.pessoaFisica.dsRg\" \nplaceholder=\"RG*\" required><div ng-messages=\"wizardStep1.rgAssociado.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Preencha o RG do associado.</span></div></div></md-input-container><md-input-container flex=\"25\"><input \ntype=\"text\" name=\"dtExpedicao\" ng-model=\"vm.associado.pessoaFisica.dtExpedicao\" placeholder=\"Dt Expedição\" \nmask=\"99/99/9999\"><div ng-messages=\"wizardStep1.dtExpedicao.$error\" role=\"alert\"><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"30\"><md-select ng-model=\"vm.associado.pessoaFisica.orgaoExpeditor\" \nname=\"orgaoExpeditorAssociado\" placeholder=\"Órgão Expedidor*\" required><md-option \nng-repeat=\"orgaoExpeditor in vm.orgaoExpeditor\" ng-init=\"vm.associado.pessoaFisica.orgaoExpeditor = 1\" \nvalue=\"{{orgaoExpeditor.idOrgaoEmissor}}\">{{orgaoExpeditor.noOrgaoEmissor}}</md-option></md-select><div \nng-messages=\"wizardStep1.orgaoExpeditorAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Orgão Expeditor.</span></div></div></md-input-container><md-input-container flex=\"20\"><md-select \nng-model=\"vm.associado.pessoaFisica.estadoExpeditor\" placeholder=\"UF*\" required name=\"estadoExpeditorAssociado\">\n<md-option ng-init=\"vm.associado.pessoaFisica.estadoExpeditor = 7\" ng-repeat=\"estado in vm.estados\" \nvalue=\"{{estado.idEstado}}\">{{estado.dsSigla}}</md-option></md-select><div \nng-messages=\"wizardStep1.estadoExpeditorAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Estado Expeditor.</span></div></div></md-input-container></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.associado.pessoaFisica.tpEstadoCivil\" name=\"tpEstadoCivil\" placeholder=\"Estado Civil*\" required><md-option\n value=\"C\">Casado</md-option><md-option value=\"D\">Divorciado</md-option><md-option value=\"S\">Solteiro</md-option>\n<md-option value=\"V\">Viúvo</md-option></md-select><div ng-messages=\"wizardStep1.tpEstadoCivil.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>O Estado Civil é Obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" style=\"margin-top: 0px\"><span \nng-show=\"vm.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><md-checkbox ng-model=\"vm.associado.inConjugeServidor\" \naria-label=\"Cônjuge é servidor do sistema penitenciário?*\">Cônjuge é servidor do sistema penitenciário?</span>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nng-show=\"vm.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"noPessoaConjuge\" ng-model=\"vm.associado.noConjuge\" placeholder=\"Nome Cônjuge*\" \nng-required=\"vm.associado.pessoaFisica.tpEstadoCivil == \'C\'\"><div ng-messages=\"wizardStep1.noPessoaConjuge.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>O Nome é Obrigatório.</span></div></div></md-input-container><div \nflex=\"5\"></div><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input type=\"text\" name=\"dtNascimento\" \nng-model=\"vm.associado.dtNascimentoConjuge\" placeholder=\"Data de Nascimento Cônjuge\" mask=\"99/99/9999\"><div \nng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA Data de Nascimento é Obrigatória.</span></div><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><lf-ng-md-file-input lf-files=\"vm.foto.noArquivo\" \nlf-placeholder=\"Foto\" lf-browse-label=\"Selecione\" lf-drag-and-drop-label=\"Arraste a Foto, Solte aqui ou Selecione\" \naccept=\"image/*\" preview progress></lf-ng-md-file-input><div ng-messages=\"wizardStep1.noArquivo.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Selecione um arquivo para a foto</span></div></div></md-input-container></div></form>\n<div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"localLoading\"><md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" \nid=\"toolbar-progress-login\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n</div><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px;color: #757575\">Dados Funcionais</div><hr \nstyle=\"color: #ccc\"><form name=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"noGuerra\" ng-model=\"vm.associado.noGuerra\" placeholder=\"Nome de Guerra\"><div \nng-messages=\"wizardStep2.noGuerra.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Nome de Guerra é Obrigatório.\n</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.associado.cargoAssociado\" name=\"cargoAssociado\" placeholder=\"Cargo*\" required><md-option \nng-repeat=\"cargo in vm.cargoAssociado\" value=\"{{cargo.idCargoAssociado}}\">{{cargo.noCargoAssociado}}</md-option>\n</md-select><div ng-messages=\"wizardStep2.cargoAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Cargo é Obrigatório.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"50\"><md-select ng-model=\"vm.associado.lotacaoAssociado\" name=\"lotacaoAssociado\" \nplaceholder=\"Lotação*\" required><md-option ng-repeat=\"lotacao in vm.lotacaoAssociado\" \nvalue=\"{{lotacao.idLotacaoAssociado}}\">{{lotacao.noLotacaoAssociado}}</md-option></md-select><div \nng-messages=\"wizardStep2.lotacaoAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>A Lotação é Obrigatória\n</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"noEmail\" ng-model=\"vm.associado.pessoaFisica.dsEmail\" placeholder=\"Email*\" class=\"text-to-lower\" \nrequired><div ng-messages=\"wizardStep2.noEmail.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmail é Obrigatório.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><h3 \nclass=\"md-title\" ng-if=\"vm.telefoneAssociado.length > 1\">Telefones</h3><h3 class=\"md-title\" \nng-if=\"vm.telefoneAssociado.length <= 1\">Telefone</h3></div><div layout=\"column\" layout-gt-xs=\"row\" flex><div \nflex=\"100\" flex-gt-xs=\"100\"><md-input-container><input type=\"text\" name=\"Telefone\" mask=\"(99)99999-999?9\" \nng-model=\"vm.telefone\" placeholder=\"Telefone\" ng-blur=\"vm.cadastrarTelefone()\"><div \nng-messages=\"wizardStep2.telefone.$error\" role=\"alert\"><div ng-if=\"!vm.isTelefoneAdicionado\"><span>\nAo menos um Telefone é Obrigatório.</span></div></div></md-input-container><md-button class=\"md-fab\" \naria-label=\"Cadastar Novo Telefone\" style=\"\" ng-click=\"vm.cadastrarTelefone()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Telefone</md-tooltip></md-button></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\"><table class=\"datatable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Telefone</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remover</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"(index, telefone) in vm.telefones\"><td>{{ telefone.dsTelefone}}</td><td><md-icon \nmd-font-icon=\"icon-trash\" class=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.showConfirmTelefone($event, telefone, index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon></td>\n</tr></tbody></table></div><div flex=\"55\"></div></div></form><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px;color: #757575\">Filiação e Endereço</div><hr style=\"color: #ccc\"><form name=\"wizardStep3\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"50\"><input type=\"text\" name=\"noMae\" ng-model=\"vm.associado.noMae\" placeholder=\"Nome da mãe*\" required><div \nng-messages=\"wizardStep3.noMae.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Nome da mãe é requerido.</span>\n</div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\"><input type=\"text\" \nname=\"dtNascimentoMae\" ng-model=\"vm.associado.dtNascimentoMae\" mask=\"99/99/9999\" \nplaceholder=\"Data de Nascimento da mãe\"><div ng-messages=\"wizardStep3.dtNascimentoMae.$error\" role=\"alert\"><div \nng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"noPai\" \nng-model=\"vm.associado.noPai\" placeholder=\"Nome do pai\"></md-input-container><div flex=\"5\"></div><md-input-container \nflex=\"50\"><input type=\"text\" name=\"dtNascimentoPai\" mask=\"99/99/9999\" ng-model=\"vm.associado.dtNascimentoPai\" \nplaceholder=\"Data de Nascimento do pai\"><div ng-messages=\"wizardStep3.dtNascimentoPai.$error\" role=\"alert\"><div \nng-message=\"mask\"><span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"nuCep\" \nng-model=\"vm.endereco.nuCep\" placeholder=\"CEP*\" mask=\"99999-999\" required><div ng-messages=\"wizardStep3.nuCep.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o CEP.</span></div></div></md-input-container><div flex=\"5\">\n</div><md-input-container flex=\"50\"><md-select ng-model=\"vm.endereco.estado\" name=\"estado\" placeholder=\"Estado*\" \nrequired><md-option ng-repeat=\"estado in vm.estados\" ng-init=\"vm.endereco.estado = 7\" value=\"{{estado.idEstado}}\">\n{{estado.noEstado}}</md-option></md-select><div ng-messages=\"wizardStep4.estado.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O Estado é requerido.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" name=\"dsEndereco\" \nng-model=\"vm.endereco.dsEndereco\" placeholder=\"Endereço*\" required><div ng-messages=\"wizardStep3.dsEndereco.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o endereço.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\"><input type=\"text\" name=\"dsBairro\" \nng-model=\"vm.endereco.dsBairro\" placeholder=\"Bairro*\" required><div ng-messages=\"wizardStep3.dsBairro.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o Bairro.</span></div></div></md-input-container><div flex=\"5\">\n</div><md-input-container flex=\"50\"><input type=\"text\" name=\"dsCidade\" ng-model=\"vm.endereco.dsCidade\" \nplaceholder=\"Cidade*\" required><div ng-messages=\"wizardStep4.dsCidade.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Preencha a Cidade.</span></div></div></md-input-container></div></form><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px;color: #757575\">Dependentes</div><hr style=\"color: #ccc\"><form name=\"wizardStep5\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"60\"><input type=\"text\" name=\"Nome Dependente\" ng-model=\"vm.dependente.noDependente\" \nplaceholder=\"Nome do Dependente\"></md-input-container><md-input-container flex=\"15\"><input type=\"text\" \nname=\"dtDependente\" mask=\"99/99/9999\" ng-model=\"vm.dependente.dtNascimento\" placeholder=\"Data Nascimento\">\n</md-input-container><div ng-messages=\"wizardStep1.dtNascimento.$error\" role=\"alert\"><div ng-message=\"mask\"><span>\nO valor informado não corresponde a uma Data.</span></div></div><md-input-container flex=\"20\"><md-select \nng-model=\"vm.dependente.tpParentesco\" name=\"parentesco\" placeholder=\"Parentesco\"><md-option \nng-repeat=\"parentesco in vm.parentesco\" value=\"{{parentesco.tpParentesco}}\">{{parentesco.noParentesco}}</md-option>\n</md-select></md-input-container><md-button class=\"md-fab\" aria-label=\"Cadastrar Dependente\" style=\"width: 150px\" \nng-if=\"!vm.dependenteEdicao\" ng-click=\"vm.cadastrarDependente()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Dependente</md-tooltip></md-button><md-button class=\"md-fab\" \naria-label=\"Editar Dependente\" ng-if=\"vm.dependenteEdicao\" style=\"\" ng-click=\"vm.editarDependente()\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Editar Dependente</md-tooltip></md-button></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><div flex=\"100\" class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data de Nascimento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Parentesco</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remover</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"dependente in vm.dependentes\"><td>{{dependente.noDependente}}</td><td>{{dependente.dtNascimento}}\n</td><td><span ng-if=\"dependente.tpParentesco == \'P\'\">Pai</span> <span ng-if=\"dependente.tpParentesco == \'M\'\">Mãe\n</span> <span ng-if=\"dependente.tpParentesco == \'F\'\">Filho</span> <span ng-if=\"dependente.tpParentesco == \'C\'\">Cônjuge\n</span></td><td><md-progress-circular ng-if=\"localLoadingDependente[$index]\" \nstyle=\"margin-left:auto; margin-right:auto; display:block; float: left\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"35\"></md-progress-circular><md-icon md-font-icon=\"icon-trash\" \nng-init=\"localLoadingDependente[$index] = false\" ng-if=\"!localLoadingDependente[$index]\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.showConfirmDependente($event, dependente, $index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon>\n<md-icon md-font-icon=\"icon-tooltip-edit\" ng-init=\"localLoadingDependente[$index] = false\" \nng-if=\"!localLoadingDependente[$index]\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \nng-click=\"vm.preencherDependenteEdicao(dependente, $index)\" style=\"cursor:pointer\" aria-hidden=\"true\"></md-icon></td>\n</tr></tbody></table></div></div><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\"></md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.sairSemSalvar()\">Sair</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.salvarAssociadoExterno();\" ng-disabled=\"msWizard.currentStepInvalid()\">Salvar\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\"></md-button></div></form></md-tab-body></md-tab></md-tabs></ms-form-wizard>\n</div></div></div></div>");
$templateCache.put("app/main/boletim/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.init();\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\n{{ vm.titulo }}</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" \nng-init=\"vm.obterDados()\"><div class=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\">\n<md-progress-circular id=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\">\n<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Dados do Boletim</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" \nname=\"dsTituloBoletimInformativo\" ng-model=\"vm.boletim.dsTituloBoletimInformativo\" placeholder=\"Título\" required><div \nng-messages=\"wizardStep1.dsTituloBoletimInformativo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o Título.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><fieldset \nflex=\"100\"><legend><h2>Boletim</h2></legend><div layout=\"column\" layout-gt-xs=\"row\" flex></div><div flex=\"100\">\n<trix-editor angular-trix trix-file-accept ng-model=\"vm.boletim.dsBoletimInformativo\" class=\"trix-content\">\n</trix-editor></div></fieldset></div></form></md-tab-body></md-tab></md-tabs></ms-form-wizard></div></div><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.cadastrar(0);\" ng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">Salvar</md-button><md-button\n class=\"md-raised md-warn\" ng-click=\"vm.cadastrar(1);\" ng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">\nSalvar e Enviar</md-button><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/boletim/views/listar.html","<div id=\"conteudo\" ng-init=\"vm.initListar()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\nBoletim Informativo</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Lista Boletins Informativos</div>\n<div class=\"content page-layout simple fullwidth doc-page element-doc-page\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\" novalidate flex-offset=\"3\"><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"5\"></div>\n<md-input-container flex=\"30\"><input type=\"text\" name=\"tituloBoletim\" \nng-model=\"vm.pesquisa.dsTituloBoletimInformativo\" placeholder=\"Título do boletim\"></md-input-container><div flex=\"5\">\n</div><md-input-container flex=\"30\"><input type=\"text\" name=\"tituloBoletim\" ng-model=\"vm.pesquisa.dtInicio\" \nmask=\"99/99/9999\" placeholder=\"Data De:\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"30\"><input \ntype=\"text\" name=\"tituloBoletim\" ng-model=\"vm.pesquisa.dtFim\" mask=\"99/99/9999\" placeholder=\"Data Até:\">\n</md-input-container><md-button class=\"md-fab\" aria-label=\"Listar Boletim\" style=\"\" ng-click=\"vm.pesquisar()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"bottom\">Pesquisar Associado</md-tooltip></md-button></div>\n</form></div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><md-button \nclass=\"md-fab\" aria-label=\"Cadastar Novo Boletim\" ui-sref=\"app.boletim.add\" \nstyle=\"position: absolute; right: 0; margin-right: 16px\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nclass=\"icon s24 ng-scope md-font icon-plus-circle-outline material-icons md-default-theme right\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"left\">Adicionar Boletim</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table datatable class=\"dataTable row-border hover hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" ng-if=\"!localLoading\" dt-columns=\"showCase.dtColumns\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Data de envio</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Título</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr \nng-repeat=\"boletim in vm.resultadoBoletim\"><td>{{ boletim.dtEnvioFormatado }}</td><td>\n{{boletim.dsTituloBoletimInformativo;}}</td><td ng-if=\"boletim.inEnviado\">Enviado</td><td ng-if=\"!boletim.inEnviado\">\nRascunho</td><td><a ui-sref=\"app.boletim.edit({idBoletim:boletim.idBoletim})\" ng-if=\"!boletim.inEnviado\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" title=\"Editar\" aria-label=\"Editar\" \nclass=\"icon s24 ng-scope md-font icon-tooltip-edit material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a>\n</td></tr></tbody></table><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/comunicacao/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.init();\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\n{{ vm.titulo }}</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" \nng-init=\"vm.obterDados()\"><div class=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\">\n<md-progress-circular id=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\">\n<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Dados do comunicado</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" \nname=\"dsTituloComunicadoInformativo\" ng-model=\"vm.comunicacao.dsTituloComunicadoInformativo\" placeholder=\"Título\" \nrequired><div ng-messages=\"wizardStep1.dsTituloComunicacaoInformativo.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Preencha o Título.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<fieldset flex=\"100\"><legend><h2>Comunicado</h2></legend><div layout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"100\">\n<text-angular ng-model=\"vm.comunicacao.dsComunicadoInformativo\"></text-angular></div></div></fieldset></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex ng-if=\"vm.anexosComunicado\"><md-input-container flex=\"100\"><table \nclass=\"dataTable row-border hover hover white-bg md-whiteframe-4dp\"><tr><td colspan=\"2\">Anexos já vinculados</td></tr>\n<tr ng-repeat=\"anexo in vm.anexosComunicado\"><td><object ng-if=\"!vm.isImagem(anexo.arquivo.mimeType);\" \ndata=\"{{\'data:\'+anexo.arquivo.mimeType+\';base64,\' + anexo.arquivo.content}}\" type=\"{{anexo.arquivo.mimeType}}\" \ntitle=\"{{anexo.dsAnexoComunicado}}\" style=\"width: 20px; height: 50px\"></object><img \nng-if=\"vm.isImagem(anexo.arquivo.mimeType);\" style=\"width: 50px; height: 80px\" \nsrc=\"{{\'data:\'+anexo.arquivo.mimeType+\';base64,\' + anexo.arquivo.content}}\" alt=\"{{anexo.dsAnexoComunicado}}\"></td><td>\n{{anexo.dsAnexoComunicado}}</td><td><a ng-click=\"vm.showConfirm($event,anexo.idAnexoComunicado)\"><md-icon \nmd-font-icon=\"icon-trash\" title=\"Visualizar\" aria-label=\"Visualizar\" style=\"cursor: pointer\" \nclass=\"icon s24 ng-scope md-font icon-eye material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a></td></tr>\n</table></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\">\n<lf-ng-md-file-input lf-files=\"vm.anexo\" lf-placeholder=\"Anexos\" lf-browse-label=\"Selecione\" \nlf-drag-and-drop-label=\"Solte aqui os Anexos\" multiple=\"multiple\" accept=\"*/*\" preview progress drag>\n</lf-ng-md-file-input></md-input-container></div></form><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.cadastrar(false);\" \nng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">Salvar</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.cadastrar(true);\" ng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">Salvar e Enviar\n</md-button><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></md-tab-body></md-tab></md-tabs>\n</ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/comunicacao/views/listar.html","<div id=\"conteudo\" ng-init=\"vm.initListar()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\nComunicações</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Lista de Comunicados</div><div \nclass=\"content page-layout simple fullwidth doc-page element-doc-page\"><form name=\"wizardStep1\" class=\"md-inline-form\" \nnovalidate flex-offset=\"3\"><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"5\"></div><md-input-container flex=\"30\">\n<input type=\"text\" name=\"tituloComunicacao\" ng-model=\"vm.pesquisa.dsTituloBoletimInformativo\" \nplaceholder=\"Título da Comunicação\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"30\"><input \ntype=\"text\" name=\"dtComunicacaoInicio\" ng-model=\"vm.pesquisa.dtInicio\" mask=\"99/99/9999\" placeholder=\"Data De:\">\n</md-input-container><div flex=\"5\"></div><md-input-container flex=\"30\"><input type=\"text\" name=\"dtComunicacaoFim\" \nng-model=\"vm.pesquisa.dtFim\" mask=\"99/99/9999\" placeholder=\"Data Até:\"></md-input-container><md-button class=\"md-fab\" \naria-label=\"Pesquisar Comunicados\" style=\"\" ng-click=\"vm.pesquisar()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Pesquisar Comunicados</md-tooltip></md-button></div></form></div><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><md-button class=\"md-fab\" \naria-label=\"Cadastar Novo Comunicado\" ui-sref=\"app.comunicacao.add\" \nstyle=\"position: absolute; right: 0; margin-right: 16px\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nclass=\"icon s24 ng-scope md-font icon-plus-circle-outline material-icons md-default-theme right\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"left\">Adicionar Comunicado</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table datatable class=\"dataTable row-border hover hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" ng-if=\"true\" dt-columns=\"showCase.dtColumns\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data de envio</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Título</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr \nng-repeat=\"comunicacao in vm.resultadoComunicacao\"><td>{{ comunicacao.dtEnvioFormatado }}</td><td>\n{{comunicacao.dsTituloComunicadoInformativo;}}</td><td ng-if=\"comunicacao.inEnviado\">Enviado</td><td \nng-if=\"!comunicacao.inEnviado\">Rascunho</td><td><a \nui-sref=\"app.comunicacao.edit({idComunicacao:comunicacao.idComunicado})\" ng-if=\"!comunicacao.inEnviado\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" title=\"Editar\" aria-label=\"Editar\" \nclass=\"icon s24 ng-scope md-font icon-tooltip-edit material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a>\n</td></tr></tbody></table><div layout=\"row\" layout-align=\"start center\" ng-if=\"false\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/contra_cheque/views/contra_cheque.html","<div id=\"conteudo\" ng-init=\"vm.init();\" style=\"height: 100%\"><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" style=\"height: 100%\"><div class=\"content\" \nstyle=\"padding:5px\"><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\" style=\"height: 100%\"><div \nclass=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\" style=\"height: 100%\"><div layout=\"column\" \nstyle=\"height: 100%\"><div flex><image src=\"/assets/images/logos/logo.png\" class=\"logo\"><span \nclass=\"titulo_contra_cheque\">{{ vm.titulo }}</span></div><md-divider class=\"color_divider\"></md-divider><div flex><div \nlayout=\"row\" layout-xs=\"column\"><div id=\"coluna1\" class=\"form_contra_cheque\" flex><form name=\"contraChequeForm\" \nclass=\"md-inline-form\" autocomplete=\"off\"><div layout=\"column\"><md-input-container flex><input type=\"text\" \nname=\"dsVencimento\" ui-number-mask ui-hide-group-sep ng-model=\"vm.pagamento.dsVencimento\" placeholder=\"Vencimento\" \nrequired><div ng-messages=\"contraChequeForm.dsVencimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha o campo.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"adicional\" \nui-number-mask ui-hide-group-sep ng-model=\"vm.pagamento.adicional\" placeholder=\"Adicional de qualificação\" required>\n<div ng-messages=\"contraChequeForm.adicional.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o campo.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"alimentacao\" ui-number-mask \nui-hide-group-sep ng-model=\"vm.pagamento.alimentacao\" placeholder=\"Alimentação\" required><div \nng-messages=\"contraChequeForm.alimentacao.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o campo.\n</span></div></div></md-input-container></div></form></div><div id=\"coluna2\" class=\"form_contra_cheque\" flex><form \nname=\"contraChequeForm\" class=\"md-inline-form\" autocomplete=\"off\"><div layout=\"column\"><md-input-container flex><label>\nTitulação</label><md-select name=\"type\" ng-model=\"vm.pagamento.ghap\" required><md-option value=\"13\">Graduação\n</md-option><md-option value=\"20\">Especialização</md-option><md-option value=\"30\">Mestrado</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"plantao\" ng-model=\"vm.pagamento.plantao\" \nmin=\"0\" max=\"31\" placeholder=\"Plantões\"></md-input-container><div flex><md-checkbox ng-model=\"vm.pagamento.tempo\" \naria-label=\"Possui adicional de tempo de serviço?\">Possui adicional de tempo de serviço?</md-checkbox></div></div>\n</form></div></div></div></div><md-divider class=\"color_divider\"></md-divider><div flex \nstyle=\"padding-top: 20px;padding-bottom:20px\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.calcularContraCheque()\">Calcular</md-button><span></span><md-button class=\"md-raised\">Limpar</md-button>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/contra_cheque/views/contra_resultado.html","<div id=\"conteudo\" ng-init=\"vm.init();\" style=\"height: {{vm.heigthPage}}\"><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" style=\"height: 100%\"><div class=\"content\" \nstyle=\"padding:5px;height: 100%\"><div class=\"white-bg\" id=\"card_branco\" style=\"height: 100%\"><div class=\"white-bg\" \nng-if=\"vm.mostrarFormulario\"><div layout=\"column\" style=\"height: 100%\"><div flex><image \nsrc=\"/assets/images/logos/logo.png\" class=\"logo\"><span class=\"titulo_contra_cheque\">{{ vm.titulo }}</span></div>\n<md-divider class=\"color_divider\"></md-divider><div flex><div layout=\"row\" layout-xs=\"column\"><div id=\"coluna1\" \nclass=\"form_contra_cheque\" flex><form name=\"contraChequeForm\" class=\"md-inline-form\" autocomplete=\"off\"><div \nlayout=\"column\"><md-input-container flex><input type=\"text\" name=\"dsVencimento\" ui-number-mask ui-hide-group-sep \nng-model=\"vm.pagamento.dsVencimento\" placeholder=\"Vencimento*\" required><div \nng-messages=\"contraChequeForm.dsVencimento.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o campo.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"adicional\" ui-number-mask \nui-hide-group-sep ng-model=\"vm.pagamento.adicional\" placeholder=\"Adicional de qualificação\"><div \nng-messages=\"contraChequeForm.adicional.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o campo.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"alimentacao\" ui-number-mask \nui-hide-group-sep ng-model=\"vm.pagamento.alimentacao\" placeholder=\"Alimentação*\" required><div \nng-messages=\"contraChequeForm.alimentacao.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o campo.\n</span></div></div></md-input-container></div></form></div><div id=\"coluna2\" class=\"form_contra_cheque\" flex><form \nname=\"contraChequeForm\" class=\"md-inline-form\"><div layout=\"column\"><md-input-container flex><label>Titulação*</label>\n<md-select name=\"type\" ng-model=\"vm.pagamento.ghap\" required><md-option value=\"13\">Graduação</md-option><md-option \nvalue=\"20\">Especialização</md-option><md-option value=\"30\">Mestrado</md-option></md-select></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"plantao\" ng-model=\"vm.pagamento.plantao\" min=\"0\" max=\"31\" \nplaceholder=\"Plantões\"></md-input-container><div flex><md-checkbox ng-model=\"vm.pagamento.tempo\" \naria-label=\"Possui adicional de tempo de serviço?\">Possui adicional de tempo de serviço?</md-checkbox></div></div>\n</form></div></div></div></div><md-divider class=\"color_divider\"></md-divider><div flex \nstyle=\"padding-top: 20px;padding-bottom:20px\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.calcularContraCheque()\">Calcular</md-button><span></span><md-button class=\"md-raised\">Limpar</md-button>\n</div></div></div><div class=\"white-bg\" style=\"height: 100%\"><div layout=\"column\" ng-if=\"!vm.mostrarFormulario\"><div \nflex><span class=\"titulo_contra_cheque\">Resultado</span></div><md-divider class=\"color_divider\"></md-divider><div flex>\n<div layout=\"row\" layout-xs=\"column\"><div flex=\"50\" flex-xs=\"100\"><div layout=\"column\" layout-xs=\"column\"><div \nid=\"coluna1\" class=\"form_contra_cheque\" flex><h3>Vencimentos</h3><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Vencimento:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.pagamento.dsVencimento | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Ad. de Qualificação:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.pagamento.adicional | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">GHAP:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.ghapResultado | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Tempo de Serviço:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.tempoServicoResultado | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Ad. Noturno:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.adicionalNoturnoResultado | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Alimentação:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.pagamento.alimentacao | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Insalubridade:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.insalubridadeResultado | currency:\"R$ \":2 }}</label></div></div></div><div id=\"coluna2\" \nclass=\"form_contra_cheque\" flex><h3>Descontos</h3><div layout=\"row\"><div flex=\"60\"><label class=\"label-result\">RPPS:\n</label></div><div flex=\"40\"><label class=\"label-result\">{{vm.rppsResultado | currency:\"R$ \":2 }}</label></div></div>\n<div layout=\"row\"><div flex=\"60\"><label class=\"label-result\">IR:</label></div><div flex=\"40\"><label \nclass=\"label-result\">{{vm.irResultado | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">ASSPEN:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.deducaoAsspen | currency:\"R$ \":2 }}</label></div></div><md-divider class=\"divider_result\"></md-divider><div \nlayout=\"row\"><div flex=\"60\"><label class=\"label-result\">Total bruto:</label></div><div flex=\"40\"><label \nclass=\"label-result\">{{vm.totalBrutoResultado | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div \nflex=\"60\"><label class=\"label-result\">Total líquido:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.totalLiquidoResultado | currency:\"R$ \":2 }}</label></div></div></div></div><div layout=\"row\"><div flex=\"50\">&nbsp\n</div></div><md-divider class=\"color_divider\"></md-divider></div><div flex=\"50\" flex-xs=\"100\"><div layout=\"column\" \nlayout-xs=\"column\"><div id=\"coluna1\" class=\"form_contra_cheque\" flex><h3>Gratificação Natalina</h3><div layout=\"row\">\n<div flex=\"60\"><label class=\"label-result\">Total bruto:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.totalGratNatResult | currency:\"R$ \":2 }}</label></div></div></div><div id=\"coluna2\" class=\"form_contra_cheque\" \nflex><h3>Descontos</h3><div layout=\"row\"><div flex=\"60\"><label class=\"label-result\">RPPS:</label></div><div flex=\"40\">\n<label class=\"label-result\">{{vm.rppsGratNatResult | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div \nflex=\"60\"><label class=\"label-result\">IR:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.irGratNatResult | currency:\"R$ \":2 }}</label></div></div><md-divider class=\"divider_result\"></md-divider><div \nlayout=\"row\"><div flex=\"60\"><label class=\"label-result\">Total líquido:</label></div><div flex=\"40\"><label \nclass=\"label-result\">{{vm.totalLiquidoGratNatResult | currency:\"R$ \":2 }}</label></div></div></div><md-divider \nclass=\"color_divider\"></md-divider><div id=\"coluna2\" class=\"form_contra_cheque\" flex><h4>Férias<div layout=\"row\"><div \nflex=\"60\"><label class=\"label-result\">Total bruto:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.feriasBrutoResult | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">IR Férias:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.irFeriasResult | currency:\"R$ \":2 }}</label></div></div><div layout=\"row\"><div flex=\"60\"><label \nclass=\"label-result\">Total líquido:</label></div><div flex=\"40\"><label class=\"label-result\">\n{{vm.feriasLiquidoResult | currency:\"R$ \":2 }}</label></div></div></h4></div></div><div layout=\"row\"><div flex=\"50\">\n&nbsp</div></div></div></div></div><md-divider class=\"color_divider\"></md-divider><div flex \nstyle=\"padding-top: 10px;padding-bottom:10px\"><md-button class=\"md-raised\" ng-click=\"vm.voltarFormulario()\">Refazer\n</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/convenio/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.init();\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\n{{ vm.titulo }}</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" \nng-init=\"vm.obterDados()\"><div class=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\">\n<md-progress-circular id=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\">\n<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Dados do Boletim</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" name=\"dsProduto\" \nng-model=\"vm.convenio.dsProduto\" placeholder=\"Descrição do Convênio\" required><div \nng-messages=\"wizardStep1.dsTituloBoletimInformativo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPreencha a descrição do produto.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex><md-input-container flex=\"100\"><input type=\"text\" name=\"vlProduto\" ng-model=\"vm.convenio.vlProduto\" \nui-number-mask ui-hide-group-sep ng-init=\"vm.convenio.vlProduto = 0.00\" placeholder=\"Valor do Convênio\" required><div \nng-messages=\"wizardStep1.vlProduto.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha o Título.</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nng-model=\"vm.convenio.inProdutoCobrado\" ng-init=\"vm.convenio.inProdutoCobrado = true\">Convênio com desconto em folha?\n</md-checkbox></div></div><div layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nng-model=\"vm.convenio.inProdutoPorQuantidadeDependentes\" \nng-init=\"vm.convenio.inProdutoPorQuantidadeDependentes = false\">\nDesconto varia de acordo com a quantidade de dependentes?</md-checkbox></div></div></form><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.cadastrar();\" \nng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">Salvar</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.voltar();\" ng-if=\"!localLoading\">Voltar</md-button><div layout=\"row\" layout-align=\"start center\" \nng-if=\"localLoading\"><md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" \nid=\"toolbar-progress-login\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n</div></md-tab-body></md-tab></md-tabs></ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/convenio/views/listar.html","<div id=\"conteudo\" ng-init=\"vm.initListar()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Convênio\n</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Lista de Convênios</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><md-button class=\"md-fab\" \naria-label=\"Cadastar Novo Convênio\" ui-sref=\"app.convenio.add\" \nstyle=\"position: absolute; right: 0; margin-right: 16px\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nclass=\"icon s24 ng-scope md-font icon-plus-circle-outline material-icons md-default-theme right\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"left\">Adicionar Convênio</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table datatable class=\"dataTable row-border hover hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" ng-if=\"!localLoading\" dt-columns=\"showCase.dtColumns\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Nome do Convênio</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Valor Produto</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ações</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" style=\"width: 20px\"><span class=\"column-title\">Ativo</span></div></th></tr></thead><tbody><tr \nng-repeat=\"convenio in vm.resultadoConvenio\" ng-init=\"vm.inAtivo[convenio.idProduto] = convenio.inProduto;\"><td>\n{{convenio.dsProduto| uppercase }}</td><td>{{convenio.vlProduto| currency:\"R$ \":2}}</td><td><a \nui-sref=\"app.convenio.edit({idProduto:convenio.idProduto})\"><md-icon md-font-icon=\"icon-tooltip-edit\" title=\"Editar\" \naria-label=\"Editar\" class=\"icon s24 ng-scope md-font icon-tooltip-edit material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></a></td><td><a href=\"javascript:void(0)\"><md-switch \nng-change=\"vm.desativarOuAtivar(convenio)\" style=\"padding-top: 0px;padding-bottom: 0px;margin: 0px\" \nng-model=\"vm.inAtivo[convenio.idProduto]\" aria-label=\" \"></md-switch></a></td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/default/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://l-lin.github.io/angular-datatables\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title mb-32\">Zero Configuration</div><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Office</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Age</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Salary</span></div></th></tr></thead><tbody><tr \nng-repeat=\"employee in ::vm.employees\"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>\n{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/default/stepper-steps/step-1.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.stepper.step1.firstname\" placeholder=\"Firstname\" \nrequired><div ng-messages=\"step1.firstname.$error\" ng-show=\"step1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.stepper.step1.lastname\" \nplaceholder=\"Lastname\" required><div ng-messages=\"step1.lastname.$error\" ng-show=\"step1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/default/stepper-steps/step-2.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.stepper.step2.address\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea><div \nng-messages=\"step2.address.$error\" ng-show=\"step2.address.$touched\" role=\"alert\"></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/default/stepper-steps/step-3.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.stepper.step3.cardholder\" placeholder=\"Card Holder\" required><div ng-messages=\"step3.cardholder.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.</span></div></div></md-input-container>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"cardnumber\" ng-model=\"vm.stepper.step3.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"step3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card number field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" \nng-model=\"vm.stepper.step3.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div ng-messages=\"step3.cc2.$error\" \nrole=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.</span></div><div \nng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.stepper.step3.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"step3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/juridico/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.listarProcessos()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\n{{ vm.titulo }}</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\"><md-progress-circular \nid=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" md-diameter=\"40\">\n</md-progress-circular></div><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\"><ms-form-wizard flex>\n<md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Dados do processo</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height: 84px;vertical-align: bottom\"><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"numProcesso\" ng-model=\"vm.juridico.numProcesso\" placeholder=\"Número do processo\" required><div \nng-messages=\"wizardStep1.numProcesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO número do processo é obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container \nflex=\"50\" flex-gt-xs=\"50\"><input type=\"text\" name=\"dataProcesso\" ng-model=\"vm.juridico.dtProcesso\" \nplaceholder=\"Data do processo\" required mask=\"99/99/9999\"><div ng-messages=\"wizardStep1.dataProcesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>A data do processo é obrigatório.</span></div><div ng-message=\"mask\">\n<span>O valor informado não corresponde a uma Data.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"100\"><input type=\"text\" name=\"dsMatricula\" \nstyle=\"text-transform: lowercase\" ng-model=\"vm.juridico.dsLink\" placeholder=\"Link do processo\"><div \nng-messages=\"wizardStep1.dsMatricula.$error\" role=\"alert\"><div ng-message=\"required\"><span>Informe o link do processo.\n</span></div></div></md-input-container><div flex=\"5\"></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-select ng-model=\"vm.juridico.tpAcaoProcesso\" name=\"tpAcaoProcesso\" \nplaceholder=\"Tipo da ação\" required><md-option value=\"3\">Cível</md-option><md-option value=\"1\">Criminal</md-option>\n<md-option value=\"2\">Trabalhista</md-option></md-select><div ng-messages=\"wizardStep1.tpAcaoProcesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tipo da ação é obrigatório.</span></div></div></md-input-container><div \nflex=\"5\"></div><md-input-container flex=\"50\" flex-gt-xs=\"50\" ng-init=\"vm.listarTribunais()\"><md-select \nng-model=\"vm.juridico.tribunal\" name=\"tribunal\" placeholder=\"Tribunal\" required><md-option \nng-repeat=\"tribunal in vm.tribunais\" value=\"{{tribunal.idTribunal}}\">{{tribunal.noTribunal}}</md-option></md-select>\n<div ng-messages=\"wizardStep1.tribunal.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Tribunal é Obrigatório.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"50\" flex-gt-xs=\"50\" ng-init=\"vm.listarAdvogados()\"><md-select ng-model=\"vm.juridico.advogado\" \nname=\"tpEstadoCivil\" placeholder=\"Advogado\" required><md-option ng-repeat=\"advogado in vm.advogados\" \nvalue=\"{{advogado.idAdvogado}}\">{{advogado.noAdvogado}}</md-option></md-select><div \nng-messages=\"wizardStep1.tpEstadoCivil.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Advogado é Obrigatório.\n</span></div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-select \nng-model=\"vm.juridico.tpProcesso\" name=\"tpProcesso\" placeholder=\"Tipo do Processo\" required><md-option value=\"1\">\nIndividual</md-option><md-option value=\"2\">Coletiva</md-option></md-select><div \nng-messages=\"wizardStep1.tpProcesso.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO tipo do processo é obrigatório.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-select ng-model=\"vm.juridico.inProcessoRecebido\" \nname=\"inProcessoRecebido\" placeholder=\"Documentação recebida?\" required><md-option value=\"1\">Documentação recebida\n</md-option><md-option value=\"0\">Não recebemos</md-option></md-select><div ng-messages=\"wizardStep1.tpProcesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Informe se a documentaçao foi recebida.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex ng-init=\"vm.listarAssociados()\" \nng-show=\"vm.juridico.tpProcesso == 1\"><md-autocomplete md-selected-item=\"vm.associado\" md-search-text=\"vm.searchText\" \nmd-clear-button=\"false\" md-no-asterisk=\"false\" md-floating-label=\"Informe o associado vinculado ao processo*\" \nmd-match-case-insensitive=\"true\" md-items=\"item in vm.associados | filter:vm.searchText\" \nmd-item-text=\"item._embedded.pessoaFisica.noPessoa\" md-input-name=\"autocompleteAssociado\" \nmd-input-id=\"autocompleteAssociado\" flex=\"100\" ng-required=\"vm.juridico.tpProcesso == 1\" flex-gt-xs=\"100\">\n<md-item-template><span md-highlight-text=\"searchText\">{{item._embedded.pessoaFisica.noPessoa}}</span>\n</md-item-template><md-not-found>Não encontramos \"{{searchText}}\"</md-not-found><div \nng-messages=\"wizardStep2.autocompleteResponsavel.$error\"><div ng-message=\"required\">\nInforme o associado vinculado ao processo</div></div></md-autocomplete></div></form><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-rised md-accent-bg\" ng-click=\"vm.cadastrarProcesso();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Salvar</md-button></div></md-tab-body></md-tab></md-tabs></ms-form-wizard>\n</div></div></div></div>");
$templateCache.put("app/main/juridico/views/listar.html","<div id=\"conteudo\" ng-init=\"vm.init()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Processos\n</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Lista de Processos</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\"><md-button class=\"md-fab\" \naria-label=\"Adicionar Processo\" ui-sref=\"app.juridico.add\" style=\"position: absolute; right: 0; margin-right: 16px\">\n<md-icon md-font-icon=\"icon-library-plus\" \nclass=\"icon s24 ng-scope md-font icon-library-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Processo</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table datatable class=\"dataTable row-border hover hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" ng-if=\"!localLoading\" dt-columns=\"showCase.dtColumns\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Número</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Associado</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tribunal</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr \nng-repeat=\"processo in vm.processos\"><td><a href=\"{{processo.dsLink}}\" target=\"_blank\">{{processo.numProcesso}}</a>\n</td><td ng-show=\"processo.tpProcesso == 2\">--COLETIVA--</td><td ng-show=\"processo.tpProcesso == 1\">\n{{processo._embedded.associado._embedded.pessoaFisica.noPessoa}}</td><td ng-show=\"processo.tpAcaoProcesso == 3\">Cível\n</td><td ng-show=\"processo.tpAcaoProcesso == 1\">Criminal</td><td ng-show=\"processo.tpAcaoProcesso == 2\">Trabalhista\n</td><td>{{processo._embedded.tribunal.noTribunal}}</td><td><a \nui-sref=\"app.juridico.edit({idProcesso:processo.idProcesso})\"><md-icon md-font-icon=\"icon-tooltip-edit\" title=\"Editar\" \naria-label=\"Editar\" class=\"icon s24 ng-scope md-font icon-tooltip-edit material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></a><a ui-sref=\"app.juridico.visualizar({idProcesso:processo.idProcesso})\"><md-icon \nmd-font-icon=\"icon-eye\" title=\"Visualizar\" aria-label=\"Visualizar\" \nclass=\"icon s24 ng-scope md-font icon-eye material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a></td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/juridico/views/visualizar.html","<div id=\"conteudo\" ng-init=\"vm.obterVisualizar()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\nJurídico</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Visualizar processo</div><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div class=\"row\">\n<div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Dados do Processo</div><table \nclass=\"dataTable row-border hover hover\" ng-if=\"!localLoading\" dt-columns=\"showCase.dtColumns\"><tbody><tr><td><b>Número\n</b></td><td>{{vm.processoVisualizar.numProcesso}}</td></tr><tr><td><b>Tribunal</b></td><td>\n{{vm.processoVisualizar._embedded.tribunal.noTribunal}}</td></tr><tr><td><b>Advogado</b></td><td>\n{{vm.processoVisualizar._embedded.advogado.noAdvogado}}</td></tr></tbody></table></div></div></div><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div class=\"row\">\n<div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Andamento do Processo</div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><md-select ng-model=\"vm.statusProcessoCadastro\" \nname=\"statusProcesso\" placeholder=\"Alterar Andamento do Processo*\" required><md-option ng-repeat=\"status in vm.status\" \nvalue=\"{{status.idStatus}}\">{{status.noStatus}}</md-option></md-select><div ng-messages=\"statusProcesso.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o Andamento.</span></div></div></md-input-container><div \nflex=\"5\"><md-button class=\"md-fab\" aria-label=\"Listar Telefone\" style=\"\" ng-click=\"vm.salvarStatus()\"><md-icon \nmd-font-icon=\"icon-library-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Adicionar Novo Status</md-tooltip></md-button></div><div flex=\"45\"></div></div><table\n class=\"dataTable row-border hover hover\" ng-if=\"!localLoading\" dt-columns=\"showCase.dtColumns\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Andamento</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"status in vm.statusProcesso\"><td>{{vm.formatarData(status.dtStatus.date )}}</td><td>\n{{status._embedded.status.noStatus}}</td></tr></tbody></table></div></div></div><div id=\"simple-table-andamento\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content-andamento\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"row\"></div></div></div></div></div>");
$templateCache.put("app/main/pagamento/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.init();vm.obterDados();\"><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px\">{{ vm.titulo }}</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\"><div class=\"content\"><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\"><md-progress-circular id=\"default-progress\" \nclass=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div\n class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\"><lf-ng-md-file-input lf-files=\"vm.pagamento.noArquivo\" lf-placeholder=\"processamento.txt\" \nlf-browse-label=\"Selecione\" lf-required lf-drag-and-drop-label=\"Arraste aqui o aquivo a ser processado ou selecione\" \naccept=\"text/*\" preview progress drag></lf-ng-md-file-input><div ng-messages=\"wizardStep1.noArquivo.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Selecione um Arquivo para o Pagamento</span></div></div>\n</md-input-container></div></form><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.cadastrar();\" ng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">\nProcessar</md-button><md-button class=\"md-raised\" ng-click=\"vm.voltarLista();\" ng-if=\"!localLoading\">Cancelar\n</md-button><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></md-tab-body></md-tab></md-tabs>\n</ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/pagamento/views/listar.html","<div id=\"conteudo\"><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Pagamentos</div><div class=\"pb-16 subtituloGrid\" \nstyle=\"padding-left: 10px\">Lista de processamentos de pagamentos</div><div \nclass=\"content page-layout simple fullwidth doc-page element-doc-page flex-30\" flex=\"30\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\" novalidate flex-offset=\"2\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"5\">\n<input type=\"text\" name=\"tituloBoletim\" ng-model=\"vm.pesquisa.dtInicio\" mask=\"99/9999\" placeholder=\"De:\">\n</md-input-container><md-input-container flex=\"5\"><input type=\"text\" name=\"tituloBoletim\" ng-model=\"vm.pesquisa.dtFim\" \nmask=\"99/9999\" placeholder=\"Até:\"></md-input-container><md-button class=\"md-fab\" aria-label=\"Listar Boletim\" style=\"\" \nng-click=\"vm.pesquisar()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Pesquisar Associado</md-tooltip></md-button></div></form></div></div><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.pesquisar()\"><md-button \nclass=\"md-fab\" aria-label=\"Cadastar Novo Pagamento\" ui-sref=\"app.pagamento.add\" \nstyle=\"position: absolute; right: 0; margin-right: 16px\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nclass=\"icon s24 ng-scope md-font icon-plus-circle-outline material-icons md-default-theme right\" aria-hidden=\"true\">\n</md-icon><md-tooltip md-direction=\"left\">Adicionar Novo Pagamento</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table datatable class=\"dataTable row-border hover hover\" \nng-init=\"vm.initListar();\" datatable=\"ng\" dt-options=\"vm.dtOptions\" ng-if=\"!localLoading\" \ndt-columns=\"showCase.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Data de envio</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Arquivo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mês</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ações</span></div></th></tr></thead><tbody><tr ng-repeat=\"pagamento in vm.resultadoArquivos\"><td>\n{{vm.formatarData(pagamento.dtEnvio.date)}}</td><td>{{pagamento.noArquivo}}</td><td>{{vm.tratarMes(pagamento.nuMes)}}\n</td><td><md-icon md-font-icon=\"icon-check\" title=\"Processado com sucesso\" aria-label=\"Processado com sucesso\" \nclass=\"icon s24 ng-scope md-accent icon-check material-icons\" ng-if=\"pagamento.inProcessado\"></md-icon><md-icon \nmd-font-icon=\"icon-alert-circle\" title=\"Falha no rocessamento\" aria-label=\"Falha no rocessamento\" \nclass=\"icon s24 ng-scope md-warn icon-alert-circle material-icons md-default-theme\" ng-if=\"!pagamento.inProcessado\">\n</md-icon></td><td><a ng-if=\"pagamento.inProcessado\" \nui-sref=\"app.pagamento.view({idPagamento: pagamento.idArquivoPagamento})\"><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.visualizar(pagamento)\" title=\"Visualizar\" aria-label=\"Visualizar\" \nclass=\"icon s24 ng-scope md-font icon-eye material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a><a \nng-if=\"pagamento.inProcessado\" ui-sref=\"app.pagamento.relatorio({idPagamento: pagamento.idArquivoPagamento})\"><md-icon \nmd-font-icon=\"icon-book-variant\" title=\"Relatório De Pagamentos\" aria-label=\"Relatório De Pagamentos\" \nclass=\"icon s24 ng-scope md-font icon-book-variant material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a>\n</td></tr></tbody></table><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/pagamento/views/modal.html","<!DOCTYPE html><html><head><title>TODO supply a title</title><meta charset=\"UTF-8\"><meta name=\"viewport\" \ncontent=\"width=device-width,initial-scale=1\"></head><body><div>TODO write content</div></body></html>");
$templateCache.put("app/main/pagamento/views/relatorio-pagamentos.html","<div ng-init=\"vm.getRelatorioPagamento()\" style=\"width: 100%; height: 100%\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"left\" \nstyle=\"position: relative;  left: 0px;z-index: 999\"><md-button class=\"md-fab\" aria-label=\"Ficha associado\" \nui-sref=\"app.pagamento\" style=\"position: absolute; left: 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Voltar para lista de pagamentos</md-tooltip></md-button></div><object \nng-show=\"dataPdf\" data=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/pagamento/views/visualizar.html","<div id=\"conteudo\"><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Pagamentos</div><div class=\"pb-16 subtituloGrid\" \nstyle=\"padding-left: 10px\">Visualização do processamento</div></div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\"></span> <span \nclass=\"ms-form-wizard-step-text\">Pagamentos Efetuados</span></span></md-tab-label><md-tab-body><table \nclass=\"dataTable row-border hover\" ng-init=\"vm.pesquisarDetalhesSucesso()\"><thead><tr><th class=\"secondary-text\" \nstyle=\"width: 15px\"><div class=\"table-header\"><span class=\"column-title\">Matrícula Asspen<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.dsMatricula-ASC\'}\" \nng-click=\"vm.ordermar(\'pessoaFisica.dsMatricula-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.dsMatricula-DESC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.dsMatricula-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome Associado<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.noPessoa-ASC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.noPessoa-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.noPessoa-DESC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.noPessoa-DESC\')\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Produto<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'produto.dsProduto-ASC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'produto.dsProduto-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'produto.dsProduto-DESC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'produto.dsProduto-DESC\')\" style=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \naria-hidden=\"true\"></md-icon></span></div></th></tr></thead><tbody><tr ng-if=\"localLoading\"><td colspan=\"4\"><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></td></tr><tr \nng-repeat=\"detalhe in vm.resultadoDetalhesSucesso._embedded.detalhe_arquivo_pagamento\" \nng-init=\"vm.inAtivo[\'pendencia\'][$index] = false\" ng-if=\"!localLoading\"><td style=\"padding: 7px 7px 7px 24px\">\n{{detalhe.dsMatricula}}</td><td style=\"padding: 7px\">{{detalhe.noPessoa| uppercase}}</td><td style=\"padding: 7px\">\n{{detalhe.dsProduto | uppercase}} - {{detalhe.nuDependentes == null ? detalhe.vlProduto : detalhe.vlProduto * (detalhe.nuDependentes +1) | currency:\"R$ \":2}}\n</td></tr><tr><td colspan=\"5\"><div class=\"layout-row layout-align-space-between-center\"><div \nclass=\"layout-row layout-align-start-center\"><span style=\"padding-right: 8px\">Mostrar</span><md-select \nstyle=\"margin: 0px\" ng-model=\"vm.itensPorPaginaBoletoPago\" ng-change=\"vm.mudarPageSizeBoleto()\" \nplaceholder=\"Itens Por Pagina\" class=\"md-no-underline\"><md-option value=\"10\">10</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"30\">30</md-option><md-option value=\"40\">40</md-option><md-option value=\"50\">50\n</md-option><md-option value=\"100\">100</md-option></md-select><span style=\"padding-left: 8px\">registros</span></div>\n<div><md-button ng-disabled=\"vm.paginaBoletoPago <= 1\" ng-click=\"vm.adicionaPaginaBoletoPago(-1)\">Anterior</md-button>\n<b>{{vm.paginaBoletoPago}} de {{vm.resultadoDetalhesSucesso.page_count}}</b><md-button \nng-disabled=\"vm.paginaBoletoPago >=  vm.resultadoDetalhesBoletoPago.page_count\" style=\"text-align: right\" \nng-click=\"vm.adicionaPaginaBoletoPago(1)\">Próximo</md-button></div></div></td></tr></tbody></table></md-tab-body>\n</md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-warn-bg\"></span> <span class=\"ms-form-wizard-step-text\">Pagamentos Pendentes\n</span></span></md-tab-label><md-tab-body><table class=\"dataTable row-border hover\" \nng-init=\"vm.pesquisarDetalhesPendencias()\"><thead><tr><th class=\"secondary-text\" style=\"width: 15px\"><div \nclass=\"table-header\"><span class=\"column-title\">Matrícula Asspen<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.dsMatricula-ASC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.dsMatricula-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.dsMatricula-DESC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.dsMatricula-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome Associado<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.noPessoa-ASC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.noPessoa-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.noPessoa-DESC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.noPessoa-DESC\')\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Produto<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'produto.dsProduto-ASC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'produto.dsProduto-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'produto.dsProduto-DESC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'produto.dsProduto-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th></tr>\n</thead><tbody><tr ng-if=\"localLoading\"><td colspan=\"4\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></td></tr><tr \nng-repeat=\"(index, detalhe) in vm.resultadoDetalhesPendencias._embedded.detalhe_arquivo_pagamento\" \nstyle=\"height: 20px\" ng-init=\"vm.inAtivo[\'pendencia\'][index] = false\" ng-if=\"!localLoading\"><td \nstyle=\"padding: 7px 7px 7px 24px\">{{detalhe.dsMatricula}}</td><td style=\"padding: 7px\">{{detalhe.noPessoa| uppercase}}\n</td><td style=\"padding: 7px\">{{detalhe.dsProduto | uppercase}} -</td><td style=\"padding: 7px\">\n{{detalhe.dsProduto | uppercase}} - {{detalhe.nuDependentes == null ? detalhe.vlProduto : detalhe.vlProduto * (detalhe.nuDependentes + 1)| currency:\"R$\":2}}\n</td></tr><tr ng-if=\"vm.resultadoDetalhesPendencias._embedded.detalhe_arquivo_pagamento.length  <= 0 && !localLoading\">\n<td colspan=\"3\" style=\"text-align: center\">Não há pendências</td></tr><tr><td colspan=\"5\"><div \nclass=\"layout-row layout-align-space-between-center\"><div class=\"layout-row layout-align-start-center\"><span \nstyle=\"padding-right: 8px\">Mostrar</span><md-select style=\"margin: 0px\" ng-model=\"vm.itensPorPaginaBoleto\" \nng-change=\"vm.mudarPageSizePendencia()\" placeholder=\"Itens Por Pagina\" class=\"md-no-underline\"><md-option value=\"10\">10\n</md-option><md-option value=\"20\">20</md-option><md-option value=\"30\">30</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"50\">50</md-option><md-option value=\"100\">100</md-option></md-select><span \nstyle=\"padding-left: 8px\">registros</span></div><div><md-button ng-disabled=\"vm.paginaBoletoPendente <= 1\" \nng-click=\"vm.adicionaPaginaPrendenciaBoleto(-1)\">Anterior</md-button><b>\n{{vm.paginaBoletoPendente}} de {{vm.resultadoDetalhesPendencias.page_count}}</b><md-button \nng-disabled=\"vm.paginaBoletoPendente >=  vm.resultadoDetalhesPendenciasBoleto.page_count\" style=\"text-align: right\" \nng-click=\"vm.adicionaPaginaPrendenciaBoleto(1)\">Próximo</md-button></div></div></td></tr></tbody></table></md-tab-body>\n</md-tab></md-tabs></ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/pessoa/views/cadastrar.html","<div id=\"conteudo\" ng-init=\"vm.init();vm.obterDados();\"><div class=\"md-title mt-32 tituloGrid\" \nstyle=\"padding-left: 10px\">{{ vm.titulo }}</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\"><div class=\"content\"><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\"><md-progress-circular id=\"default-progress\" \nclass=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" md-diameter=\"40\"></md-progress-circular></div><div\n class=\"white-bg md-whiteframe-4dp\" ng-if=\"!loadingTable\"><div class=\"avatar-wrapper\" \nstyle=\"position: absolute; top: -1px; right: 0px\"><img style=\"height: 80px;width: 80px\" class=\"md-avatar avatar\" \nng-show=\"vm.fotoAvatar\" ng-src=\"{{vm.fotoAvatar}}\"></div><div class=\"avatar-wrapper right\" \nstyle=\"position: absolute; top: -1px; right: 0px\"><img style=\"height: 80px;width: 80px\" class=\"md-avatar avatar\" \nng-show=\"!vm.fotoAvatar\" src=\"assets/images/avatars/profile.jpg\"></div><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Dados Pessoais</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"cpf\" ng-model=\"vm.pessoa.nuCpf\" \nplaceholder=\"CPF\" mask=\"999.999.999-99\" ng-cpf required><div ng-messages=\"wizardStep1.cpf.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Preencha o Cpf.</span></div><div ng-message=\"cpf\">CPF inválido</div></div>\n</md-input-container><div flex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"nome\" \nng-model=\"vm.pessoa.noPessoa\" placeholder=\"Nome\" required><div ng-messages=\"wizardStep1.nome.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O Nome é obrigatório</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"matricula\" \nng-model=\"vm.pessoa.dsMatricula\" placeholder=\"Matrícula\" required><div ng-messages=\"wizardStep1.matricula.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha a Matrícula.</span></div></div></md-input-container><div \nflex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"email\" \nng-model=\"vm.pessoa.dsEmail\" placeholder=\"Email\" class=\"text-to-lower\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Preencha a Mensalidade.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"50\" \nflex-gt-xs=\"50\"><label>Cargo*</label><md-select ng-model=\"vm.pessoa.cargo\" name=\"id_cargo\"><md-option \nng-repeat=\"cargo in vm.cargos\" value=\"{{cargo.idCargo}}\">{{cargo.noCargo}}</md-option></md-select><div \nng-messages=\"wizardStep1.id_cargo.$error\" role=\"alert\"><div ng-message=\"required\"><span>O cargo é Obrigatória.</span>\n</div></div></md-input-container><div flex=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"usernanme\" ng-model=\"vm.pessoa.username\" placeholder=\"Usuário\" \nng-blur=\"vm.validarUsuarioDuplicado(vm.pessoa.username)\" required><div ng-messages=\"wizardStep1.usernanme.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Preencha o Usuário.</span></div><div ng-show=\"vm.usuarioDuplicado\"><span>\nUsuário já cadastrado.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"50\" flex-gt-xs=\"50\"><label>Perfil*</label><md-select ng-model=\"vm.pessoa.perfil\" \nname=\"id_perfil\" required><md-option ng-repeat=\"perfil in vm.perfis\" value=\"{{perfil.idPerfil}}\">{{perfil.noPerfil}}\n</md-option></md-select><div ng-messages=\"wizardStep1.id_perfil.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Perfil É Obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div><div flex=\"100\" flex-gt-xs=\"50\">\n</div></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><lf-ng-md-file-input \nlf-files=\"vm.foto.noArquivo\" lf-placeholder=\"Foto\" lf-browse-label=\"Selecione\" \nlf-drag-and-drop-label=\"Arraste a Foto, Solte aqui ou Selecione\" accept=\"image/*\" preview progress drag>\n</lf-ng-md-file-input><div ng-messages=\"wizardStep1.noArquivo.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSelecione um Arquivo para o Cardápio</span></div></div></md-input-container></div></form><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.cadastrar();\" \nng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">Salvar</md-button><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"localLoading\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></md-tab-body></md-tab></md-tabs>\n</ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/pessoa/views/pessoa.html","<div id=\"conteudo\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Usuários</div><div \nclass=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Lista os funcionários cadastrados</div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\"><md-button class=\"md-fab\" \naria-label=\"Cadastar Novo Usuário\" ui-sref=\"app.pessoa.add\" style=\"position: absolute; right: 0; margin-right: 16px\">\n<md-icon md-font-icon=\"icon-account-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Adicionar Responsável</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nng-if=\"!localLoading\" dt-columns=\"showCase.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">CPF</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Usuário</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Cargo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Editar</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ativo</span></div></th></tr></thead><tbody><tr ng-repeat=\"pessoa in vm.pessoas\" \nng-init=\"vm.inAtivo[pessoa._embedded[0].idPessoaFisica] = pessoa._embedded[0].inAtivo\"><td mask=\"999.999.999-99\">\n{{pessoa._embedded[0].nuCpf | brCpf}}</td><td>{{pessoa._embedded[0].noPessoa}}</td><td>{{pessoa.username}}</td><td \nclass=\"text-to-lower\">{{pessoa._embedded[0].dsEmail}}</td><td>{{pessoa._embedded[0]._embedded.cargo.noCargo}}</td><td>\n<a ui-sref=\"app.pessoa.edit({idPessoaFisica:pessoa._embedded[0].idPessoaFisica})\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\" title=\"Editar\" aria-label=\"Editar\" \nclass=\"icon s24 ng-scope md-font icon-tooltip-edit material-icons md-default-theme\" aria-hidden=\"true\"></md-icon></a>\n</td><td><a href=\"javascript:void(0)\"><md-switch ng-change=\"vm.desativarOuAtivar(pessoa._embedded[0])\" \nstyle=\"padding-top: 0px;padding-bottom: 0px;margin: 0px\" ng-model=\"vm.inAtivo[pessoa._embedded[0].idPessoaFisica]\" \naria-label=\" \"></md-switch></a></td></tr></tbody></table><div layout=\"row\" layout-align=\"start center\" \nng-if=\"localLoading\"><md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" \nid=\"toolbar-progress-login\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n</div></div></div></div>");
$templateCache.put("app/main/relatorio/views/dashboard-relatorio.html","<div id=\"conteudo\" ng-init=\"vm.pesquisar()\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">\nRelatórios</div><div class=\"pb-16 subtituloGrid\" style=\"padding-left: 10px\">Relatórios Disponíveis</div><div \nclass=\"navigation\" flex layout=\"row\" layout-md=\"row\"><div flex=\"25\" layout=\"column\"><md-button \nclass=\"md-raised md-accent font-menor\" ng-click=\"vm.redirecionar(\'associado-por-nome\')\">Associado por Nome</md-button>\n</div><div flex=\"25\" layout=\"column\"><md-button class=\"md-raised md-accent font-menor\" \nng-click=\"vm.redirecionar(\'associado-por-data\')\">Associado por Dt. Nasc</md-button></div><div flex=\"25\" \nlayout=\"column\"><md-button class=\"md-raised md-accent font-menor\" style=\"min-width: 175px\" \nng-click=\"vm.redirecionar(\'associado-por-matricula\')\">Associado por Matrícula</md-button></div><div flex=\"25\" \nlayout=\"column\"><md-button class=\"md-raised md-accent font-menor\" ng-click=\"vm.redirecionar(\'associado-por-ativos\')\">\nAssociado por Status</md-button></div></div><div class=\"navigation\" flex layout=\"row\" layout-md=\"row\"><div flex=\"25\" \nlayout=\"column\"><md-button class=\"md-raised md-accent font-menor\" \nng-click=\"vm.redirecionar(\'associado-somente-ativos\')\">Associados Ativos</md-button></div></div></div>");
$templateCache.put("app/main/relatorio/views/relatorio-associados.html","<div id=\"conteudo\" ng-init=\"vm.init();\"><div class=\"md-title mt-32 tituloGrid\" style=\"padding: 10px\">\nRelatório de Associados</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" \nng-init=\"vm.listar()\"><div class=\"content\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"loadingTable\">\n<md-progress-circular id=\"default-progress\" class=\"md-accent\" style=\"text-align: center\" md-mode=\"indeterminate\" \nmd-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-gt-xs=\"row\"><div layout=\"column\" flex>\n<md-card style=\"padding-right: 15px;height: 500px\" flex><md-card-content><div class=\"titulo-card\" style=\"padding: 5px\">\nFiltros</div><form class=\"md-inline-form\" novalidate flex-offset=\"3\"><div layout=\"column\" layout-gt-xs=\"row\"><div \nflex=\"5\"></div><md-input-container flex=\"40\"><input type=\"text\" name=\"matriculaAspen\" \nng-model=\"vm.pesquisa.matriculaAsspen\" placeholder=\"Matrícula Asspen\"></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"60\"><input type=\"text\" name=\"nomeAssociado\" ng-model=\"vm.pesquisa.noAssociado\" \nplaceholder=\"Nome do Associado\"></md-input-container><div flex=\"5\"></div></div><div layout=\"column\" layout-gt-xs=\"row\">\n<div flex=\"5\"></div><md-input-container flex=\"60\"><input type=\"text\" name=\"CPF\" ng-model=\"vm.pesquisa.nuCpf\" \nname=\"nuCpf\" mask=\"999.999.999-99\" placeholder=\"CPF\"></md-input-container><div flex=\"5\"></div><md-input-container \nflex=\"70\"><md-select ng-model=\"vm.pesquisa.cargoAssociado\" name=\"cargoAssociado\" placeholder=\"Cargo\"><md-option \nvalue=\"\">--</md-option><md-option ng-repeat=\"cargo in vm.cargoAssociado\" value=\"{{cargo.idCargoAssociado}}\">\n{{ cargo.noCargoAssociado }}</md-option></md-select><div ng-messages=\"wizardStep2.cargoAssociado.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>O Cargo é Obrigatório.</span></div></div></md-input-container><div flex=\"5\"></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"5\"></div><md-input-container flex=\"60\"><md-select \nng-model=\"vm.pesquisa.ativo\" name=\"status\" placeholder=\"Ativo?\"><md-option value=\"\">--</md-option><md-option \nvalue=\"SIM\">Sim</md-option><md-option value=\"NÃO\">Não</md-option></md-select><div \nng-messages=\"wizardStep2.cargoAssociado.$error\" role=\"alert\"><div ng-message=\"required\"><span>O Cargo é Obrigatório.\n</span></div></div></md-input-container><div flex=\"75\"></div></div></form></md-card-content></md-card><md-card>\n<md-card-content><form class=\"md-inline-form\"><div class=\"titulo-card\" style=\"padding: 5px\">Filtros de Datas</div><div \nclass=\"subtitulo-card\" style=\"padding: 5px\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data de Nascimento</div><div layout=\"row\">\n<div flex=\"5\"></div><md-input-container flex=\"30\"><input type=\"text\" name=\"De\" ng-model=\"vm.pesquisa.deNascimento\" \nname=\"nuCpf\" mask=\"99/99/9999\" placeholder=\"De\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"30\">\n<input type=\"text\" name=\"Até\" ng-model=\"vm.pesquisa.ateNascimento\" mask=\"99/99/9999\" placeholder=\"Até\">\n</md-input-container><div flex=\"5\"></div></div><div class=\"subtitulo-card\" style=\"padding: 5px\">\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data de Filiação</div><div layout=\"row\"><div flex=\"5\"></div><md-input-container \nflex=\"30\"><input type=\"text\" name=\"De\" ng-model=\"vm.pesquisa.deFiliacao\" name=\"nuCpf\" mask=\"99/99/9999\" \nplaceholder=\"De\"></md-input-container><div flex=\"5\"></div><md-input-container flex=\"30\"><input type=\"text\" name=\"Até\" \nng-model=\"vm.pesquisa.ateFiliacao\" mask=\"99/99/9999\" placeholder=\"Até\"></md-input-container><div flex=\"5\"></div></div>\n</form></md-card-content></md-card><md-card flex><md-card-content><div class=\"titulo-card\" style=\"padding: 5px\">\nOrdenação</div><form class=\"md-inline-form\" novalidate flex-offset=\"3\"><div layout=\"column\" layout-gt-xs=\"row\"><div \nflex=\"5\"></div><md-input-container flex=\"50\"><md-select ng-model=\"vm.ordencaoSelecionada.campo\" name=\"ordenacao\" \nplaceholder=\"Ordem\"><md-option value=\"\">--</md-option><md-option ng-repeat=\"ordem in vm.ordenacao\" \nvalue=\"{{ordem.campo}}\">{{ ordem.label }}</md-option></md-select></md-input-container><div flex=\"5\"></div>\n<md-input-container flex=\"50\"><md-select ng-model=\"vm.ordencaoSelecionada.tipo\" name=\"tipoOrdenacao\" \nplaceholder=\"Tipo de Ordenação\"><md-option ng-repeat=\"(key, tipo) in vm.tipoOrtenacao\" value=\"{{key}}\">{{ tipo }}\n</md-option></md-select></md-input-container><div flex=\"5\"></div></div></form></md-card-content></md-card></div><div \nlayout=\"column\" flex ng-if=\"!loadingTable\"><md-card flex style=\"height: 200px\"><md-card-content><div \nclass=\"titulo-card\" style=\"padding: 5px\">Convênios</div><div layout=\"column\" class=\"md-inline-form\" \nlayout-gt-xs=\"column\" ng-repeat=\"convenio in vm.convenios\" style=\"padding-left: 5px\"><md-checkbox \nng-model=\"vm.conveniosSelecionados[convenio.idProduto]\" flex=\"30\"><span style=\"white-space: nowrap\">\n{{ convenio.dsProduto | uppercase }}</span></md-checkbox></div></md-card-content></md-card><md-card><div \nclass=\"titulo-card\" style=\"padding: 5px;padding-top: 10px;padding-left: 15px\">Campos presentes no relatório</div>\n<md-card-content layout=\"row\"><div flex><md-checkbox layout=\"column\" ng-repeat=\"(key,campo) in vm.camposFileiraUm\" \nng-model=\"vm.camposSelecionados[key]\"><span style=\"white-space: nowrap\">{{campo.label | uppercase}}</span>\n</md-checkbox></div><div flex><md-checkbox layout=\"column\" ng-repeat=\"(key,campo) in vm.camposFileiraDois\" \nng-model=\"vm.camposSelecionados[key]\"><span style=\"white-space: nowrap\">{{campo.label | uppercase}}</span>\n</md-checkbox></div></md-card-content></md-card></div></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" style=\"padding-top: 50px\"><md-button class=\"md-raised md-accent\" \nng-click=\" vm.emtirRelatorio();\" ng-disabled=\"msWizard.formsIncomplete()\" ng-if=\"!localLoading\">Exibir Relatório\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.limparFiltro()\" ng-disabled=\"msWizard.formsIncomplete()\" \nng-if=\"!localLoading\">Limpar Filtros</md-button><div layout=\"row\" layout-align=\"start center\" ng-if=\"localLoading\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/relatorio/views/relatorio-ativos-inativos.html","<div ng-init=\"vm.getRelatorioOrdenandoAtivosInativos()\" style=\"width: 100%; height: 100%\"><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"left\" \nstyle=\"position: relative;  left: 0px;z-index: 999\"><md-button class=\"md-fab\" aria-label=\"Ficha associado\" \nui-sref=\"app.relatorio\" style=\"position: absolute; left: 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Voltar para relatórios</md-tooltip></md-button></div><object ng-show=\"dataPdf\" \ndata=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/relatorio/views/relatorio-ativos.html","<div ng-init=\"vm.getRelatorioOrdenandoAtivos()\" style=\"width: 100%; height: 100%\"><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"left\" \nstyle=\"position: relative;  left: 0px;z-index: 999\"><md-button class=\"md-fab\" aria-label=\"Dashboard Relatórios\" \nui-sref=\"app.relatorio\" style=\"position: absolute; left: 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Voltar para relatórios</md-tooltip></md-button></div><object ng-show=\"dataPdf\" \ndata=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/relatorio/views/relatorio-por-matricula.html","<div ng-init=\"vm.getRelatorioOrdenandoPorMatricula()\" style=\"width: 100%; height: 100%\"><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"left\" \nstyle=\"position: relative;  left: 0px;z-index: 999\"><md-button class=\"md-fab\" aria-label=\"Ficha associado\" \nui-sref=\"app.relatorio\" style=\"position: absolute; left: 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Voltar para relatórios</md-tooltip></md-button></div><object ng-show=\"dataPdf\" \ndata=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/relatorio/views/relatorio-por-nascimento.html","<div ng-init=\"vm.getRelatorioOrdenandoNascimento()\" style=\"width: 100%; height: 100%\"><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"left\" \nstyle=\"position: relative;  left: 0px;z-index: 999\"><md-button class=\"md-fab\" aria-label=\"Ficha associado\" \nui-sref=\"app.relatorio\" style=\"position: absolute; left: 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Voltar para relatórios</md-tooltip></md-button></div><object ng-show=\"dataPdf\" \ndata=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/relatorio/views/relatorio-por-nome.html","<div ng-init=\"vm.getRelatorioOrdenandoPorNome()\" style=\"width: 100%; height: 100%\"><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" ng-if=\"localLoading\" class=\"\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div><div class=\"left\" \nstyle=\"position: relative;  left: 0px;z-index: 999\"><md-button class=\"md-fab\" aria-label=\"Ficha associado\" \nui-sref=\"app.relatorio\" style=\"position: absolute; left: 0\"><md-icon md-font-icon=\"icon-arrow-left-bold\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Voltar para relatórios</md-tooltip></md-button></div><object ng-show=\"dataPdf\" \ndata=\"{{dataPdf}}\" type=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">Menu</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<md-list><md-subheader class=\"md-no-sticky\"><span>Atualização</span></md-subheader><md-list-item><h2>15/06/2016</h2>\n</md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.VERSAO_ATUAL\">1.0</span></md-subheader><md-list-item><h3 translate=\"FUNCIONALIDADE.RESPONSAVEL\">\nRESPONSAVEL</h3></md-list-item><md-list-item><h3 translate=\"FUNCIONALIDADE.ALUNO\">ALUNO</h3></md-list-item>\n<md-list-item><h3 translate=\"FUNCIONALIDADE.TURMA\">TURMA</h3></md-list-item><md-list-item><h3 \ntranslate=\"FUNCIONALIDADE.CARDAPIO\">CARDÁPIO</h3></md-list-item><md-list-item><h3 translate=\"FUNCIONALIDADE.RECEITAS\">\nRECEITAS</h3></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span>\nData da próxima Versão</span></md-subheader><md-list-item><h2>01/08/2016</h2></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Hoje</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.SOBRE\">Sobre</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>Introdução\n</h3><p>O Escolinha Digital</p></div></md-list-item></md-list><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.AJUDA\">Ajuda</span></md-subheader><md-list-item class=\"md-2-line\" ng-click=\"dummyFunction()\"><div\n class=\"md-list-item-text\"><h3>Manual</h3><p>O manual bla bla bla bla bla...</p></div></md-list-item><md-list-item \nclass=\"md-2-line\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>Chamados</h3><p>\nSe ocorrer alguma erro inesperado ou restar alguma dúvida, abra um chamado par a nossa equipe especializada.</p></div>\n</md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>{{vm.usuarioLogado}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Meus dados\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Sair</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><div><img src=\"logo.png\" \nstyle=\"width: 58px;height: 58px;padding-left: 3px\"></div><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/pagamento/views/boleto/listar.html","<div id=\"conteudo\" ng-init=\"vm.initBoleto();vm.pesquisarDetalhesPendenciasBoleto();\"><div \nclass=\"md-title mt-32 tituloGrid\" style=\"padding-left: 10px\">Associados</div><div class=\"pb-16 subtituloGrid\" \nstyle=\"padding-left: 10px\">Lista de Associados Cadastrados</div><div \nclass=\"content page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.preencherCombosBoleto()\"><form \nname=\"wizardStep1\" class=\"md-inline-form\" novalidate flex-offset=\"3\"><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"padding-left-30\"></div><md-input-container flex=\"10\"><md-select ng-model=\"vm.pesquisa.mesBoleto\" name=\"inAtivo\">\n<md-option ng-repeat=\"mes in vm.mesesBoletos\" value=\"{{mes.valor}}\">{{mes.label}}</md-option></md-select>\n</md-input-container><div flex=\"2\"><md-button class=\"md-fab\" aria-label=\"Listar Telefone\" style=\"\" \nng-click=\"  vm.pesquisarBoleto()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Pesquisar Pagamentos</md-tooltip></md-button></div><div flex=\"60\"></div></div></form>\n</div><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.listar()\">\n<md-button class=\"md-fab\" aria-label=\"Cadastar Pagamento\" ng-click=\"vm.abrirModal($event)\" \nstyle=\"position: absolute; right: 0; margin-right: 16px\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon s24 ng-scope md-font icon-account-plus material-icons md-default-theme right\" aria-hidden=\"true\"></md-icon>\n<md-tooltip md-direction=\"left\">Cadastar Pagamento</md-tooltip></md-button><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-warn-bg\"></span> <span \nclass=\"ms-form-wizard-step-text\">Pagamentos Pendentes</span></span></md-tab-label><md-tab-body><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" style=\"width: 15px\"><div class=\"table-header\">\n<span class=\"column-title\">Matrícula Asspen<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.dsMatricula-ASC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.dsMatricula-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.dsMatricula-DESC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.dsMatricula-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome Associado<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.noPessoa-ASC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.noPessoa-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'pessoaFisica.noPessoa-DESC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'pessoaFisica.noPessoa-DESC\')\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Produto<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'produto.dsProduto-ASC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'produto.dsProduto-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPendente == \'produto.dsProduto-DESC\'}\" \nng-click=\"vm.ordenarBoletoPendente(\'produto.dsProduto-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" style=\"width: 20px\"><span class=\"column-title\" \nstyle=\"padding-left:24px\">Ação</span></div></th></tr></thead><tbody><tr ng-if=\"localLoading\"><td colspan=\"4\"><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></td></tr><tr \nng-repeat=\"(index, detalhe) in vm.resultadoDetalhesPendenciasBoleto._embedded.detalhe_arquivo_pagamento\" \nstyle=\"height: 20px\" ng-init=\"vm.inAtivo[\'pendencia\'][index] = false\" ng-if=\"!localLoading\"><td \nstyle=\"padding: 7px 7px 7px 24px\">{{detalhe.dsMatricula}}</td><td style=\"padding: 7px\">{{detalhe.noPessoa| uppercase}}\n</td><td style=\"padding: 7px\">\n{{detalhe.dsProduto | uppercase}} - {{detalhe.nuDependentes == null ? detalhe.vlProduto : detalhe.vlProduto * (detalhe.nuDependentes+1) | currency:\"R$\":2}}\n</td><td style=\"padding: 7px\" ng-init=\"vm.loadingPagamento[index] = false\"><md-progress-circular \nng-if=\"vm.loadingPagamento[index]\" style=\"padding-left: 24px\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"25\"></md-progress-circular><md-button ng-if=\"!vm.loadingPagamento[index]\" \nclass=\"md-accent flat-btn-grid\" ng-click=\"vm.salvarBoleto(detalhe, index)\">Pagar</md-button></td></tr><tr \nng-if=\"vm.resultadoDetalhesPendenciasBoleto._embedded.detalhe_arquivo_pagamento.length  <= 0 && !localLoading\"><td \ncolspan=\"3\" style=\"text-align: center\">Não há pendências</td></tr><tr><td colspan=\"5\"><div \nclass=\"layout-row layout-align-space-between-center\"><div class=\"layout-row layout-align-start-center\"><span \nstyle=\"padding-right: 8px\">Mostrar</span><md-select style=\"margin: 0px\" ng-model=\"vm.itensPorPaginaBoleto\" \nng-change=\"vm.mudarPageSizePendencia()\" placeholder=\"Itens Por Pagina\" class=\"md-no-underline\"><md-option value=\"10\">10\n</md-option><md-option value=\"20\">20</md-option><md-option value=\"30\">30</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"50\">50</md-option><md-option value=\"100\">100</md-option></md-select><span \nstyle=\"padding-left: 8px\">registros</span></div><div><md-button ng-disabled=\"vm.paginaBoletoPendente <= 1\" \nng-click=\"vm.adicionaPaginaPrendenciaBoleto(-1)\">Anterior</md-button><b>\n{{vm.paginaBoletoPendente}} de {{vm.resultadoDetalhesPendenciasBoleto.page_count}}</b><md-button \nng-disabled=\"vm.paginaBoletoPendente >=  vm.resultadoDetalhesPendenciasBoleto.page_count\" style=\"text-align: right\" \nng-click=\"vm.adicionaPaginaPrendenciaBoleto(1)\">Próximo</md-button></div></div></td></tr></tbody></table></md-tab-body>\n</md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\"></span> <span class=\"ms-form-wizard-step-text\">Pagamentos Efetuados\n</span></span></md-tab-label><md-tab-body><table class=\"dataTable row-border hover\" \nng-init=\"vm.pesquisarDetalhesSucessoBoleto()\"><thead><tr><th class=\"secondary-text\" style=\"width: 15px\"><div \nclass=\"table-header\"><span class=\"column-title\">Matrícula Asspen<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.dsMatricula-ASC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.dsMatricula-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.dsMatricula-DESC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.dsMatricula-DESC\')\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome Associado<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.noPessoa-ASC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.noPessoa-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'pessoaFisica.noPessoa-DESC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'pessoaFisica.noPessoa-DESC\')\" aria-hidden=\"true\"></md-icon></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Produto<md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nstyle=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'produto.dsProduto-ASC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'produto.dsProduto-ASC\')\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"icon ng-scope md-font material-icons md-default-theme right\" \nng-class=\"{\'azul\':  vm.ordenacaoPesquisaPago == \'produto.dsProduto-DESC\'}\" \nng-click=\"vm.ordenarBoletoPago(\'produto.dsProduto-DESC\')\" style=\"font-size: 20px; padding-right: 10px;cursor: pointer\" \naria-hidden=\"true\"></md-icon></span></div></th></tr></thead><tbody><tr ng-if=\"localLoading\"><td colspan=\"4\"><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular \nstyle=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></td></tr><tr \nng-repeat=\"detalhe in vm.resultadoDetalhesBoletoPago._embedded.detalhe_arquivo_pagamento\" \nng-init=\"vm.inAtivo[\'pendencia\'][$index] = false\" ng-if=\"!localLoading\"><td style=\"padding: 7px 7px 7px 24px\">\n{{detalhe.dsMatricula}}</td><td style=\"padding: 7px\">{{detalhe.noPessoa| uppercase}}</td><td style=\"padding: 7px\">\n{{detalhe.dsProduto | uppercase}} - {{detalhe.vlProduto| currency:\"R$\":2}}</td></tr><tr><td colspan=\"5\"><div \nclass=\"layout-row layout-align-space-between-center\"><div class=\"layout-row layout-align-start-center\"><span \nstyle=\"padding-right: 8px\">Mostrar</span><md-select style=\"margin: 0px\" ng-model=\"vm.itensPorPaginaBoletoPago\" \nng-change=\"vm.mudarPageSizeBoleto()\" placeholder=\"Itens Por Pagina\" class=\"md-no-underline\"><md-option value=\"10\">10\n</md-option><md-option value=\"20\">20</md-option><md-option value=\"30\">30</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"50\">50</md-option><md-option value=\"100\">100</md-option></md-select><span \nstyle=\"padding-left: 8px\">registros</span></div><div><md-button ng-disabled=\"vm.paginaBoletoPago <= 1\" \nng-click=\"vm.adicionaPaginaBoletoPago(-1)\">Anterior</md-button><b>\n{{vm.paginaBoletoPago}} de {{vm.resultadoDetalhesBoletoPago.page_count}}</b><md-button \nng-disabled=\"vm.paginaBoletoPago >=  vm.resultadoDetalhesBoletoPago.page_count\" style=\"text-align: right\" \nng-click=\"vm.adicionaPaginaBoletoPago(1)\">Próximo</md-button></div></div></td></tr></tbody></table></md-tab-body>\n</md-tab></md-tabs></ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/pagamento/views/boleto/modal.html","<md-dialog aria-label=\"Adicionar Pagamento\" ng-init=\"vm.init();\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Adicionar Pagamento</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.fecharModal()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.loading == true\">\n<md-progress-circular style=\"margin-left:auto; margin-right:auto; display:block\" id=\"toolbar-progress-login\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div \nng-if=\"vm.loading == false\"><form><div style=\"min-width: 500px\"><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-autocomplete style=\"width: 100%\" required md-selected-item=\"vm.associado\" \nmd-search-text=\"vm.textoAssociadoAutocomplete\" md-items=\"item in vm.pesquisarAutocomplete()\" \nmd-item-text=\"item._embedded.pessoaFisica.noPessoa\" md-min-length=\"4\" placeholder=\"Digite o nome do associado\">\n<md-item-template><span md-highlight-text=\"vm.textoAssociadoAutocomplete\" md-highlight-flags=\"^i\">\n{{item._embedded.pessoaFisica.noPessoa | uppercase}}</span></md-item-template><md-not-found>\nNão encontramos um associado com o nome\"{{vm.textoAssociadoAutocomplete | uppercase }}\".</md-not-found>\n</md-autocomplete><div ng-messages=\"autocompleteForm.autocomplete.$error\"><div ng-message=\"required\">\nSelecione um Associado</div></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><md-select ng-model=\"vm.boletoPagamento.produto\" name=\"produto\" placeholder=\"Convênio*\" required>\n<md-option ng-repeat=\"(key, convenio) in convenios | filter:{\'inProdutoCobrado\': true}\" \nvalue=\"{{convenio.vlProduto+\'||\'+convenio.dsProduto  }}\">{{convenio.dsProduto | uppercase }}</md-option></md-select>\n<div ng-messages=\"wizardStep2.produto.$error\" role=\"alert\"><div ng-message=\"required\"><span>Selecione o convênio</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" mask=\"99/9999\" name=\"mesAno\" ng-model=\"vm.boletoPagamento.mesAno\" \nplaceholder=\"Mês e Ano*\"><div ng-messages=\"wizardStep2.mesAno.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nO Nome Mês e Ano de referência á obrigatório.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" name=\"nuDependentes\" mask=\"9\" \nng-model=\"vm.boletoPagamento.nuDependentes\" ng-init=\"vm.boletoPagamento.nuDependentes=0\" \nplaceholder=\"Quantidade de Dependetes\" required><div ng-messages=\"wizardStep1.nuDependentes.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Preencha o Número de Dependentes.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex style=\"vertical-align: center; margin-left: -10px\"><md-button \nng-click=\"vm.salvarPagamento()\" style=\"padding: 0;margin: 0\" class=\"md-accent\">Salvar</md-button><md-button \nng-click=\"vm.fecharModal()\" style=\"padding: 0\">Cancelar</md-button></div></div></form></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");}]);